<template>
<f7-page :page-content="true" :class="{ 'loading-history': $refs.rform && $refs.rform.loadingHistory }">
  <r-form
    ref="rform"
    :itemId="id"
    @save="onSave"
    :defaultData=" offline ? {iniciado: Utils.getProperty('viene.enac') && Utils.getProperty('viene.enac') == 'true', estado: {estado: 'GENERADO'}, inspectores: [{username: getUsernameLogged(), rol: 'INSPECTOR'}], sesiones: [],sesionesManuales: [], fechaInsp: new Date(), guardadoLocal: new Date(), direccionInspeccion: {provincia: provincia}} : {sesiones: [],sesionesManuales: [], sesionesTPI: []}"
    :readonly="readonly"
    :dbAdapter="offline ? InspeccionOffline : Inspeccion"
    class="page"
    classContent="full-height page-content"
    :beforeSave="beforeSave"
    :required="['codigo']"
    @loadItem="loadItem"
    :documentoAdapter="target == 'cordova' ? DocumentoOffline : Documento"
  >
    <!-- Top Navbar -->
    <template v-slot:before="{ rform }">
      
      <f7-navbar>
        <f7-nav-left>
          <f7-link @click.stop="clickAtras">&lt; {{$t('atras')}}</f7-link>
          <f7-button v-if="!offline" class="btn-historico" icon-f7="square_pencil" @click="rform.getHistory()" :class="{ 'cursor-wait': rform.loadingHistory }"> Ver Histórico </f7-button>
          <f7-button
            v-if="offline && rform.formData.sesionesManuales && rform.formData.sesionesManuales.length == 0 && rform.formData.estado && (rform.formData.estado.estado == 'GENERADO' || rform.formData.estado.estado == 'PLANIFICADO')"
            fill
            color="teal"
            icon-f7="play"
            :disabled="iniciandoSesion"
            @click="comienzaTrabajoManual('iniciado')"
            key="btn-iniciar"
          >Iniciar</f7-button>
          <f7-button
            v-if="offline && rform.formData.sesionesManuales && rform.formData.sesionesManuales.length != 0  && rform.formData.sesionesManuales[rform.formData.sesionesManuales.length - 1].fin != null && rform.formData.estado && (rform.formData.estado.estado == 'GENERADO' || rform.formData.estado.estado == 'PLANIFICADO')"
            fill
            color="teal"
            icon-f7="play"
            :disabled="iniciandoSesion"
            @click="comienzaTrabajoManual('reanudado')"
            key="btn-reanudar"
          >Reanudar</f7-button>
          <f7-button
            v-if="offline  && rform.formData.sesionesManuales && rform.formData.sesionesManuales.length && rform.formData.sesionesManuales[rform.formData.sesionesManuales.length - 1].fin == null && rform.formData.estado && (rform.formData.estado.estado == 'GENERADO' || rform.formData.estado.estado == 'PLANIFICADO')"
            fill
            color="teal"
            icon-f7="pause"
            @click="finalizaTrabajoManual('pausado', true);"
            key="btn-pausar"
          >Pausar</f7-button>
          <f7-button
            v-if="offline && rform.formData.sesionesManuales && rform.formData.sesionesManuales.length && rform.formData.sesionesManuales[rform.formData.sesionesManuales.length - 1].fin == null"
            fill
            color="teal"
            icon-f7="floppy_disk"
            @click="nocalificacionEstadoSesion('finalizado')"
            key="btn-finalizar"
          >Finalizar</f7-button>
        </f7-nav-left>
        <f7-nav-title class="display-flex">
          <f7-button v-if="!offline && rform && rform.formData && (rform.formData.idExpedienteRelacionado || rform.formData.idExpedienteAnteriorNegativo)"
            fill
            small
            icon-f7="chevron_compact_left"
            @click="navigate('/inspecciones/view/' + (rform.formData.idExpedienteRelacionado || rform.formData.idExpedienteAnteriorNegativo) + '/')"
            key="btn-anterior"
          ></f7-button>
          <div style="padding-top:6px;">
            {{(rform.formData.codigo ? rform.formData.codigo : $t('inspecciones.inspeccion_form.inspeccion'))}}
            <f7-icon v-if="rform.formData && rform.formData.tarea" f7="tornado" color="orange" size="20px" style="margin-left:5px;"></f7-icon>
          </div>
          <f7-button v-if="!offline && rform && rform.formData && rform.formData.expedientesSiguientes && rform.formData.expedientesSiguientes.length"
            fill
            small
            icon-f7="chevron_compact_right"
            @click="navigate('/inspecciones/view/' + rform.formData.expedientesSiguientes[0].nombre + '/')"
            key="btn-siguiente"
          ></f7-button>
        </f7-nav-title>
        <f7-nav-right>
          <template slot="right">
            <r-badge v-if="rform.formData.idExpedienteVersion" class="warning-version" color="red" text="Este expediente tiene una versión"></r-badge>
            <r-badge v-if="rform.formData.textoErrorItem && !rform.formData.itemAceptadoCalidad && rform.formData.estado && rform.formData.estado.estado && rform.formData.estado.estado != 'ENVIADO' && rform.formData.estado.estado != 'PDTE_ENVIO'" class="warning-version" color="red" borderColor="yelow" :text="rform.formData.textoErrorItem"></r-badge>
            <r-badge v-if="rform.formData.manual" class="warning-version" color="yellow" text="Este expediente es manual"></r-badge>
            <!-- <f7-button
              v-if="offline && botonEditarVisible"
              fill
              color="green"
              @click="editarOffline"
            >editar</f7-button> -->
            <f7-button
              v-if="offline && !botonEditarVisible && (!readonly || precargaForzada)"
              fill
              color="green"
              @click="guardar()"
            >{{$t('common.guardar')}}</f7-button>
            <f7-button
              v-if="true || rform.formData && rform.formData.estado && rform.formData.estado.estado && getAccionSegunEstado(rform.formData.estado.estado)"
              v-noroles="['ENAC', 'PRODUCCION']"
              fill
              color="orange"
              @click="cumpleReglas"
            >
              {{$t('inspecciones.inspeccion_form.comprobar_reglas')}}
            </f7-button>
            <f7-button
              v-if="!offline && readonly && rform.formData.estado && (rform.formData.estado.estado == 'GENERADO' || rform.formData.estado.estado == 'PLANIFICADO') && !rform.formData.bloqueado"
              v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN','INSPECTOR']}"
              fill
              color="blue"
              @click="syncOnline(rform.formData)"
            >{{$t('inspecciones.inspeccion_form.sync')}}</f7-button>
            <f7-button
              v-if="!offline && botonEditarVisible"
              fill
              color="green"
              @click="comienzaTrabajo"
            >editar</f7-button>
            <f7-button
              v-else-if="!offline && (!readonly || precargaForzada)"
              fill
              color="green"
              @click="guardar()"
            >{{$t('common.guardar')}}</f7-button>
            <div v-if="offline && rform && rform.formData && rform.formData.iniciado" class="menu-item menu-item-dropdown bg-color-primary" >
              <div class="menu-item-content"><i class="f7-icons">ellipsis_vertical</i></div>
              <div class="menu-dropdown menu-dropdown-right bg-color-primary" style="z-index:10">
                <div class="menu-dropdown-content bg-color-primary text-align-right">
                  <div class="menu-dropdown-item menu-close pointer"></div><!-- Se deja una línea vacía porque el componente de tabs se muestra siempre por encima en z.index. Así, la primera opción, queda visible -->
                  <div class="menu-dropdown-item menu-close pointer" 
                    @click="copiarPlantilla(rform.formData)">{{$t('Guardar como plantilla')}}
                  </div>
                  <div class="menu-dropdown-item menu-close pointer" 
                    v-if="!rform.formData.codigo" 
                    @click="popupCargarPlantillaOpened = true">{{$t('Cargar plantilla')}}
                  </div>
                  <div class="menu-dropdown-item menu-close pointer" 
                    @click="cargarListadoHistorico(rform.formData), popupCargarHistoricoOpened = true">{{$t('Cargar Histórico de inspección')}}
                  </div>
                  <div class="menu-dropdown-item menu-close pointer" 
                    v-if="rform.formData.idExpedienteRelacionado" 
                    @click="navigate('/inspecciones/view-offline/' + rform.formData.idExpedienteRelacionado + '/')">{{$t('Ver Expediente de la anterior inspección')}}
                  </div>
                  <div class="menu-dropdown-item menu-close pointer" 
                    v-if="rform.formData.expedientesSiguientes && rform.formData.expedientesSiguientes.length"
                    @click="navigate('/inspecciones/edit-offline/' + rform.formData.expedientesSiguientes[0].nombre + '/')">{{$t('Ver Expediente de la siguiente inspección')}}
                  </div>
                  <div class="menu-dropdown-item menu-close pointer" 
                    v-if="rform.formData.idPedido"
                    @click="rform.formData.guardadoSilencioso = true;rform.saveItem();navigate('/pedidos/documentos/' + rform.formData.idPedido + '/')">{{$t('Ver documentación del pedido')}}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!offline" class="menu-item menu-item-dropdown bg-color-primary">
              <div class="menu-item-content"><i class="f7-icons">ellipsis_vertical</i></div>
              <div class="menu-dropdown menu-dropdown-right bg-color-primary" style="z-index:10">
                <div class="menu-dropdown-content bg-color-primary text-align-right">
                  <div class="menu-dropdown-item menu-close pointer"></div><!-- Se deja una línea vacía porque el componente de tabs se muestra siempre por encima en z.index. Así, la primera opción, queda visible -->
                  <div class="menu-dropdown-item menu-close pointer" v-if="certificadoDescargable(rform.formData)" @click="descargarCertificado(rform.formData)">{{$t('inspecciones.inspeccion_form.descargarCertificado')}}</div>
                  <div class="menu-dropdown-item menu-close pointer" v-if="certificadoDescargable(rform.formData) && Utils.getUser() && Utils.getUser().username == 'SIMECAL'" @click="descargarCertificado(rform.formData, true)" v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN']}">{{$t('inspecciones.inspeccion_form.descargarCertificadoBETA')}}</div>
                  <div class="menu-dropdown-item menu-close pointer" v-if="true" @click="descargarHojaDatos(rform.formData, false)">{{$t('inspecciones.inspeccion_form.descargarHojaDatos')}}</div>
                  <div class="menu-dropdown-item menu-close pointer item-enriquecido-beta"
                    v-if="rform.formData && rform.formData.codigo"
                    v-roles="{route: $f7route.url, roles: ['ADMIN']}"
                    @click="abrirGenerarItemEnriquecido(rform.formData)"
                  >🧪 Generar item enriquecido <span class="item-enriquecido-beta-tag">beta</span></div>
                  <div class="menu-dropdown-divider" v-if="datosDescargables(rform.formData)"></div>
                  <div class="menu-dropdown-item menu-close pointer" 
                    v-if="(((readonly && rform.formData && rform.formData.estado && (rform.formData.estado.estado == 'INSPECCIONADO' || rform.formData.estado.estado == 'GENERADO' || rform.formData.estado.estado == 'PLANIFICADO') && !rform.formData.bloqueado) || (readonly && rform.formData.manual)) && !(offline && rform.formData.estado && (rform.formData.estado.estado == 'GENERADO' || rform.formData.estado.estado == 'PLANIFICADO')))"
                    v-roles="{route: $f7route.url, roles: ['INSPECTOR']}"
                    @click="readonly=false; iniciaSesion(rform.formData); inicializarPrecargas(); "
                  >{{$t('common.editar')}}</div>
                  <div class="menu-dropdown-item menu-close pointer" 
                    v-else-if="((readonly && rform.formData && !rform.formData.bloqueado) || (readonly && rform.formData && rform.formData.manual)) && !(offline && rform.formData.estado && (rform.formData.estado.estado == 'GENERADO' || rform.formData.estado.estado == 'PLANIFICADO'))"
                    v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN']}"
                    @click="readonly=false;iniciaSesion(rform.formData); "
                  >{{$t('common.editar')}}</div>
                  <div 
                    v-if="(readonly && rform.formData && !rform.formData.bloqueado)" 
                    class="menu-dropdown-item menu-close pointer arreglarDocumentos" 
                    v-roles="{route: $f7route.url, roles: ['ADMIN']}"
                    @click="arreglarDocumentos()"
                  >Arreglar documentos</div>
                  <div class="menu-dropdown-item menu-close pointer AsignarFormato" 
                    v-if="!readonly && !offline && rform.formData" 
                    v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN','INSPECTOR']}"
                    @click="openPopupAsignarFormato"
                  >Asignar formato</div>
                  <div v-if="rform.formData && rform.formData.formato" class="menu-dropdown-item menu-close pointer forzarPrecargas" 
                    v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN']}"
                    @click="readonly=false; inicializarPrecargas(true);"
                  >{{$t('inspecciones.inspeccion_form.forzarPrecargas')}}</div>
                  <div class="menu-dropdown-item menu-close pointer cambiaEstado-INSPECCIONADO" 
                    v-if="rform && rform.formData && rform.formData.estado && rform.formData.estado.estado == 'PLANIFICADO' && rform.formData.idExpedienteRelacionado"
                    v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN','INSPECTOR']}"
                    @click="cambiaEstado('INSPECCIONADO', 'Expediente de segundas ya inspeccionado')"
                  >{{$t('inspecciones.inspeccion_form.ya_inspeccionado')}}</div>
                  <div class="menu-dropdown-item menu-close pointer" v-if="!readonly && !offline" @click="cancelarEdicion()" v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN','INSPECTOR']}">{{$t('common.cancelar')}}</div>
                  <div class="menu-dropdown-divider" v-if="datosDescargables(rform.formData)"></div>
  
  
                  <div class="menu-dropdown-item menu-close pointer" v-if="rform.formData && rform.formData.estado && rform.formData.estado.estado == 'INSPECCIONADO' && readonly" v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN','INSPECTOR']}" @click="finalizar()">{{$t('inspecciones.inspeccion_form.finalizar')}}</div>
                  <div class="menu-dropdown-item menu-close pointer" v-if="rform.formData && rform.formData.estado && rform.formData.estado.estado == 'CORREGIR_ERRORES_AUDITORIA_CALIDAD' && readonly" v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN','INSPECTOR']}" @click="finalizar()">{{$t('inspecciones.inspeccion_form.errorescorregidos')}}</div>
                  
                  
                  <div class="menu-dropdown-item menu-close pointer" v-if="rform.formData && rform.formData.erroresAuditoria && rform.formData.erroresAuditoria.length > 0" 
                    @click="popupReadOnly = true;$set($refs.rformErrores.formData, 'erroresAuditoria', rform.formData.erroresAuditoria);$refs.popupErrores.open()" 
                    popup-open=".popupErrores"
                    v-noroles="['ENAC', 'PRODUCCION']"
                    >{{$t('inspecciones.inspeccion_form.resultadosAuditoria')}}</div>
                  <div class="menu-dropdown-item menu-close pointer" 
                    v-if="rform.formData && rform.formData.estado && rform.formData.estado.estado == 'PENDIENTE_REVISION_CALIDAD'" 
                    v-roles="{route: $f7route.url, roles: ['DTYCAL']}"
                    @click="popupReadOnly = false;$set($refs.rformErrores.formData, 'erroresAuditoria', []);$refs.popupErrores.open()" 
                    popup-open=".popupErrores"
                  >{{$t('inspecciones.inspeccion_form.auditoria')}}</div>
                  <div class="menu-dropdown-item menu-close pointer" v-if="rform.formData && rform.formData.estado && (rform.formData.estado.estado == 'PDTE_CONFORMIDAD' || rform.formData.estado.estado == 'FIRMADO_INSPECTOR')"
                    v-roles="{route: $f7route.url, roles: ['DTYCAL']}"
                    @click="cambiaEstado('PDTE_ENVIO', 'Aprobado por calidad para iniciar el proceso de entrega')"
                  >{{$t('inspecciones.inspeccion_form.aprobadoenvio')}}</div>
                  <div class="menu-dropdown-item menu-close pointer" v-if="rform.formData && rform.formData.estado && rform.formData.estado.estado == 'PENDIENTE_FIRMA_INSPECTOR'" v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN','INSPECTOR','FVYFP']}" @click="abrirPopupCertificado(false)">{{$t('inspecciones.inspeccion_form.adjuntadocumentosinfirma')}}</div>
                  <div class="menu-dropdown-item menu-close pointer" v-if="rform.formData && rform.formData.estado && rform.formData.estado.estado == 'PENDIENTE_FIRMA_INSPECTOR'" v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN','INSPECTOR','FVYFP']}" @click="abrirPopupCertificado(true)">{{$t('inspecciones.inspeccion_form.adjuntadocumentofirmado')}}</div>
                  <!-- <div class="menu-dropdown-item menu-close pointer" v-if="rform.formData && rform.formData.estado && rform.formData.estado.estado == 'PENDIENTE_FIRMA_INSPECTOR' && !rform.formData.manual" v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN','INSPECTOR','FVYFP']}" @click="firmarInspector(rform.formData)">{{$t('inspecciones.inspeccion_form.firmainspector')}}</div> -->
                  <div class="menu-dropdown-item menu-close pointer" v-if="rform.formData && rform.formData.estado && rform.formData.estado.estado == 'PENDIENTE_FIRMA_INSPECTOR' && (!rform.formData.manual || (rform.formData.manual && rform.formData.adjuntadoSinFirma))" v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN','INSPECTOR','FVYFP']}" @click="abrirAutoFirma(rform.formData)">{{$t('inspecciones.inspeccion_form.autofirma')}}</div>
                  <div class="menu-dropdown-item menu-close pointer" v-if="rform.formData && rform.formData.estado && rform.formData.estado.estado == 'PENDIENTE_FIRMA_INSPECTOR' && rform.formData.urlFirma" v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN','INSPECTOR','FVYFP']}" @click="refreshEnvio(rform.formData)">{{$t('inspecciones.inspeccion_form.refreshEnvio')}}</div>
                  
                  <div class="menu-dropdown-divider" v-if="rform && rform.formData && rform.formData.estado && rform.formData.estado.estado == 'FIRMADO_INSPECTOR' " ></div>
  
                  <div class="menu-dropdown-divider" v-if="rform.formData && rform.formData.estado && (rform.formData.idExpedienteRelacionado || (rform.formData.expedientesSiguientes && rform.formData.expedientesSiguientes.length))"></div>
                  <div class="menu-dropdown-item menu-close pointer" 
                    v-if="rform && rform.formData && rform.formData.idExpedienteRelacionado" 
                    @click="navigate('/inspecciones/view/' + rform.formData.idExpedienteRelacionado + '/')"
                  >{{$t('Ver Expediente de la anterior inspección')}}</div>
                  <div class="menu-dropdown-item menu-close pointer" 
                    v-if="rform && rform.formData && rform.formData.idExpedienteAnteriorNegativo" 
                    @click="navigate('/inspecciones/view/' + rform.formData.idExpedienteAnteriorNegativo + '/')"
                  >{{$t('Ver Expediente de la anterior inspección')}}</div>
                  <div class="menu-dropdown-item menu-close pointer" 
                    v-if="rform && rform.formData && rform.formData.expedientesSiguientes && rform.formData.expedientesSiguientes.length"
                    @click="navigate('/inspecciones/view/' + rform.formData.expedientesSiguientes[0].nombre + '/')"
                  >{{$t('Ver Expediente de la siguiente inspección')}}</div>
                  <div class="menu-dropdown-item menu-close pointer" 
                    v-if="rform && rform.formData && rform.formData.idExpedienteNuevaPrimera"
                    @click="navigate('/inspecciones/view/' + rform.formData.idExpedienteNuevaPrimera + '/')"
                  >{{$t('Ver Expediente de la siguiente inspección')}}</div>
  
                  <div class="menu-dropdown-divider" v-if="rform && rform.formData && !rform.formData.idExpedienteVersion && !rform.formData.codigoExpedienteVersion && rform.formData.estado && rform.formData.estado.estado == 'ENVIADO'"></div>
                  <div class="menu-dropdown-item menu-close pointer" 
                    v-if="rform && rform.formData && !rform.formData.idExpedienteVersion && !rform.formData.codigoExpedienteVersion && rform.formData.estado && rform.formData.estado.estado == 'ENVIADO' && !rform.formData.manual"
                    @click="versionar(rform.formData)"
                  >{{$t('Versionar')}}</div>
                  <template v-roles="{route: $f7route.url, roles: ['DTYCAL']}">
                    <div v-if="rform && rform.formData && rform.formData.estado && rform.formData.estado.estado != 'ENVIADO' && rform.formData.estado.estado != 'PLANIFICADO' && rform.formData.estado.estado != 'INSPECCIONADO'" class="menu-dropdown-divider"></div>
                    <div 
                      v-if="rform && rform.formData && rform.formData.estado && rform.formData.estado.estado && !['GENERADO', 'PLANIFICADO', 'INSPECCIONADO'].includes(rform.formData.estado.estado)"
                      class="menu-dropdown-item menu-close pointer" 
                      v-roles="{route: $f7route.url, roles: ['DTYCAL']}"
                      @click="cambiaEstado('INSPECCIONADO', 'Vuelve a edición')"
                    >{{$t('Volver a edición')}}</div>
                  </template>
  
                  <div v-if="rform.formData && (rform.formData.idExpedienteVersion || rform.formData.idExpedienteOriginal )" class="menu-dropdown-divider"></div>
                  <div class="menu-dropdown-item menu-close pointer" 
                    v-if="rform && rform.formData && rform.formData.idExpedienteVersion" 
                    @click="navigate(('/inspecciones/view/' + rform.formData.idExpedienteVersion + '/'))"
                  >{{$t('Ver Expediente de la versión siguiente')}}</div>
                  <div class="menu-dropdown-item menu-close pointer" 
                    v-if="rform && rform.formData && rform.formData.idExpedienteOriginal"
                    @click="navigate(('/inspecciones/view/' + rform.formData.idExpedienteOriginal + '/'))"
                  >{{$t('Ver Expediente de la versión anterior')}}</div>
                  <div v-if="rform.formData && rform.formData.idPedido" class="menu-dropdown-divider"></div>
                  <div 
                    v-if="rform && rform.formData && rform.formData.idPedido"
                    class="menu-dropdown-item menu-close pointer" 
                    @click="navigate('/pedidos/view/' + rform.formData.idPedido + '/')"
                  >{{$t('Ver Pedido')}}</div>
                  <div v-noroles="['ENAC', 'PRODUCCION']" v-if="rform.formData" class="menu-dropdown-divider"></div>
                  <!-- Botones de auditoría -->
                  <span 
                    v-if="rform.formData && rform.formData.estado && Inspeccion.orden(rform.formData.estado.estado) >= Inspeccion.orden('INSPECCIONADO') && Inspeccion.orden(rform.formData.estado.estado) < Inspeccion.orden('ENVIADO')" class="menu-dropdown-divider"
                    v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN']}"
                  >
                    <div 
                      v-if="estadoAuditoria() == 'SIN_INICIAR'"
                      class="menu-dropdown-item menu-close pointer" 
                      style="background-color: #5cb85c; color: blue;"
                      @click="iniciarAuditoria(rform.formData)"
                    ><span><f7-icon f7="tornado" color="orange" style="margin-right:2px;"></f7-icon>{{$t('Iniciar Auditoría')}}</span></div>
                    
                    <div 
                      v-if="estadoAuditoria() == 'SESION_ABIERTA'"
                      class="menu-dropdown-item menu-close pointer" 
                      style="background-color: #f0ad4e; color: blue;"
                      @click="pausarAuditoria(rform.formData)"
                    ><span><f7-icon f7="tornado" color="blue" style="margin-right:2px;"></f7-icon>{{$t('Pausar Auditoría')}}</span></div>
                    
                    <div 
                      v-if="estadoAuditoria() == 'SESION_CERRADA'"
                      class="menu-dropdown-item menu-close pointer" 
                      style="background-color: #f0ad4e; color: blue;"
                      @click="reiniciarAuditoria(rform.formData)"
                    ><span><f7-icon f7="tornado" color="blue" style="margin-right:2px;"></f7-icon>{{$t('Reiniciar Auditoría')}}</span></div>
                    
                    <div 
                      v-if="estadoAuditoria() == 'SESION_ABIERTA'"
                      class="menu-dropdown-item menu-close pointer" 
                      style="background-color: #5cb85c; color: blue;"
                      @click="finalizarAuditoria(rform.formData)"
                    ><span><f7-icon f7="tornado" color="red" style="margin-right:2px;"></f7-icon>{{$t('Finalizar Auditoría')}}</span></div>
                    
                    <div 
                      v-if="estadoAuditoria() !== 'SIN_INICIAR'"
                      class="menu-dropdown-item menu-close pointer" 
                      style="background-color: #d9534f; color: blue;"
                      @click="cancelarAuditoria(rform.formData)"
                    ><span><f7-icon f7="tornado" color="green" style="margin-right:2px;"></f7-icon>{{$t('Cancelar Auditoría')}}</span></div>
                    
                    <div
                      v-if="rform && rform.formData"
                      class="menu-dropdown-item menu-close pointer"
                      style="background-color: #f0ad4e; color: black;"
                      @click="registrarTareaAuditoria(rform.formData)"
                      v-noroles="['ENAC', 'PRODUCCION']"
                    >{{$t('Registrar Tarea de auditoría (manual)')}}</div>
                    <div class="menu-dropdown-divider"></div>
                  </span>
                  <!-- Botones de análisis de incompatibilidad (US #134) -->
                  <span
                    v-if="rform.formData && rform.formData.textoErrorItem && rform.formData.itemAceptadoCalidad === false"
                    v-roles="{route: $f7route.url, roles: ['DTYCAL']}"
                  >
                    <div
                      v-if="estadoTareaIncompatibilidad() == 'SIN_INICIAR'"
                      class="menu-dropdown-item menu-close pointer"
                      style="background-color: #5cb85c; color: blue;"
                      @click="iniciarEstudioIncompatibilidad(rform.formData)"
                    ><span><f7-icon f7="exclamationmark_octagon" color="red" style="margin-right:2px;"></f7-icon>{{$t('Iniciar Estudio de Incompatibilidad')}}</span></div>

                    <div
                      v-if="estadoTareaIncompatibilidad() == 'SESION_ABIERTA'"
                      class="menu-dropdown-item menu-close pointer"
                      style="background-color: #f0ad4e; color: blue;"
                      @click="pausarEstudioIncompatibilidad(rform.formData)"
                    ><span><f7-icon f7="exclamationmark_octagon" color="blue" style="margin-right:2px;"></f7-icon>{{$t('Pausar Estudio de Incompatibilidad')}}</span></div>

                    <div
                      v-if="estadoTareaIncompatibilidad() == 'SESION_CERRADA'"
                      class="menu-dropdown-item menu-close pointer"
                      style="background-color: #f0ad4e; color: blue;"
                      @click="reiniciarEstudioIncompatibilidad(rform.formData)"
                    ><span><f7-icon f7="exclamationmark_octagon" color="blue" style="margin-right:2px;"></f7-icon>{{$t('Reanudar Estudio de Incompatibilidad')}}</span></div>

                    <div
                      v-if="estadoTareaIncompatibilidad() == 'SESION_ABIERTA'"
                      class="menu-dropdown-item menu-close pointer"
                      style="background-color: #5cb85c; color: blue;"
                      @click="finalizarEstudioIncompatibilidad(rform.formData)"
                    ><span><f7-icon f7="exclamationmark_octagon" color="red" style="margin-right:2px;"></f7-icon>{{$t('Finalizar Estudio de Incompatibilidad')}}</span></div>

                    <div
                      v-if="estadoTareaIncompatibilidad() !== 'SIN_INICIAR'"
                      class="menu-dropdown-item menu-close pointer"
                      style="background-color: #d9534f; color: blue;"
                      @click="cancelarEstudioIncompatibilidad(rform.formData)"
                    ><span><f7-icon f7="exclamationmark_octagon" color="green" style="margin-right:2px;"></f7-icon>{{$t('Cancelar Estudio de Incompatibilidad')}}</span></div>
                    <div class="menu-dropdown-divider"></div>
                  </span>
                  <div
                    v-if="rform && rform.formData"
                    class="menu-dropdown-item menu-close pointer"
                    @click="verTareas(rform.formData)"
                    v-noroles="['ENAC', 'PRODUCCION']"
                  >{{$t('Ver Tareas')}}</div>
                  <div v-noroles="['ENAC', 'PRODUCCION']" v-if="rform.formData" class="menu-dropdown-divider"></div>
                  <div class="menu-dropdown-divider" 
                    v-if="rform.formData && ( !rform.formData.expedientesSiguientes || !rform.formData.expedientesSiguientes.length) && '|NEGATIVO|DESFAVORABLE|FAVORABLE_CON_DEFECTOS|'.includes('|'+rform.formData.calificacion+'|') && readonly "
                  ></div>
                  <div class="menu-dropdown-item menu-close pointer"
                    v-if="rform.formData && ( !rform.formData.expedientesSiguientes || !rform.formData.expedientesSiguientes.length)  && (('|DESFAVORABLE|FAVORABLE_CON_DEFECTOS|'.includes('|'+rform.formData.calificacion+'|') && hayExpedientesAnteriores)||('|NEGATIVO|'.includes('|'+rform.formData.calificacion+'|') && !hayExpedientesAnteriores)) && readonly && !rform.formData.manual"
                    @click="crearExpedienteSegundas(rform.formData)"
                  >{{$t('Crear Expediente de Segundas')}}</div>
                  <div v-if="rform.formData &&  rform.formData.estado && rform.formData.estado.estado == 'INSPECCIONADO' && readonly && !rform.formData.manual" 
                    class="menu-dropdown-divider" v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN']}"></div>
                  <div
                    v-if="rform.formData &&  rform.formData.estado && (rform.formData.estado.estado == 'INSPECCIONADO' || rform.formData.estado.estado == 'PLANIFICADO') && readonly && !rform.formData.manual"
                    class="menu-dropdown-item menu-close pointer" 
                    v-roles="{route: $f7route.url, roles: ['DTYCAL','ADMIN']}"
                    @click="regenerarCodigoExpediente()"
                  >{{$t('Regenerar Código Expediente')}}</div>
                </div>
              </div>
            </div>
          </template>
        </f7-nav-right>
        <f7-subnavbar>
          <f7-segmented raised class="elevation-6">
            <f7-button fill tab-link="#tab-cliente" @click="tabActive = 'Cliente'">Cliente</f7-button>
            <f7-button v-if="rform.formData && rform.formData.idExpedienteAnteriorNegativo" ref="tabExpediente" fill tab-link="#tab-expediente" @click="tabActive = 'Expediente'" tab-link-active icon-material="looks_one" >Expediente</f7-button>
            <f7-button v-else-if="rform.formData && rform.formData.idExpedienteRelacionado" ref="tabExpediente" fill tab-link="#tab-expediente" @click="tabActive = 'Expediente'" tab-link-active icon-material="looks_two" >Expediente</f7-button>
            <f7-button v-else ref="tabExpediente" fill tab-link="#tab-expediente" @click="tabActive = 'Expediente'"  tab-link-active>Expediente</f7-button>
            
            <f7-button fill tab-link="#tab-instalacion" @click="tabActive = 'Instalacion'; rellenarCaracteristicasDefecto()">
              {{$t('items.instalacion')}}
              <f7-icon v-if="rform.formData && (!rform.formData.caracteristicas || !rform.formData.caracteristicas.length)" f7="exclamationmark_triangle_fill" color="yellow" style="top:0;"></f7-icon>
            </f7-button>
            <f7-button fill tab-link="#tab-tomadedatos" @click="tabActive = 'TomaDatos'; inicializarPrecargas()">
              {{$t('Toma de datos')}}
              <f7-icon v-if="rform.formData && (!rform.formData.comprobaciones || !rform.formData.comprobaciones.length)" f7="exclamationmark_triangle_fill" color="yellow" style="top:0;"></f7-icon>
            </f7-button>
          </f7-segmented>
        </f7-subnavbar>
      </f7-navbar>
      <f7-toolbar :position="'bottom'" 
        :class="{
          'bg-color-gray': !rform.formData.calificacion, 
          'bg-color-green': rform.formData.calificacion == 'FAVORABLE',
          'bg-color-lime': rform.formData.calificacion == 'FAVORABLE_CON_DEFECTOS' || rform.formData.calificacion == 'FAVORABLE_CON_REPARO',
          'bg-color-orange': rform.formData.calificacion == 'DESFAVORABLE',
          'bg-color-red': rform.formData.calificacion == 'NEGATIVO'
        }">
        <div class="list" style="z-index: 10; width: 100%;" :class="{disabled: offline && !rform.formData.iniciado && !readonly}">
          <ul style="background: transparent;display: inline-flex;">
            <r-autocomplete-m2m
              class="calificacion"
              inline-label
              outline
              :label="$t('inspecciones.inspeccion_form.calificacion') + ':'"
              :form="rform"
              name="calificacion"
              idProp="id"
              labelProp="nombre"
              :multiple="false"
              :disabled="readonly"
              @change="onChangeCalificacion"
              :dbItems="[
                {id: 'FAVORABLE', nombre:'Favorable'},
                {id: 'FAVORABLE_CON_DEFECTOS', nombre:'Favorable con Defectos'},
                {id: 'FAVORABLE_CON_REPARO', nombre:'Favorable con Reparo (reiteración defecto leve)'},
                {id: 'DESFAVORABLE', nombre:'Condicionada'},
                {id: 'NEGATIVO', nombre:'Negativa'}
              ]"
            ></r-autocomplete-m2m>
            <f7-list-item v-if="!readonly && rform.formData.formato && rform.formData.formato.mostrarCalcular">
              <f7-button 
                slot="after" 
                fill
                small
                color="blue"
                icon-f7="function" 
                @click="calcularCalificacion(rform)"
                tooltip="Calcular calificación según normativa BOE"
                style="align-content: center;margin-left: 10px;height: 30px;position: relative;left: -50px;"
              ></f7-button>
            </f7-list-item>
          </ul>
        </div>
      </f7-toolbar>
    </template>

    <!-- Tabs -->
    <template v-slot:default="{ rform }">
      <div class="full-height" :class="{disabled: offline && !rform.formData.iniciado && !readonly}">
        <f7-tabs class="full-height">
          <f7-tab id="tab-cliente" class="page-content">
            <f7-block-title medium>Cliente</f7-block-title>
            <!-- Cliente -->
            <div class="list" style="z-index: 11" v-if="tabActive == 'Cliente'">
              <f7-row>
                <ul style="width: 80%">
                  <r-autocomplete
                    outline
                    class="bordeAzul"
                    v-if="!rform.formData.idPedido"
                    ref="cliente"
                    :dbAdapter="offline ? ClienteOffline : Cliente"
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.cliente')"
                    :form="rform"
                    name="cliente"
                    :labelProp="offline ? 'razonSocial' : 'codigoNombre'"
                    :minLength="target == 'web' && offline ? 0 : 3"
                    :readonly="readonly"
                    :shownFields="['nif']"
                    :async="(target == 'web' && offline) ? false : true"
                  >
                    <f7-link
                      v-if="(!rform.formData.cliente || !rform.formData.cliente.razonSocial) && !readonly && offline"
                      slot="inner-end"
                      popup-open=".popup-nuevo-cliente"
                      class="input-suffix-btn"
                      icon-f7="plus_app_fill"
                    ></f7-link>
                  </r-autocomplete>
                  <f7-list-input
                    v-else
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.cliente')"
                    :value="
                      rform.formData.cliente ? rform.formData.cliente.razonSocial : ''
                    "
                    autocomplete="off"
                    :readonly="true"
                  >
                  </f7-list-input>
                </ul>
                <ul style="width: 20%"> 
                  <r-input
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.nif')"
                    :form="rform"
                    name="cliente.nif"
                    :readonly="true"
                  >
                  </r-input>
                </ul>
              </f7-row>
            </div>
            <f7-block-title medium>Dirección Inspección</f7-block-title>
            <div class="list" style="z-index: 10;">
              <ul>
                <r-direccion
                  class="outlineAzul"
                  :form="rform"
                  name="direccionInspeccion"
                  :guardarCodigos="true"
                  :offline="offline"
                  :readonlyFields="['provincia']"
                ></r-direccion>
              </ul>
            </div>
            <f7-block-title>{{ $t('Titular') }}</f7-block-title>
            <div class="list">
              <ul class="row">
                <r-input
                  class="col-50 medium-50"
                  floating-label
                  :label="$t('clientes.nif')"
                  :form="rform"
                  :name="'nifTitular'"
                ></r-input>
                <r-input
                  class="col-50 medium-50"
                  floating-label
                  :label="$t('ofertas.titular')"
                  :form="rform"
                  :name="'titular'"
                ></r-input>
              </ul>
            </div>
            <f7-block-title>{{$t('Contacto')}}</f7-block-title>
            <div class="list">
              <ul class="row">
                <r-input
                  class="col-100 medium-100"
                  floating-label
                  :label="$t('Persona de contacto para la inspección')"
                  :form="rform"
                  :name="'contacto'"
                ></r-input>
                <r-input
                  class="col-100 medium-100"
                  floating-label
                  :label="$t('Teléfono 1')"
                  :form="rform"
                  :name="'telefono1'"
                ></r-input>
                <r-input
                  class="col-100 medium-100"
                  floating-label
                  :label="$t('Teléfono 2')"
                  :form="rform"
                  :name="'telefono2'"
                ></r-input>
                <r-input
                  class="col-100 medium-100"
                  floating-label
                  :label="$t('El titular ha comunicado que quiere presenciar la inspección')"
                  :form="rform"
                  type="check" 
                  :name="'titularPresencial'"
                ></r-input>
              </ul>
            </div>
          </f7-tab>
          <f7-tab id="tab-expediente" class="page-content" tab-active>
            <f7-list v-if="tabActive == 'Expediente'">
              <ul>
                <r-input
                  floating-label
                  :label="$t('inspecciones.inspeccion_form.codigo')"
                  :form="rform"
                  type="text"
                  name="codigo"
                  :readonly="true"
                ></r-input>
                <!-- v-if="rform.formData.codigoExpedienteAnterior" -->
                <r-input
                  floating-label
                  :label="$t('inspecciones.inspeccion_form.codigoExpAnterior')"
                  :form="rform"
                  type="text"
                  name="codigoExpedienteAnterior"
                  :readonly="true"
                ></r-input>
                <f7-list-input
                  :label="$t('inspecciones.inspeccion_form.codigoExpSiguiente')"
                  v-if="rform.formData && rform.formData.expedientesSiguientes && rform.formData.expedientesSiguientes.length"
                  :value="rform.formData.expedientesSiguientes[0].valor"
                  autocomplete="no"
                  :readonly="true"
                  v-tooltip="rform.formData.expedientesSiguientes[0].valor"
                  type="text"
                >
                </f7-list-input>
                <div class="col-100" style="position:relative;">
                  <r-input
                    class="col-100"
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.formato')"
                    :form="rform"
                    type="text"
                    :readonly="true"
                    name="formato.codigo"
                  ></r-input>
                  <a
                    v-if="rform.formData && rform.formData.formato && rform.formData.formato.id"
                    :href="urlVerFormato(rform.formData.formato.id)"
                    target="_blank"
                    rel="noopener"
                    class="external"
                    v-tooltip="'Abrir formato ' + (rform.formData.formato.codigo || '') + ' en nueva pestaña'"
                    style="position:absolute;right:10px;top:50%;transform:translateY(-50%);text-decoration:none;cursor:pointer;z-index:10;"
                  ><i class="f7-icons" style="font-size:16px;color:#1565c0;">arrow_up_right_square</i></a>
                </div>
                <!-- Inspectores -->
                <f7-block-title class="col-100" v-if="rform && rform.formData" style="z-index: 30">
                  {{$t('inspecciones.inspeccion_form.inspectores')}}
                  <f7-link
                    @click="rform.formData.inspectores?rform.formData.inspectores.push({rol: 'INSPECTOR'}):$set(rform.formData,'inspectores',[{rol: 'INSPECTOR'}])"
                  >{{$t('inspecciones.inspeccion_form.add')}}</f7-link>
                </f7-block-title>

                <div v-if="rform && rform.formData" style="z-index: 50" class="col-100">
                  <f7-card
                    class="elevation-3 padding-vertical-half padding-right"
                    v-for="(item,index) in rform.formData.inspectores"
                    :key="'inspectores-'+index"
                    :style="'z-index:'+(rform.formData.inspectores.length - index)"
                  >
                    <f7-card-content>
                      <f7-list class="list-form">
                        <ul class="no-margin no-padding">
                          <f7-row no-gap>
                            <r-autocomplete
                              :dbAdapter="offline ? InspectorOffline : Inspector"
                              class="col-100 medium-50"
                              floating-label
                              :label="$t('inspecciones.inspeccion_form.inspector')"
                              :form="rform"
                              :name="'inspectores.' + index + '.username'"
                              labelProp="nombre"
                              :filter="offline ? null : {filter:{rol:'INSPECTOR'}}"
                              :readonly="readonly"
                              :shownFields="['oficina', 'nombre', 'email', 'firma']"
                              idProp="username"
                              idFieldDetail="id"
                              prefixProp="username"
                              @change="onChangeInspector(index, $event)"
                            ></r-autocomplete>
                            <r-input
                              class="col-100 medium-50"
                              floating-label
                              :label="$t('inspecciones.inspeccion_form.rol')"
                              :form="rform"
                              type="select"
                              :readonly="readonly"
                              :name="'inspectores.' + index + '.rol'"
                            >
                              <option value="INSPECTOR">{{$t('pedidos.inspector')}}</option>
                              <option value="SUPERVISADO">{{$t('pedidos.inspectorSupervisado')}}</option>
                              <option value="OBSERVADOR">{{$t('pedidos.observador')}}</option>
                              <option value="SUPERVISOR">{{$t('pedidos.supervisor')}}</option>
                              <option value="SUPERVISADO_FORMACION">{{$t('pedidos.supervisadoFormacion')}}</option>
                            </r-input>
                            <!-- <r-autocomplete
                              outline
                              floating-label
                              :dbAdapter="null"
                              :label="$t('inspecciones.inspeccion_form.rol')"
                              class="col-100 medium-50"
                              :form="rform"
                              :name="'inspectores.' + index + '.rol'"
                              labelProp="nombre"
                              idProp="codigo"
                              :dbItems="[{codigo: 'INSPECTOR', nombre: 'Inspector'},{codigo: 'SUPERVISADO', nombre: 'Supervisado'},{codigo: 'OBSERVADOR', nombre: 'Observador'},{codigo: 'SUPERVISOR', nombre: 'Supervisor'},{codigo: 'SUPERVISADO_FORMACION', nombre: 'Supervisado en Formación'}]"
                            >
                            </r-autocomplete> -->
                          </f7-row>
                        </ul>
                      </f7-list>
                    </f7-card-content>
                    <f7-link
                      v-if="rform.formData"
                      @click="$delete(rform.formData.inspectores, index);"
                      class="margin-half"
                      style="position:absolute;right:0;top:0;"
                      icon-f7="trash"
                    ></f7-link>
                  </f7-card>
                </div>
                <!-- Inspectores -->
                <!-- #975 · Evaluación del tutor de observadores y supervisados en formación. Solo en línea:
                     vive en la API de Formación y no viaja con la inspección. -->
                <bloque-tutor-practicas
                  v-if="!offline && rform && rform.formData && rform.formData.id"
                  :expediente-id="rform.formData.id"
                  :firma-participantes="String(guardadosTutor)"
                ></bloque-tutor-practicas>
                <f7-row no-gap>
                  <r-input
                    v-noroles="['ENAC', 'PRODUCCION']"
                    class="col-25"
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.estado')"
                    :form="rform"
                    type="badge"
                    :readonly="true"
                    name="estado.estado"
                    :text="rform.formData && rform.formData.estado ? getTextoBadgeEstado(rform.formData.estado.estado) : ''"
                    :color="rform.formData && rform.formData.estado ? getColorBadgeEstado(rform.formData.estado.estado) : ''"
                    :decorationConfig="Utils.getProperty('viene.enac') && Utils.getProperty('viene.enac') == 'true' ? undefined : {
                      icon: 'rectangle_on_rectangle_angled',
                      color: 'blue',
                      tooltip: 'Histórico de estados',
                      action: mostrarHistoricoEstados
                    }"
                  ></r-input>
                  <r-input
                    v-noroles="['ENAC', 'PRODUCCION']"
                    v-if="!offline"
                    class="col-25"
                    :label="$t('inspecciones.inspeccion_form.bloqueado')"
                    :form="rform"
                    type="check"
                    name="bloqueado"
                  ></r-input>
                  <r-input
                    v-noroles="['ENAC', 'PRODUCCION']"
                    v-if="!offline"
                    class="col-25"
                    :label="$t('inspecciones.inspeccion_form.auditoria_manual')"
                    :form="rform"
                    type="check"
                    name="auditoriaManual"
                  ></r-input>
                </f7-row>
                <f7-row no-gap>
                  <r-input
                    floating-label
                    :class="!offline ? 'col-25' : 'col-50'"
                    :label="$t('inspecciones.inspeccion_form.fecha_inspeccion')"
                    :form="rform"
                    type="datepicker"
                    :name="'fechaInsp'"
                    :calendar-params="{
                      closeOnSelect: true,
                      routableModals: false,
                      dateFormat: {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      },
                    }"
                  ></r-input>
                  <r-input
                    v-if="!offline"
                    outline
                    floating-label
                    class="col-25 bordeAzul"
                    :label="$t('inspecciones.inspeccion_form.fecha_limite_correccion')"
                    :form="rform"
                    type="datepicker"
                    :name="'fechaLimiteCorrecion'"
                    :calendar-params="{
                      closeOnSelect: true,
                      routableModals: false,
                      dateFormat: {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      },
                    }"
                  ></r-input>
                  <r-input
                    v-if="!offline"
                    outline   
                    floating-label
                    class="col-25 bordeAzul"
                    :label="$t('inspecciones.inspeccion_form.fecha_prox_inspeccion')"
                    :form="rform"
                    type="datepicker"
                    :name="'proxInsp'"
                    :readonly="true"
                    :overrideReadonly="true"
                    :calendar-params="{
                      closeOnSelect: true,
                      routableModals: false,
                      dateFormat: {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      },
                    }"
                  ></r-input>
                  <r-input
                    v-if="!offline"
                    outline
                    floating-label
                    class="col-25 bordeAzul"
                    :label="$t('inspecciones.inspeccion_form.fecha_renovacion')"
                    :form="rform"
                    type="datepicker"
                    :name="'fechaRenovacion'"
                    :readonly="!!infoPeriodicidadMessage"
                    :calendar-params="{
                      closeOnSelect: true,
                      routableModals: false,
                      dateFormat: {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      },
                    }"
                  >
                    <f7-link
                      v-if="rform && rform.formData && rform.formData.formato && rform.formData.formato.ayudaPeriodicidad"
                      slot="content-end"
                      @click="popupProxInspOpened = true;"
                      icon-f7="info_circle_fill"
                      style="top: 9px;right: 15px;font-size: 8pt;"
                      ></f7-link>
                      <span
                      v-if="infoPeriodicidadMessage"
                      style="font-size: 8pt;"
                      slot="info"
                    >{{infoPeriodicidadMessage}}</span>
                  </r-input>
                  <r-input
                    v-else
                    outline   
                    floating-label
                    class="col-50 bordeAzul"
                    :label="$t('inspecciones.inspeccion_form.fecha_renovacion')"
                    :form="rform"
                    type="datepicker"
                    :name="'fechaRenovacion'"
                    :readonly="!!infoPeriodicidadMessage"
                    :calendar-params="{
                      closeOnSelect: true,
                      routableModals: false,
                      dateFormat: {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      },
                    }"
                  >
                    <f7-link
                      v-if="rform && rform.formData && rform.formData.formato && rform.formData.formato.ayudaPeriodicidad"
                      slot="content-end"
                      @click="popupProxInspOpened = true;"
                      icon-f7="info_circle_fill"
                      style="top: initial;right: 15px;"
                    ></f7-link>
                    <span
                      v-if="infoPeriodicidadMessage"
                      slot="info"
                    >{{infoPeriodicidadMessage}}</span>
                  </r-input>
                </f7-row>
                <f7-row no-gap>
                  <r-input
                    v-if="Utils.posterior2Dic2024(rform.formData.fechaInsp)"
                    class="col-30"
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.hora_inicio')"
                    :form="rform"
                    :name="'hc1'"
                    type="datetime-local"
                    :readonly="true"
                    :overrideReadonly="true"
                    :calendar-params="{ timePickerPlaceholder: 'Seleccionar hora', toolbarCloseText: 'Hecho', closeOnSelect: true, timePicker: true, routableModals: false, dateFormat: { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' } }"
                    :ignorePreviousVal="true"
                    :formatDate="'DD/MM/YYYY HH:mm'"
                  ></r-input>
                  <r-timepicker
                    v-else
                    class="col-30"
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.hora_inicio')"
                    :form="rform"
                    name="hc1"
                  ></r-timepicker>
                  <r-input
                    v-if="Utils.posterior2Dic2024(rform.formData.fechaInsp)"
                    class="col-30"
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.hora_final')"
                    :form="rform"
                    :name="'hf1'"
                    type="datetime-local"
                    :readonly="true"
                    :overrideReadonly="true"
                    :calendar-params="{ timePickerPlaceholder: 'Seleccionar hora', toolbarCloseText: 'Hecho', closeOnSelect: true, timePicker: true, routableModals: false, dateFormat: { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' } }"
                    :ignorePreviousVal="true"
                    :formatDate="'DD/MM/YYYY HH:mm'"
                  ></r-input>
                  <r-timepicker
                    v-else
                    outline
                    class="col-30 bordeAzul"
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.hora_final')"
                    :form="rform"
                    name="hf1"
                  ></r-timepicker>
                  <r-input
                    outline
                    class="col-30"
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.duracion')"
                    :form="rform"
                    name="duracionH"
                    altername="duracion"
                    :readonly="true"
                    :overrideReadonly="true"
                  ></r-input>
                </f7-row>
                <f7-row v-if="rform && rform.formData && (!rform.formData.sesiones || !rform.formData.sesiones.length) && (!Utils.getProperty('viene.enac') || Utils.getProperty('viene.enac') == 'false')" no-gap v-roles="['DTYCAL','ADMIN']">
                  <r-timepicker
                    class="col-30"
                    outline
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.hora_inicio_real')"
                    :form="rform"
                    name="hcReal"
                  ></r-timepicker>
                  <r-timepicker
                    class="col-30"
                    outline
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.hora_final_real')"
                    :form="rform"
                    name="hfReal"
                  ></r-timepicker>
                </f7-row>
                <f7-row v-if="rform && rform.formData && (!rform.formData.sesiones || !rform.formData.sesiones.length) && (!Utils.getProperty('viene.enac') || Utils.getProperty('viene.enac') == 'false')" no-gap v-noroles="['DTYCAL','ADMIN', 'ENAC', 'PRODUCCION']">
                  <r-timepicker
                    class="col-30"
                    outline
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.hora_inicio_real')"
                    :form="rform"
                    name="hcReal"
                    :readonly="true"
                    :overrideReadonly="true"
                  ></r-timepicker>
                  <r-timepicker
                    class="col-30"
                    outline
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.hora_final_real')"
                    :form="rform"
                    name="hfReal"
                    :readonly="true"
                    :overrideReadonly="true"
                  ></r-timepicker>
                </f7-row>
                <div v-if="true && rform && rform.formData && !offline && rform.formData.sesiones && rform.formData.sesiones.length && (!Utils.getProperty('viene.enac') || Utils.getProperty('viene.enac') == 'false')" v-noroles="['ENAC', 'PRODUCCION']" style="z-index: 50" class="col-100">
                  <f7-block-title style="z-index: 30">
                    {{$t('inspecciones.inspeccion_form.sesiones_trabajo_automaticas')}}
                    <span v-if="duracionAcumuladaSesiones(rform.formData.sesiones, 'number')" style="font-size: 0.75em;padding-right: 4pt;"><f7-icon f7="alarm" size="small" color="primary"></f7-icon>{{duracionAcumuladaSesiones(rform.formData.sesiones)}} | </span>
                    <f7-link
                      v-if="editableAdminDtycal"
                      @click="rform.formData.sesiones.push({inicio: new Date(), fin: null})"
                    >{{$t('inspecciones.inspeccion_form.add')}}</f7-link>
                  </f7-block-title>
                  <f7-card
                    class="elevation-3 padding-vertical-half padding-right"
                    v-for="(item,index) in rform.formData.sesiones"
                    :key="'sesiones-'+index"
                    :style="'z-index:'+(rform.formData.sesiones.length - index)"
                  >
                    <f7-card-content>
                      <f7-list class="list-form">
                        <ul class="no-margin no-padding">
                          <f7-row no-gap>
                            <r-input
                              class="col-40 medium-40 small-40"
                              floating-label
                              :label="$t('inspecciones.inspeccion_form.inicio')"
                              :form="rform"
                              :name="'sesiones.'+index+'.inicio'"
                              type="datetime-local"
                              :readonly="!editableAdminDtycal"
                              :overrideReadonly="true"
                              :calendar-params="{timePickerPlaceholder:'Seleccionar hora', toolbarCloseText:'Hecho',closeOnSelect:true,timePicker: true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit', hour:'2-digit',minute:'2-digit' } }"
                              :ignorePreviousVal="true"
                              :formatDate="'DD/MM/YYYY HH:mm'"
                            ></r-input>
                            <r-input
                              class="col-40 medium-40 small-40"
                              floating-label
                              :label="$t('inspecciones.inspeccion_form.fin')"
                              :form="rform"
                              :name="'sesiones.'+index+'.fin'"
                              type="datetime-local"
                              :readonly="!editableAdminDtycal"
                              :overrideReadonly="true"
                              :calendar-params="{timePickerPlaceholder:'Seleccionar hora', toolbarCloseText:'Hecho',closeOnSelect:true,timePicker: true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit', hour:'2-digit',minute:'2-digit' } }"
                              :ignorePreviousVal="true"
                              :formatDate="'DD/MM/YYYY HH:mm'"
                            ></r-input>
                            <span v-if="item && DateUtils.getDurationInSeconds(item.inicio, item.fin)" class="col-10 medium-10 small-10" style="padding-top: 10px;"><f7-icon f7="alarm" color="primary"></f7-icon>{{DateUtils.getDifferenceInTime(item.inicio, item.fin)}}</span>
                            <span v-else class="col-10 medium-10 small-10" style="padding-top: 10px;"> </span>
                          </f7-row>
                        </ul>
                      </f7-list>
                    </f7-card-content>
                    <f7-link
                      v-if="editableAdminDtycal"
                      @click="eliminarSesion(index);"
                      class="margin-half"
                      style="position:absolute;right:0;top:0;"
                      icon-f7="trash"
                    ></f7-link>
                  </f7-card>
                </div>

                <!-- <div style="z-index: 50" class="col-100" v-if="(!Utils.getProperty('viene.enac') || Utils.getProperty('viene.enac') == 'false')"> -->
                <div style="z-index: 50" class="col-100" v-if="Utils.posterior2Dic2024(rform.formData.fechaInsp)">
                  <f7-block-title style="z-index: 30">
                    {{$t('inspecciones.inspeccion_form.sesiones_trabajo_manuales')}}
                    <span v-if="duracionAcumuladaSesiones(rform.formData.sesionesManuales, 'number')" style="font-size: 0.75em;padding-right: 4pt;"><f7-icon f7="alarm" size="small" color="primary"></f7-icon>{{duracionAcumuladaSesiones(rform.formData.sesionesManuales)}} | </span>
                    <f7-link
                      v-if="editableAdminDtycalInspector && !Utils.posterior2Dic2024(rform.formData.fechaInsp)"
                      @click="addSesionManual()"
                    >{{$t('inspecciones.inspeccion_form.add')}}</f7-link>
                  </f7-block-title>
                  <f7-card
                    class="elevation-3 padding-vertical-half padding-right"
                    v-for="(item,index) in rform.formData.sesionesManuales"
                    :key="'sesionesManuales-'+index"
                    :style="'z-index:'+(rform.formData.sesionesManuales.length - index)"
                  >
                    <f7-card-content>
                      <f7-list class="list-form">
                        <ul class="no-margin no-padding">
                          <f7-row no-gap>
                            <div class="col-40 inicio-sesion">
                              <r-input
                                :class="{'col-15': !offline, 'col-30': offline}"
                                floating-label
                                :label="$t('inspecciones.inspeccion_form.inicio')"
                                :form="rform"
                                :name="'sesionesManuales.'+index+'.inicio'"
                                type="datetime-local"
                                :readonly="!editableAdminDtycalInspector || Utils.posterior2Dic2024(rform.formData.fechaInsp)"
                                :overrideReadonly="true"
                                :calendar-params="{timePickerPlaceholder:'Seleccionar hora', toolbarCloseText:'Hecho',closeOnSelect:true,timePicker: true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit', hour:'2-digit',minute:'2-digit' } }"
                                :ignorePreviousVal="true"
                                :formatDate="'DD/MM/YYYY HH:mm'"
                                :viewHistory="false"
                              ></r-input>
                              <r-input
                                v-noroles="['ENAC', 'PRODUCCION']"
                                :class="{'col-30': !offline, 'col-60': offline}"
                                floating-label
                                :label="$t('Dir. Inicio')"
                                :form="rform"
                                :name="'sesionesManuales.' + index + '.puntoInicio.direccion'"
                                :readonly="true"
                                :overrideReadonly="true"
                                :ignorePreviousVal="true"
                                :decorationConfig="{
                                  icon: 'map_pin_ellipse',
                                  color: 'blue',
                                  tooltip: 'Ver en mapa',
                                  action: () => offline ? recalcularDireccion(rform.formData.sesionesManuales[index], 'puntoInicio') : mostrarEnMapa(rform.formData.sesionesManuales[index].puntoInicio),
                                  showDecoration: () => offline || (rform.formData.sesionesManuales[index].puntoInicio && rform.formData.sesionesManuales[index].puntoInicio.longitud && rform.formData.sesionesManuales[index].puntoInicio.latitud)
                                }"
                                :viewHistory="false"
                              ></r-input>
                              <r-input
                                v-if="$refs.rform && $refs.rform.username == 'NOID'"
                                class="col-10"
                                floating-label
                                :label="$t('longitud')"
                                :form="rform"
                                :name="'sesionesManuales.' + index + '.puntoInicio.longitud'"
                                :viewHistory="false"
                              ></r-input>
                              <r-input
                                v-if="$refs.rform && $refs.rform.username == 'NOID'"
                                class="col-10"
                                floating-label
                                :label="$t('latitud')"
                                :form="rform"
                                :name="'sesionesManuales.' + index + '.puntoInicio.latitud'"
                                :viewHistory="false"
                              ></r-input>
                              <!-- <r-input
                                v-roles="{route: $f7route.url, roles: ['ENAC', 'PRODUCCION']}"
                                :class="{'col-30': !offline, 'col-60': offline}"
                                floating-label
                                :label="$t('Dir. Inicio')"
                                :form="rform"
                                :name="'sesionesManuales.' + index + '.puntoInicio.direccion'"
                                :readonly="true"
                                :overrideReadonly="true"
                                :ignorePreviousVal="true"
                              ></r-input> -->
                              <r-input
                                v-roles="['ENAC', 'PRODUCCION']"
                                :class="'col-10'"
                                floating-label
                                :label="$t('longitud')"
                                :form="rform"
                                :name="'sesionesManuales.' + index + '.puntoInicio.longitud'"
                                :readonly="true"
                                :overrideReadonly="true"
                                :viewHistory="false"
                              ></r-input>
                              <r-input
                                v-roles="['ENAC', 'PRODUCCION']"
                                :class="'col-10'"
                                floating-label
                                :label="$t('latitud')"
                                :form="rform"
                                :name="'sesionesManuales.' + index + '.puntoInicio.latitud'"
                                :readonly="true"
                                :overrideReadonly="true"
                                :viewHistory="false"
                              ></r-input>
                            </div>

                            <div class="col-40 fin-sesion">
                              <r-input
                                :class="{'col-15': !offline, 'col-30': offline}"
                                floating-label
                                :label="$t('inspecciones.inspeccion_form.fin')"
                                :form="rform"
                                :name="'sesionesManuales.'+index+'.fin'"
                                type="datetime-local"
                                :readonly="!editableAdminDtycalInspector || Utils.posterior2Dic2024(rform.formData.fechaInsp)"
                                :overrideReadonly="true"
                                :calendar-params="{timePickerPlaceholder:'Seleccionar hora', toolbarCloseText:'Hecho',closeOnSelect:true,timePicker: true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit', hour:'2-digit',minute:'2-digit' } }"
                                :ignorePreviousVal="true"
                                :formatDate="'DD/MM/YYYY HH:mm'"
                                :viewHistory="false"
                              ></r-input>
                              <r-input
                                v-noroles="['ENAC', 'PRODUCCION']"
                                :class="{'col-30': !offline, 'col-60': offline}"
                                floating-label
                                :label="$t('Dir. Fin')"
                                :form="rform"
                                :name="'sesionesManuales.' + index + '.puntoFin.direccion'"
                                :readonly="true"
                                :overrideReadonly="true"
                                :ignorePreviousVal="true"
                                :decorationConfig="{
                                  icon: 'map_pin_ellipse',
                                  color: 'blue',
                                  tooltip: 'Ver en mapa',
                                  action: () => offline ? recalcularDireccion(rform.formData.sesionesManuales[index], 'puntoFin') : mostrarEnMapa(rform.formData.sesionesManuales[index].puntoFin),
                                  showDecoration: () => offline || (rform.formData.sesionesManuales[index].puntoFin && rform.formData.sesionesManuales[index].puntoFin.longitud && rform.formData.sesionesManuales[index].puntoFin.latitud)
                                }"
                                :viewHistory="false"
                              ></r-input>
                              <r-input
                                v-if="$refs.rform && $refs.rform.username == 'NOID'"
                                :class="'col-10'"
                                floating-label
                                :label="$t('longitud')"
                                :form="rform"
                                :name="'sesionesManuales.' + index + '.puntoFin.longitud'"
                                :viewHistory="false"
                              ></r-input>
                              <r-input
                                v-if="$refs.rform && $refs.rform.username == 'NOID'"
                                :class="'col-10'"
                                floating-label
                                :label="$t('latitud')"
                                :form="rform"
                                :name="'sesionesManuales.' + index + '.puntoFin.latitud'"
                                :viewHistory="false"
                              ></r-input>
                              <!-- <r-input
                                v-roles="{route: $f7route.url, roles: ['ENAC', 'PRODUCCION']}"
                                :class="{'col-30': !offline, 'col-60': offline}"
                                floating-label
                                :label="$t('Dir. Fin')"
                                :form="rform"
                                :name="'sesionesManuales.' + index + '.puntoFin.direccion'"
                                :readonly="true"
                                :overrideReadonly="true"
                                :ignorePreviousVal="true"
                              ></r-input> -->
                              <r-input
                                v-roles="['ENAC', 'PRODUCCION']"
                                :class="'col-10'"
                                floating-label
                                :label="$t('longitud')"
                                :form="rform"
                                :name="'sesionesManuales.' + index + '.puntoFin.longitud'"
                                :readonly="true"
                                :overrideReadonly="true"
                                :viewHistory="false"
                              ></r-input>
                              <r-input
                                v-roles="['ENAC', 'PRODUCCION']"
                                :class="'col-10'"
                                floating-label
                                :label="$t('latitud')"
                                :form="rform"
                                :name="'sesionesManuales.' + index + '.puntoFin.latitud'"
                                :readonly="true"
                                :overrideReadonly="true"
                                :viewHistory="false"
                              ></r-input>
                            </div>

                            <span v-if="item && DateUtils.getDurationInSeconds(item.inicio, item.fin)" class="col-15" style="padding-top: 10px;"><f7-icon f7="alarm" color="primary"></f7-icon>{{DateUtils.getDifferenceInTime(item.inicio, item.fin)}}</span>
                            <span v-else class="col-15" style="padding-top: 10px;"> </span>
                          </f7-row>
                        </ul>
                      </f7-list>
                    </f7-card-content>
                    <f7-link
                      v-if="editableAdminDtycalInspector && !Utils.posterior2Dic2024(rform.formData.fechaInsp)"
                      @click="eliminarSesionManual(index);"
                      class="margin-half"
                      style="position:absolute;right:0;top:0;"
                      icon-f7="trash"
                    ></f7-link>
                  </f7-card>
                </div>

                <div v-if="!offline && Utils.posterior2Dic2024(rform.formData.fechaInsp)" style="z-index: 50" class="col-100">
                  <f7-block-title style="z-index: 30">
                    {{$t('inspecciones.inspeccion_form.sesiones_tpi')}}
                    <span v-if="duracionAcumuladaSesiones(rform.formData.sesionesTPI, 'number')" style="font-size: 0.75em;padding-right: 4pt;"><f7-icon f7="alarm" size="small" color="primary"></f7-icon>{{duracionAcumuladaSesiones(rform.formData.sesionesTPI)}} | </span>
                    <f7-link
                      v-if="editableAdminDtycalInspector"
                      @click="inicioSesionTPI(rform.formData.sesionesTPI)"
                    >{{$t('inspecciones.inspeccion_form.add')}}</f7-link>
                  </f7-block-title>
                  <f7-card
                    class="elevation-3 padding-vertical-half padding-right"
                    v-for="(item,index) in rform.formData.sesionesTPI"
                    :key="'sesionesTPI-'+index"
                    :style="'z-index:'+(rform.formData.sesionesTPI.length - index)"
                  >
                    <f7-card-content>
                      <f7-list class="list-form">
                        <ul class="no-margin no-padding">
                          <f7-row no-gap>
                            
                            <div class="col-40 inicio-sesion">
                              <r-input
                                class="col-15"
                                floating-label
                                :label="$t('inspecciones.inspeccion_form.inicio')"
                                :form="rform"
                                :name="'sesionesTPI.'+index+'.inicio'"
                                type="datetime-local"
                                :readonly="!editableAdminDtycalInspector"
                                :overrideReadonly="true"
                                :calendar-params="{timePickerPlaceholder:'Seleccionar hora', toolbarCloseText:'Hecho',closeOnSelect:true,timePicker: true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit', hour:'2-digit',minute:'2-digit' } }"
                                :ignorePreviousVal="true"
                                :formatDate="'DD/MM/YYYY HH:mm'"
                                :viewHistory="false"
                              ></r-input>
                              <r-input
                                v-noroles="['ENAC', 'PRODUCCION']"
                                class="col-20"
                                floating-label
                                :label="$t('Dir. Inicio')"
                                :form="rform"
                                :name="'sesionesTPI.'+index+'.puntoInicio.direccion'"
                                :readonly="true"
                                :overrideReadonly="true"
                                :ignorePreviousVal="true"
                                :decorationConfig="{
                                  icon: 'map_pin_ellipse',
                                  color: 'blue',
                                  tooltip: 'Ver en mapa',
                                  action: () => mostrarEnMapa(rform.formData.sesionesTPI[index].puntoInicio),
                                  showDecoration: () => rform.formData.sesionesTPI[index].puntoInicio && rform.formData.sesionesTPI[index].puntoInicio.longitud && rform.formData.sesionesTPI[index].puntoInicio.latitud
                                }"
                                :viewHistory="false"
                              ></r-input>
                              <r-input
                                v-if="$refs.rform && $refs.rform.username == 'NOID'"
                                :class="'col-10'"
                                floating-label
                                :label="$t('longitud')"
                                :form="rform"
                                :name="'sesionesTPI.' + index + '.puntoInicio.longitud'"
                                :viewHistory="false"
                              ></r-input>
                              <r-input
                                v-if="$refs.rform && $refs.rform.username == 'NOID'"
                                :class="'col-10'"
                                floating-label
                                :label="$t('latitud')"
                                :form="rform"
                                :name="'sesionesTPI.' + index + '.puntoInicio.latitud'"
                                :viewHistory="false"
                              ></r-input>
                              <!-- <r-input
                                v-roles="['ENAC', 'PRODUCCION']"
                                class="col-20"
                                floating-label
                                :label="$t('Dir. Inicio')"
                                :form="rform"
                                :name="'sesionesTPI.'+index+'.puntoInicio.direccion'"
                                :readonly="true"
                                :overrideReadonly="true"
                                :ignorePreviousVal="true"
                              ></r-input> -->
                              <r-input
                                v-roles="['ENAC', 'PRODUCCION']"
                                :class="'col-10'"
                                floating-label
                                :label="$t('longitud')"
                                :form="rform"
                                :name="'sesionesTPI.' + index + '.puntoInicio.longitud'"
                                :readonly="true"
                                :overrideReadonly="true"
                                :viewHistory="false"
                              ></r-input>
                              <r-input
                                v-roles="['ENAC', 'PRODUCCION']"
                                :class="'col-10'"
                                floating-label
                                :label="$t('latitud')"
                                :form="rform"
                                :name="'sesionesTPI.' + index + '.puntoInicio.latitud'"
                                :readonly="true"
                                :overrideReadonly="true"
                                :viewHistory="false"
                              ></r-input>
                            </div>
                            
                            <div class="col-40 fin-sesion">
                              <r-input
                                class="col-15"
                                floating-label
                                :label="$t('inspecciones.inspeccion_form.fin')"
                                :form="rform"
                                :name="'sesionesTPI.'+index+'.fin'"
                                type="datetime-local"
                                :readonly="!editableAdminDtycalInspector"
                                :overrideReadonly="true"
                                :calendar-params="{timePickerPlaceholder:'Seleccionar hora', toolbarCloseText:'Hecho',closeOnSelect:true,timePicker: true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit', hour:'2-digit',minute:'2-digit' } }"
                                :ignorePreviousVal="true"
                                :formatDate="'DD/MM/YYYY HH:mm'"
                                :viewHistory="false"
                              ></r-input>
                              <r-input
                                v-noroles="['ENAC', 'PRODUCCION']"
                                class="col-20"
                                floating-label
                                :label="$t('Dir. Fin')"
                                :form="rform"
                                :name="'sesionesTPI.'+index+'.puntoFin.direccion'"
                                :readonly="true"
                                :overrideReadonly="true"
                                :ignorePreviousVal="true"
                                :decorationConfig="{
                                  icon: 'map_pin_ellipse',
                                  color: 'blue',
                                  tooltip: 'Ver en mapa',
                                  action: () => mostrarEnMapa(rform.formData.sesionesTPI[index].puntoFin),
                                  showDecoration: () => rform.formData.sesionesTPI[index].puntoFin && rform.formData.sesionesTPI[index].puntoFin.longitud && rform.formData.sesionesTPI[index].puntoFin.latitud
                                }"
                                :viewHistory="false"
                              ></r-input>
                              <r-input
                                v-if="$refs.rform && $refs.rform.username == 'NOID'"
                                :class="'col-10'"
                                floating-label
                                :label="$t('longitud')"
                                :form="rform"
                                :name="'sesionesTPI.' + index + '.puntoFin.longitud'"
                                :viewHistory="false"
                              ></r-input>
                              <r-input
                                v-if="$refs.rform && $refs.rform.username == 'NOID'"
                                :class="'col-10'"
                                floating-label
                                :label="$t('latitud')"
                                :form="rform"
                                :name="'sesionesTPI.' + index + '.puntoFin.latitud'"
                                :viewHistory="false"
                              ></r-input>
                              <!-- <r-input
                                v-roles="['ENAC', 'PRODUCCION']"
                                class="col-20"
                                floating-label
                                :label="$t('Dir. Fin')"
                                :form="rform"
                                :name="'sesionesTPI.'+index+'.puntoFin.direccion'"
                                :readonly="true"
                                :overrideReadonly="true"
                                :ignorePreviousVal="true"
                                :viewHistory="false"
                              ></r-input> -->
                              <r-input
                                v-roles="['ENAC', 'PRODUCCION']"
                                :class="'col-10'"
                                floating-label
                                :label="$t('longitud')"
                                :form="rform"
                                :name="'sesionesTPI.' + index + '.puntoFin.longitud'"
                                :readonly="true"
                                :overrideReadonly="true"
                                :viewHistory="false"
                              ></r-input>
                              <r-input
                                v-roles="['ENAC', 'PRODUCCION']"
                                :class="'col-10'"
                                floating-label
                                :label="$t('latitud')"
                                :form="rform"
                                :name="'sesionesTPI.' + index + '.puntoFin.latitud'"
                                :readonly="true"
                                :overrideReadonly="true"
                                :viewHistory="false"
                              ></r-input>
                            </div>
                            <r-input
                              class="col-15"
                              floating-label
                              :label="$t('Empleado')"
                              :form="rform"
                              :name="'sesionesTPI.' + index + '.username'"
                              :readonly="true"
                              :overrideReadonly="true"
                              :viewHistory="false"
                            ></r-input>
                            <span v-if="item && DateUtils.getDurationInSeconds(item.inicio, item.fin)" class="col-10 medium-10 small-10" style="padding-top: 10px;"><f7-icon f7="alarm" color="primary"></f7-icon>{{DateUtils.getDifferenceInTime(item.inicio, item.fin)}}</span>
                            <span v-else class="col-10 medium-10 small-10" style="padding-top: 10px;"> </span>
                          </f7-row>
                        </ul>
                      </f7-list>
                    </f7-card-content>
                    <f7-link
                      v-if="editableAdminDtycalInspector"
                      @click="eliminarSesionTPI(index);"
                      class="margin-half"
                      style="position:absolute;right:0;top:0;"
                      icon-f7="trash"
                    ></f7-link>
                  </f7-card>
                </div>

                <f7-row no-gap v-noroles="['ENAC', 'PRODUCCION']" v-if="(!Utils.getProperty('viene.enac') || Utils.getProperty('viene.enac') == 'false')">
                  <r-input
                    :class="{'col-50': !offline, 'col-100': offline}"
                    outline
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.direccion_inicio')"
                    :form="rform"
                    name="puntoInicio.direccion"
                    :readonly="true"
                    :overrideReadonly="true"
                    :decorationConfig="{
                      icon: 'map_pin_ellipse',
                      color: 'blue',
                      tooltip: 'Ver en mapa',
                      action: () => offline ? recalcularDireccion(rform.formData, 'puntoInicio') : mostrarEnMapa(rform.formData.puntoInicio),
                      showDecoration: () => offline || (rform.formData.puntoInicio && rform.formData.puntoInicio.longitud && rform.formData.puntoInicio.latitud)
                    }"
                  ></r-input>
                  <r-input
                    v-if="$refs.rform && $refs.rform.username == 'NOID'"
                    :class="'col-10'"
                    floating-label
                    :label="$t('longitud')"
                    :form="rform"
                    :name="'puntoInicio.longitud'"
                  ></r-input>
                  <r-input
                    v-if="$refs.rform && $refs.rform.username == 'NOID'"
                    :class="'col-10'"
                    floating-label
                    :label="$t('latitud')"
                    :form="rform"
                    :name="'puntoInicio.latitud'"
                  ></r-input>
                  <r-input
                    v-roles="['ENAC', 'PRODUCCION']"
                    class="col-30"
                    outline
                    floating-label
                    :label="$t('Dir. Fin')"
                    :form="rform"
                    :name="'puntoInicio.direccion'"
                    :readonly="true"
                    :overrideReadonly="true"
                    :ignorePreviousVal="true"
                  ></r-input>
                  <r-input
                    v-noroles="['ENAC', 'PRODUCCION']"
                    outline
                    :class="{'col-50': !offline, 'col-100': offline}"
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.direccion_fin')"
                    :form="rform"
                    name="puntoFin.direccion"
                    :readonly="true"
                    :overrideReadonly="true"
                    :decorationConfig="{
                      icon: 'map_pin_ellipse',
                      color: 'blue',
                      tooltip: 'Ver en mapa',
                      action: () => offline ? recalcularDireccion(rform.formData, 'puntoFin') : mostrarEnMapa(rform.formData.puntoFin),
                      showDecoration: () => offline || (rform.formData.puntoFin && rform.formData.puntoFin.longitud && rform.formData.puntoFin.latitud)
                    }"
                  ></r-input>
                  <r-input
                    v-if="$refs.rform && $refs.rform.username == 'NOID'"
                    :class="'col-10'"
                    floating-label
                    :label="$t('longitud')"
                    :form="rform"
                    :name="'puntoFin.longitud'"
                  ></r-input>
                  <r-input
                    v-if="$refs.rform && $refs.rform.username == 'NOID'"
                    :class="'col-10'"
                    floating-label
                    :label="$t('latitud')"
                    :form="rform"
                    :name="'puntoFin.latitud'"
                  ></r-input>
                  <r-input
                    v-roles="['ENAC', 'PRODUCCION']"
                    class="col-30"
                    outline
                    floating-label
                    :label="$t('Dir. Fin')"
                    :form="rform"
                    :name="'puntoFin.direccion'"
                    :readonly="true"
                    :overrideReadonly="true"
                    :ignorePreviousVal="true"
                  ></r-input>
                </f7-row>
                <r-input
                  outline
                  class="bordeAzul"
                  floating-label
                  :label="$t('inspecciones.inspeccion_form.observaciones')"
                  :form="rform"
                  type="textarea"
                  :name="'observaciones'"
                  :allMayus="true"
                />
                <div>
                  <r-autocomplete-m2m
                    outline
                    style="display:block;"
                    class="bordeAzul"
                    ref="equipos"
                    :dbAdapter="offline ? EquipoOffline : Item"
                    floating-label
                    :label="$t('inspecciones.inspeccion_form.equipos')"
                    :form="rform"
                    name="equipos"
                    labelProp="nombre"
                    :idProp="null"
                    :valueProperty="'codigo'"
                    prefixProp="codigo"
                    idFieldDetail="id"
                    :filter="offline ? null : { esEquipo: true }"
                  ></r-autocomplete-m2m>
                </div>
              </ul>
            </f7-list>
            <f7-popup
              v-if="popupProxInspOpened"
              @popup:closed="popupProxInspOpened = false"
              :opened="true"
              ref="popupProxInspOpened"
            >
              <f7-page>
                <f7-navbar title="Ayuda periodicidad">
                  <f7-nav-right>
                    <f7-link
                      @click="$refs.popupProxInspOpened.close()"
                      icon-f7="multiply"
                    ></f7-link>
                  </f7-nav-right>
                </f7-navbar>
                <f7-block>
                  <r-rich-text-input
                    v-if="rform && rform.formData && rform.formData.formato && rform.formData.formato.ayudaPeriodicidad"
                    :disabled="true"
                    class="col-50"
                    :form="rform"
                    :name="'formato.ayudaPeriodicidad'"
                  ></r-rich-text-input>
                </f7-block>
              </f7-page>
            </f7-popup>
          </f7-tab>
          <f7-tab id="tab-instalacion" class="page-content">
            <!-- Características -->
            <div v-if="tabActive == 'Instalacion'">
              <div
                class="textoAzul w-99"
                v-for="(caracteristica, ic) in rform.formData.caracteristicas"
                :key="'caracteristica-' + caracteristica.nombre + '-' + ic"
              >
                <caracteristica
                  :key="'caract-' + caracteristica.nombre + '-' + ic"
                  :tipo="caracteristica.tipo"
                  :caracteristica="caracteristica"
                  :form="rform"
                  :label="caracteristica.label"
                  :name="'caracteristicas.' + ic"
                  :allCaracteristicas="rform.formData.caracteristicas"
                  @change="caracteristicaModificada($event)"
                  :offline="offline"
                ></caracteristica>
              </div>
            </div>
          </f7-tab>
          <f7-tab id="tab-tomadedatos" class="page-content">
            <f7-tabs class="full-height" v-if="tabActive == 'TomaDatos'">
              <f7-toolbar tabbar>
                <f7-link tab-link="#tab-comprobaciones" tab-link-active
                  >Comprobaciones</f7-link
                >
                <f7-link tab-link="#tab-defectos">Defectos</f7-link>
                <f7-link
                  :tab-link="'#tab-' + it"
                  v-for="(tab, it) in rform.formData.tabs"
                  :key="'tab-' + it"
                  >{{ tab.nombre }}</f7-link
                >
                <f7-link tab-link="#tab-notas">Notas</f7-link>
                <f7-link tab-link="#tab-documentos" @click="documentosOpened=true">Documentos</f7-link>
              </f7-toolbar>
              <!--style="--f7-page-subnavbar-offset:0px;"-->
              <f7-tab
                id="tab-comprobaciones"
                tab-active
                class="page-content no-padding"
              >
                <i
                  style="margin-left: 10px;cursor: pointer;"
                  class="icon f7-icons" 
                  @click="accordionOpened=!accordionOpened;switchAllComprobaciones(rform.formData.comprobaciones,accordionOpened)"
                >{{accordionOpened?'rectangle_compress_vertical':'rectangle_expand_vertical'}}</i> <span style="font-size: 9px;">(puede tardar unos segundos en realizar la acción)</span>
                <f7-list accordion-list>
                  <comprobacion
                    v-for="(comprobacion, ic) in rform.formData.comprobaciones"
                    :key="'comprobaciones.' + ic + '.' + comprobacion.codigo"
                    :comprobacion="comprobacion"
                    :name="'comprobaciones.' + ic"
                    :referencia="'comprobaciones_' + ic"
                    :form="rform"
                    :resultadoDefecto="comprobacion.valorInicial"
                    :tabletFormat="target == 'cordova'"
                    :pathPadre="'Documentos'"
                    :offline="offline"
                  ></comprobacion>
                </f7-list>
              </f7-tab>
              <f7-tab id="tab-defectos" class="page-content no-padding">
                <div class="full-height">
                  <f7-searchbar
                    disable-button-text="Cancelar"
                    placeholder="Buscar defecto por código"
                    :clear-button="true"
                    search-container=".fichas-defectos"
                    search-in=".card-header"
                    style="overflow-x: hidden;"
                    found-el=".searchbar-found-defectos"
                    not-found-el=".searchbar-not-found-defectos"
                  ></f7-searchbar>
                  <div class="page-content no-padding">
                    <f7-list
                      class="searchbar-not-found searchbar-not-found-defectos"
                    >
                      <f7-list-item
                        title="No se han encontrado defectos"
                      ></f7-list-item>
                    </f7-list>
                    <f7-list
                      class="searchbar-found searchbar-found-defectos fichas-defectos no-hairlines"
                    >
                      <ul>
                        <li
                          v-for="(item, index) in getAllDefectos()"
                          :key="'all-defectos-' + index"
                          class="card margin elevation-4"
                        >
                          <div class="card-header row align-items-center">
                            <div class="col-80">
                              <span class="display-inline-block">
                                {{ item.codigo }} {{ item.codigoVisual ? (' - ' + item.codigoVisual) : '' }} - {{item.nombre}}</span>
                              <span class="display-inline-block padding-left">{{
                                item.cuadro
                              }}</span>
                              <span v-if="item.nombreItem">{{item.nombreTab}} - {{item.nombreItem}}</span>
                            </div>
                            <div class="col-20">
                              <span class="display-inline-block">{{
                                item.categoria
                              }}</span>
                              <span class="display-inline-block padding-left">{{
                                item.prop
                              }}</span>
                            </div>
                          </div>
                          <div class="card-content item-row">
                            <div class="item-cell">
                              <div
                                class="item-row padding-horizontal padding-top-half align-items-center"
                              >
                                {{ item.descripcion }}
                                <i
                                  class="material-icons"
                                  v-tooltip="item.textoAyuda"
                                  >info</i
                                >
                              </div>
                              <div class="item-row">
                                <r-input
                                  :form="rform"
                                  placeholder="Observaciones"
                                  type="textarea"
                                  :name="index + '.observaciones'"
                                  class="width-100 textoAzul"
                                  :allMayus="true"
                                ></r-input>
                              </div>
                              <div class="item-row" v-if="rform.formData && rform.formData.formato && rform.formData.formato.conTipoMedidaAAdoptar">
                                <r-input
                                  floating-label
                                  :label="$t('inspecciones.inspeccion_form.tipoMedidaDefecto')"
                                  :form="rform"
                                  type="select"
                                  :name="index + '.tipoMedidaAAdoptar'"
                                >
                                  <option selected value=""></option>
                                  <option value="A OBSERVAR">A OBSERVAR</option>
                                  <option value="NECESARIA">NECESARIA</option>
                                  <option value="URGENTE">URGENTE</option>
                                </r-input>
                              </div>
                              <div class="item-row" v-if="rform.formData && rform.formData.formato && rform.formData.formato.conFaltaMantenimiento">
                                <r-input
                                  floating-label
                                  :label="$t('inspecciones.inspeccion_form.faltaMantenimiento')"
                                  :form="rform"
                                  type="select"
                                  :name="index + '.faltaMantenimiento'"
                                >
                                  <option selected value=""></option>
                                  <option value="SI">SI</option>
                                  <option value="NO">NO</option>
                                </r-input>
                              </div>
                              <div class="item-row">
                                <r-files
                                  :mostrarCheck="isImage"
                                  :mostrar-agrupador-documento="mostrarAgrupadorDocumentoInspeccion"
                                  :class="{ 'width-100': target != 'cordova' || readonly, 'width-70': target == 'cordova' && !readonly }"
                                  class="overflow-auto"
                                  :prefixKey="index"
                                  :form="rform"
                                  :name="index + '.documentos'"
                                  :documentoAdapter="target == 'cordova' ? DocumentoOffline : Documento"
                                  :offlinePath="Utils.getInspeccionPath(item.nombreItem ? `Documentos/${item.nombreTab}/${item.nombreItem}/Defectos/${item.codigo}` : `Documentos/Defectos/${item.codigo}`, rform.formData) "
                                ></r-files>
                                <f7-list v-if="!readonly">
                                  <f7-list-item
                                    v-if="target == 'cordova'"
                                    title="Capturar foto"
                                    @click="Utils.capturarFoto(rform, index + '.documentos', Utils.getInspeccionPath(item.nombreItem ? `Documentos/${item.nombreTab}/${item.nombreItem}/Defectos/${item.codigo}` : `Documentos/Defectos/${item.codigo}`, rform.formData), $set)"
                                    link="#"
                                  >
                                    <f7-icon
                                      slot="media"
                                      material="add_a_photo"
                                      color="primary"
                                    ></f7-icon>
                                  </f7-list-item>
                                  <f7-list-item
                                    v-if="target == 'cordova'"
                                    title="Grabar vídeo"
                                    @click="Utils.grabarVideo(rform, index + '.documentos', Utils.getInspeccionPath(item.nombreItem ? `Documentos/${item.nombreTab}/${item.nombreItem}/Defectos/${item.codigo}` : `Documentos/Defectos/${item.codigo}`, rform.formData), $set)"
                                    link="#"
                                  >
                                    <f7-icon
                                      slot="media"
                                      material="video_call"
                                      color="primary"
                                    ></f7-icon>
                                  </f7-list-item>
                                  <f7-list-item
                                    v-if="target == 'cordova'"
                                    title="Grabar audio"
                                    @click="Utils.grabarAudio(rform, index + '.documentos', Utils.getInspeccionPath(item.nombreItem ? `Documentos/${item.nombreTab}/${item.nombreItem}/Defectos/${item.codigo}` : `Documentos/Defectos/${item.codigo}`, rform.formData), $set)"
                                    link="#"
                                  >
                                    <f7-icon
                                      slot="media"
                                      material="mic"
                                      color="primary"
                                    ></f7-icon>
                                  </f7-list-item>
                                </f7-list>
                              </div>
                            </div>
                            <div class="item-after align-items-center padding" v-if="!readonly">
                              <a
                                class="link eliminar-defecto"
                                @click="eliminarDefecto(index)"
                                v-tooltip="'Eliminar defecto'"
                              >
                                <i class="f7-icons">trash</i>
                              </a>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </f7-list>
                  </div>
                </div>
              </f7-tab>
              <f7-tab
                v-for="(tab, it) in rform.formData.tabs"
                :key="'tab-' + it"
                :id="'tab-' + it"
                class="page-content no-padding"
              >
                <div class="full-height">
                  <f7-navbar>
                    <f7-nav-left>
                      <f7-link
                        v-tooltip="'Buscar'"
                        class="searchbar-enable"
                        :data-searchbar="'.searchbar-tab-' + it"
                        icon-ios="f7:search"
                        icon-aurora="f7:search"
                        icon-md="material:search"
                      ></f7-link>
                    </f7-nav-left>
                    <f7-nav-title>Lista de {{ tab.nombre }}</f7-nav-title>
                    <f7-nav-right>
                      <f7-link
                        v-if="!readonly"
                        v-tooltip="'Añadir'"
                        icon-ios="f7:plus_app"
                        icon-aurora="f7:plus_app"
                        icon-md="material:add_box"
                        @click="anadirTabItem(tab)"
                      ></f7-link>
                    </f7-nav-right>
                    <f7-searchbar
                      :class="
                        'searchbar-tab-' + it + ' width-100 bg-color-primary'
                      "
                      expandable
                      disable-button-text="Cancelar"
                      placeholder="Buscar"
                      :clear-button="true"
                      :search-container="'.lista-tab-' + it"
                      style="overflow-x: hidden;"
                      :found-el="'.searchbar-found-tab-' + it"
                      :not-found-el="'.searchbar-not-found-tab-' + it"
                    ></f7-searchbar>
                  </f7-navbar>
                  <div class="page-content no-padding">
                    <f7-list
                      :class="
                        'searchbar-not-found searchbar-not-found-tab-' + it
                      "
                    >
                      <f7-list-item
                        title="No se han encontrado elementos"
                      ></f7-list-item>
                    </f7-list>
                    <f7-list :class="'searchbar-found searchbar-found-tab-' + it + ' lista-tab-' + it + ' no-hairlines'" >
                      <ul v-for="(item, index) in tab.items" :key="'items-' + it + '-' + index">
                        <f7-list-item
                          :link="true"
                          @click="
                            popupTabs = {};
                            popupTabs[tab.nombre] = index;
                            popupOpen = false;
                            $nextTick(() => (popupOpen = true));
                          "
                          :route-props="{ rform }"
                          :title="item.nombre"
                        ></f7-list-item>
                        <f7-popup
                          tablet-fullscreen
                          v-if="popupTabs[tab.nombre] === index"
                          :class="{ 'bg-transparent': cameraOpened, 'bg-white': !cameraOpened }"
                          :key="'items-popup-' + it + index"
                          :opened="popupOpen"
                          @popup:closed="
                            popupTabs[tab.nombre] = false;
                            popupOpen = false;
                          "
                        >
                          <elemento
                            v-focusableNextElement="target == 'cordova'"
                            :rform="$refs.rform"
                            :indexTab="it"
                            :index="index"
                            :elemento="item"
                            :tab="tab"
                            @abrirPopup="
                              popupTabs[tab['nombre']] = $event;
                              popupOpen = false;
                              $nextTick(() => (popupOpen = true));
                            "
                          />
                        </f7-popup>
                      </ul>
                    </f7-list>
                  </div>
                </div>
              </f7-tab>
              <f7-tab id="tab-notas" class="page-content no-padding" style="overflow: hidden;">
                <f7-list style="height: 100%;">
                  <ul style="height: 100%;">
                    <r-input
                      :form="rform"
                      placeholder="Escriba aquí las notas"
                      type="textarea"
                      name="notas"
                      :allMayus="true"
                      class="textoAzul notas-inspeccion"
                      :viewTooltip="false"
                    ></r-input>
                  </ul>
                </f7-list>
                <f7-list
                  class="searchbar-found searchbar-found-defectos fichas-defectos no-hairlines"
                >
                  <ul>
                    <li
                      v-for="(comprobacion, idx) in getComprobacionesConDatos()"
                      :key="'datos-comprobacion-' + idx"
                      class="card margin elevation-4"
                    >
                      <div class="card-header row align-items-center">
                        <div class="col-80">
                          <span class="display-inline-block">{{ comprobacion.codigo }} - {{comprobacion.nombre}}</span>
                        </div>
                      </div>
                      <div class="card-content item-row">
                        <div class="item-cell">
                          <div class="item-row">
                            <r-input
                              :form="rform"
                              outline
                              placeholder="Observaciones"
                              type="textarea"
                              :name="comprobacion.ruta + '.observaciones'"
                              class="width-100 textoAzul"
                              :allMayus="true"
                            ></r-input>
                          </div>
                          <div class="item-row">
                            <r-files
                              :mostrarCheck="isImage"
                              :mostrar-agrupador-documento="mostrarAgrupadorDocumentoInspeccion"
                              :class="{ 'width-100': target != 'cordova' || readonly, 'width-70': target == 'cordova' && !readonly }"
                              class="overflow-auto"
                              :prefixKey="comprobacion.ruta"
                              :form="rform"
                              :name="comprobacion.ruta + '.documentos'"
                              :documentoAdapter="target == 'cordova' ? DocumentoOffline : Documento"
                              :offlinePath="Utils.getInspeccionPath(`Documentos/Comprobaciones/${comprobacion.codigo}`, rform.formData) "
                            ></r-files>
                            <f7-list v-if="!readonly">
                              <f7-list-item
                                v-if="target == 'cordova'"
                                title="Capturar foto"
                                @click="Utils.capturarFoto(rform, comprobacion.ruta + '.documentos', Utils.getInspeccionPath(`Documentos/Comprobaciones/${comprobacion.codigo}`, rform.formData), $set)"
                                link="#"
                              >
                                <f7-icon
                                  slot="media"
                                  material="add_a_photo"
                                  color="primary"
                                ></f7-icon>
                              </f7-list-item>
                              <f7-list-item
                                v-if="target == 'cordova'"
                                title="Grabar vídeo"
                                @click="Utils.grabarVideo(rform, comprobacion.ruta + '.documentos', Utils.getInspeccionPath(`Documentos/Comprobaciones/${comprobacion.codigo}`, rform.formData), $set)"
                                link="#"
                              >
                                <f7-icon
                                  slot="media"
                                  material="video_call"
                                  color="primary"
                                ></f7-icon>
                              </f7-list-item>
                              <f7-list-item
                                v-if="target == 'cordova'"
                                title="Grabar audio"
                                @click="Utils.grabarAudio(rform, comprobacion.ruta + '.documentos', Utils.getInspeccionPath(`Documentos/Comprobaciones/${comprobacion.codigo}`, rform.formData), $set)"
                                link="#"
                              >
                                <f7-icon
                                  slot="media"
                                  material="mic"
                                  color="primary"
                                ></f7-icon>
                              </f7-list-item>
                            </f7-list>
                          </div>
                        </div>
                        <div class="item-after align-items-center padding" v-if="!readonly">
                          <a
                            class="link eliminar-observacion"
                            @click="eliminarObservacion(comprobacion)"
                            v-tooltip="'Eliminar Observación y documentos de la comprobación ' + comprobacion.codigo"
                          >
                            <i class="f7-icons">trash</i>
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </f7-list>
              </f7-tab>

              <f7-tab id="tab-documentos" class="page-content no-padding">
                <template v-if="documentosOpened">
                  <div class="item-row">
                    <f7-list>
                      <r-files
                        :mostrarCheck="isImage"
                        :mostrar-agrupador-documento="mostrarAgrupadorDocumentoInspeccion"
                        class="width-100 overflow-auto"
                        :form="rform"
                        name="documentos"
                        :documentoAdapter="target == 'cordova' ? DocumentoOffline : Documento"
                        :offlinePath="Utils.getInspeccionPath('Documentos/Generales', rform.formData)"
                      ></r-files>
                    </f7-list>
                    <f7-list v-if="!readonly">
                      <f7-list-item
                        v-if="target == 'cordova'"
                        title="Capturar foto"
                        @click="Utils.capturarFoto(rform, 'documentos', Utils.getInspeccionPath('Documentos/Generales', rform.formData), $set)"
                        link="#"
                      >
                        <f7-icon
                          slot="media"
                          material="add_a_photo"
                          color="primary"
                        ></f7-icon>
                      </f7-list-item>
                      <f7-list-item
                        v-if="target == 'cordova'"
                        title="Grabar vídeo"
                        @click="Utils.grabarVideo(rform, 'documentos', Utils.getInspeccionPath('Documentos/Generales', rform.formData), $set)"
                        link="#"
                      >
                        <f7-icon
                          slot="media"
                          material="video_call"
                          color="primary"
                        ></f7-icon>
                      </f7-list-item>
                      <f7-list-item
                        v-if="target == 'cordova'"
                        title="Grabar audio"
                        @click="Utils.grabarAudio(rform, 'documentos', Utils.getInspeccionPath('Documentos/Generales', rform.formData), $set)"
                        link="#"
                      >
                        <f7-icon
                          slot="media"
                          material="mic"
                          color="primary"
                        ></f7-icon>
                      </f7-list-item>
                    </f7-list>
                  </div>
                </template>
              </f7-tab>

            </f7-tabs>
          </f7-tab>
        </f7-tabs>
      </div>
    </template>
  </r-form>
  <r-form
    ref="rformCliente"
    v-slot="{rform}"
    :itemId="null"
    @save="onSaveNuevoCliente"
    :readonly="readonly"
    :dbAdapter="ClienteOffline"
    :defaultData="{direcciones:[]}"
  >
    <f7-popup ref="popupNuevoCliente" class="popup-nuevo-cliente" swipe-to-close>
      <f7-page>
        <f7-navbar title="Contacto Cliente">
          <f7-nav-right></f7-nav-right>
        </f7-navbar>

        <!-- <div style="height: 100%" class="display-flex justify-content-center align-items-center"> -->
        <f7-card class="elevation-3 padding-vertical-half padding-right">
          <f7-card-content>
            <f7-list class="list-form" style="z-index:30">
              <ul>
                <f7-row>
                  <r-input
                    class="col-50"
                    floating-label
                    :label="$t('clientes.razonSocial')"
                    :form="rform"
                    :name="'razonSocial'"
                  ></r-input>
                  <r-input
                    class="col-50"
                    floating-label
                    :label="$t('clientes.nif')"
                    :form="rform"
                    :name="'nif'"
                  ></r-input>
                  <r-direccion
                    class="col-100"
                    :form="rform"
                    :name="'direccionDefectoFacturasDTO'"
                    :guardarCodigos="true"
                    autocomplete="off"
                  >
                  </r-direccion>
                </f7-row>
              </ul>
            </f7-list>

          </f7-card-content>
          <f7-row>
            <f7-col width="100" medium="100">
              <f7-button
                fill
                icon-f7="save"
                :text="$t('inspeccionesOffline.guardar_cliente')"
                class="display-flex margin-left"
                color="green"
                @click="$refs.rformCliente.saveItem()"
              ></f7-button>
            </f7-col>
          </f7-row>
        </f7-card>
        <!-- </div> -->
      </f7-page>
    </f7-popup>
  </r-form>

    <!-- v-if="$refs.rform && $refs.rform.formData && $refs.rform.formData.estado && $refs.rform.formData.estado.estado == 'PENDIENTE_FIRMA_INSPECTOR'" -->
  <r-form
    ref="rformCertificadoFirmado"
    v-slot="{rform}"
    @save="adjuntarCertificado"
    :dbAdapter="null"
    :readonly="false"
    :defaultData="{documentos: []}"
    :documentoAdapter="Documento"
  >
    <f7-popup ref="popupAdjuntarCertificado" class="popup-aceptacion" style="height:274px;" swipe-to-close>
      <f7-page>
        <f7-navbar >
          <f7-nav-left></f7-nav-left>
          <f7-nav-title v-if="!firmado">
            {{$t('inspecciones.popup_certificado.certificadosinfirmar')}}
          </f7-nav-title>
          <f7-nav-title v-else>
            {{$t('inspecciones.popup_certificado.certificadofirmado')}}
          </f7-nav-title>
          <f7-nav-right></f7-nav-right>
        </f7-navbar>

        <!-- <div style="height: 100%" class="display-flex justify-content-center align-items-center"> -->
      <f7-card
        class="elevation-3 padding-vertical-half padding-right padding-left"
      >
          <f7-card-content>
            <r-files 
              :mostrarCheck="isImage"
              :mostrar-agrupador-documento="mostrarAgrupadorDocumentoInspeccion"
              :form="rform" 
              :name="'documento'"
              :documentoAdapter="Documento"
              :label="!firmado ? $t('inspecciones.popup_certificado.anadircertificadosinfirma') : $t('inspecciones.popup_certificado.anadircertificadofirmado')"
              :maxFiles="1"
            ></r-files>
          </f7-card-content>
          <f7-row>
            <f7-col width="100" medium="100">
              <f7-button
                  fill
                  icon-f7="cloud_upload_fill"
                  text="Cargar Documentos"
                  class="display-flex margin-vertical"
                  color="green"
                  @click="enviarCertificadoFirmado($refs)"
                ></f7-button>
            </f7-col>
          </f7-row>
      </f7-card>
        <!-- </div> -->
      </f7-page>
    </f7-popup>
  </r-form>
  <f7-popup class="popupCargarPlantilla" v-if="popupCargarPlantillaOpened" :opened="true" @popup:closed="popupCargarPlantillaOpened = false;" ref="popupCargarPlantilla" >
    <r-list
      :dbAdapter="Plantilla"
      :tableMode="false"
      class="page"
      classContent="page-content list no-hairlines no-margin"
      :shownFields="['id', 'nombre']"
      :classList="['media-list', 'no-margin']"
      sortDir="DESC"
      sort="_id"
      :virtualListParams="{ height: 54 }"
    >
      <template v-slot:before>
        <f7-navbar title="Selecciona la plantilla">
          <f7-link slot="right" popup-close icon-f7="multiply"></f7-link>
        </f7-navbar>
      </template>
      <template v-slot:default="{vlData, rlist}">
        <f7-list-item
          :link="'#'"
          @click="cargarPlantilla(item.id)"
          :title="item.nombre"
          v-for="(item, idx) in vlData.items"
          :key="'plantilla-' + idx"
          class="listaPlantillas"
        >
          <f7-button
          icon-f7="trash"
          color="red"
          @click.stop="rlist.deleteItem(item.id)"
          ></f7-button>
        </f7-list-item>
      </template>
    </r-list>
  </f7-popup>
  <f7-popup class="popupCargarHistorico" v-if="popupCargarHistoricoOpened" :opened="true" @popup:closed="historico = []; popupCargarHistoricoOpened = false;" ref="popupCargarHistorico" >
    <f7-page>
      <f7-navbar>
        <f7-nav-left></f7-nav-left>
        <f7-nav-title>
          {{$t('Histórico de inspección')}}
        </f7-nav-title>
        <f7-nav-right></f7-nav-right>
      </f7-navbar>
      <f7-card
        class="elevation-3 padding-vertical-half padding-right padding-left"
      >
          <f7-card-content v-if="historico && historico.length">
            <div 
              v-for="(hist, idx) in historico"
              :key="'historico-' + idx"
              style="border: solid 1px black; display: flex; justify-content: space-between; padding: 10px;"
            >
              <div>{{hist.date}} - {{ hist.file }}</div>
              <f7-button
                fill
                icon-f7="cloud_download"
                color="green"
                @click="cargaHistorico(hist)"
              ></f7-button>

            </div>
          </f7-card-content>
      </f7-card>
    </f7-page>
  </f7-popup>

  <!-- Modal de errores de auditoría manual -->
  <f7-popup ref="popupErrores" class="popupErrores" >
    <f7-page>
      <f7-navbar>
        <f7-nav-left></f7-nav-left>
        <f7-nav-title>
          {{$t('inspecciones.popupauditoria.erroresAuditoria')}}
        </f7-nav-title>
        <f7-nav-right v-if="!popupReadOnly">
          <f7-link 
            @click="auditoriaManual($refs.rform.formData,$refs.rformErrores.formData.erroresAuditoria);$refs.popupErrores.close()"
          >
            {{$t('common.guardar')}}
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <r-form 
        ref="rformErrores" 
        classContent="full-height"
        :readonly="readonly"
        :defaultData="{erroresAuditoria:[]}" 
      >
        <template v-slot:default="{ rform }">

        <!-- Errores -->
          <f7-block-title>
            {{$t('inspecciones.popupauditoria.erroresAuditoria')}}
            <f7-link v-if="!popupReadOnly" @click="rform.formData.erroresAuditoria.push('')">{{$t('common.anadir')}}</f7-link>
          </f7-block-title>
          <div 
            style="z-index: 30"
            v-for="(item,index) in rform.formData.erroresAuditoria"
            :key="'erroresAuditoria-'+index"
          >
            <f7-card
              class="elevation-3 padding-vertical-half padding-right"
            >
              <f7-card-content>
                <f7-list 
                  class="list-form"
                >
                  <ul>
                    <f7-row no-gap >
                      <r-input
                        class="col-100"
                        floating-label
                        :label="$t('inspecciones.popupauditoria.descripcionerror')"
                        :form="rform"
                        :text="item"
                        :name="'erroresAuditoria.' + index "
                        :readonly="popupReadOnly"
                        :overrideReadonly="true"
                      ></r-input>
                    </f7-row>
                  </ul>
                </f7-list>
              </f7-card-content>
              <f7-link
                v-if="!popupReadOnly"
                @click="$delete(rform.formData.erroresAuditoria,index);"
                class="margin-half"
                style="position:absolute;right:0;top:0;"
                icon-f7="trash"
              ></f7-link>
            </f7-card>
      
          </div>
        </template>
      </r-form>
    </f7-page>
  </f7-popup>
  <!-- Modal de errores de auditoría manual -->
  <asignar-formato ref="popupAsignarFormato" :inspeccion="inspeccion" :guardar="false" @finished="reloadPage"/>

  <f7-popup
    v-if="popupNoCalificacion"
    @popup:closed="popupNoCalificacion = false"
    :opened="true"
    ref="popupNoCalificacion"
  >
    <f7-page>
      <f7-navbar title="Opciones de cierre de la inspección">
        <f7-nav-right>
          <!-- <f7-link
            @click="$refs.popupProxInspOpened.close()"
            icon-f7="multiply"
          ></f7-link> -->
        </f7-nav-right>
      </f7-navbar>
      <f7-block class="inspeccion-no-realizada">
        <span v-if="$refs.rform && $refs.rform.formData && !$refs.rform.formData.calificacion" style="color: #11113d;">
          Indique una calificación para la inspección antes de finalizarla.
          <hr/>
        </span>
        En caso de no querer guardar cambios, pulse el Botón <b>"Salir sin guardar"</b>
      </f7-block>
      <f7-row>
        <f7-col width="100" medium="50" small="100">
          <f7-button
              fill
              text="Finalizar la inspección"
              class="display-flex margin-vertical margin-left margin-right size-medium"
              :disabled="$refs.rform && $refs.rform.formData && !$refs.rform.formData.calificacion"
              @click="nocalificacionEstadoSesion('finalizado')"
          ></f7-button>
        </f7-col>
        <f7-col width="100" medium="50">
          <f7-button
              fill
              text="Guardar cambios y pausar la inspección"
              class="display-flex margin-vertical margin-left margin-right size-medium"
              @click="nocalificacionEstadoSesion('pausado')"
          ></f7-button>
        </f7-col>
      </f7-row>
      <f7-row>
        <f7-col width="100" medium="50">
          <f7-button
              fill
              text="Salir sin pausar la inspección"
              class="display-flex margin-vertical margin-left margin-right size-medium"
              @click="guardar(() => nocalificacionNoRealizada())"
          ></f7-button>
        </f7-col>
        <f7-col width="100" medium="50">
          <f7-button
              fill
              text="Permanecer en la inspección"
              class="display-flex margin-vertical margin-left margin-right size-medium"
              color="green"
              @click="nocalificacionOk"
          ></f7-button>
        </f7-col>
      </f7-row>
    </f7-page>
  </f7-popup>
  <f7-popup 
    v-if="popupHistoricoEstadosOpened" :opened="true" @popup:closed="popupHistoricoEstadosOpened = false"
    ref="popupHistoricoEstados" 
    class="popupHistoricoEstados"
  >
    <f7-page>
      <f7-navbar>
        <f7-nav-left></f7-nav-left>
        <f7-nav-title>
          {{ $t('inspecciones.inspeccion_form.historicoEstados') }}
        </f7-nav-title>
      </f7-navbar>
      <template>
        <f7-list class="">
          <f7-row no-gap style="text-align:center;font-weight: bold;" class="list_popup row-header">
            <span class="col-30">{{ $t('inspecciones.inspeccion_form.estado') }}</span>
            <!-- <span class="col-30">{{ $t('inspecciones.inspeccion_form.observaciones') }}</span> -->
            <span class="col-30">{{ $t('inspecciones.inspeccion_form.usuario') }}</span>
            <span class="col-30">{{ $t('inspecciones.inspeccion_form.fecha') }}</span>
          </f7-row>
          <f7-row
            no-gap
            v-for="(item, index) in getHistoricoEstados()"
            :key="'historicoEstados-' + index"
            :class="'list_popup ' + (index % 2 == 0 ? 'row-even' : 'row-odd')"
          >
            <select
              v-if="$refs.rform.username == 'NOID' && !$refs.rform.readonly"
              class="col-30"
              @change="setEstado($refs.rform.formData.historicoEstados[index],$event.target.value)"
            >
              <option value></option>
              <option v-for="(e,ie) in getListaEstados()" 
                :selected="item.estado == e.nombre"
                :key="'historicoEstados-' + index + '-'+ie" 
                :value="e.nombre"
                :style="{ color: getColorBadgeEstado(e.nombre) }"
              >{{e.texto}}</option>
            </select>
            <r-input
              v-else
              class="col-30"
              type="badge"
              name="estado"
              :readonly="true"
              :overrideReadonly="true"
              :text="getTextoBadgeEstado(item.estado)"
              :color="getColorBadgeEstado(item.estado)"
            ></r-input>
            
            <!-- <f7-list-input
              :value="item.observaciones"
              v-tooltip="item.observaciones"
              :readonly="true"
              class="col-30"
              type="text"

            /> -->
            <f7-list-input
              :value="item.username"
              v-tooltip="item.username"
              :readonly="$refs.rform.username !== 'NOID'"
              @change="$refs.rform.formData.historicoEstados[index].username = $event.target.value"
              class="col-30"
              type="text"
            />
            <f7-list-input
              :value="DateUtils.dateFormat(item.fecha, 'DD/MM/YYYY HH:mm')"
              v-tooltip="DateUtils.dateFormat(item.fecha, 'DD/MM/YYYY HH:mm')"
              :calendar-params="{ closeOnSelect: true, routableModals: false, dateFormat: { year: 'numeric', month: '2-digit', day: '2-digit' } }"
              :readonly="$refs.rform.username !== 'NOID'"
              @change="setDate($refs.rform.formData.historicoEstados[index].fecha , $event.target.value)"
              class="col-30"
              type="text"
            />
            <div v-if="$refs.rform && $refs.rform.username == 'NOID'">
              <!-- Botón de eliminar fila de estado -->
              <f7-link @click="eliminarElementoHistoricoEstados(item, index)" icon-f7="trash" color="red" class="r-input-little"></f7-link>
            </div>
            
          </f7-row>
        </f7-list>
      </template>
    </f7-page>
  </f7-popup>

  <f7-popup ref="popupTareaAuditoria" swipe-to-close :opened="true" v-if="popupTareasAuditoriaOpened" @popup:closed="onCerrarPopupTareaAuditoria">
    <tarea-form :id="tareaAuditoriaId" linea="" :editable="popupTareaAuditoriaEditable" @close="$refs.popupTareaAuditoria.close();"  
      :defaultData="dataTareaAuditoria" :esPopup="true" @save="onTareaAuditoriaGuardada"
    ></tarea-form>
  </f7-popup>

  <listado-tareas
    v-if="verListadoTareas"
    :filterName="codigoExpediente?'codigoExpediente':'idExpediente'"
    :filterValue="codigoExpediente||idExpediente"
    entityField="expediente"
    tableCode="TAREASINSPECCION"
    :shownFields="['codigoExpediente', 'tipo', 'estado', 'descripcion']"
    @listado-cerrado="verListadoTareas = false"
  ></listado-tareas>

  <!-- Mostramos un popup con el mensaje de "Se ha detectado una configuración de hora incorrecta, por favor, compruebe que la hora de su dispositivo está en modo automático" -->
  <f7-popup 
    tablet-fullscreen
    ref="popupFechaHoraIncorrecta"
    v-if="avisoFechaHoraAutomaticos" 
    :opened="true" 
    @popup:closed="avisoFechaHoraAutomaticos = false;verifyTimeZone()" 
    :close-on-escape="false"
    :swipe-to-close="false"
  >
    <f7-page>
      <f7-navbar title="Configuración de hora incorrecta">
      </f7-navbar>
      <f7-block class="text-align-center">
        <p>{{$t('inspecciones.inspeccion_form.horaIncorrecta')}}</p>
      </f7-block>
    </f7-page>
  </f7-popup>

  <f7-popup :opened="popupItemEnriquecidoOpened" @popup:closed="popupItemEnriquecidoOpened = false" class="popup-item-enriquecido">
    <f7-page>
      <f7-navbar title="Item enriquecido sincronizado desde el expediente">
        <f7-nav-right>
          <f7-link popup-close>Cerrar</f7-link>
        </f7-nav-right>
      </f7-navbar>
      <div class="item-enriquecido-popup-content">
        <p class="text-color-gray no-margin-top">
          El item enriquecido se ha creado o actualizado a partir de los datos del expediente.
          Aquí tienes el JSON resultante (solo lectura). Puedes abrir la ficha para revisar o editar.
        </p>
        <textarea
          v-model="itemCanonicoPropuesto"
          class="item-enriquecido-textarea"
          spellcheck="false"
          readonly
        ></textarea>
        <div class="item-enriquecido-actions">
          <f7-button color="gray" @click="popupItemEnriquecidoOpened = false">Cerrar</f7-button>
          <f7-button fill color="blue" @click="copiarItemEnriquecidoAlPortapapeles">
            <i class="f7-icons" style="font-size:16px;margin-right:6px;">doc_on_clipboard</i>
            Copiar JSON
          </f7-button>
          <f7-button fill color="green" v-if="itemEnriquecidoSyncedId" @click="abrirFichaItemEnriquecido">
            Abrir ficha del item
          </f7-button>
        </div>
      </div>
    </f7-page>
  </f7-popup>

</f7-page>
</template>
<style>
/***********/
.userprofile {
  padding-top: 14px;
  height: 90px;
  background-color: var(
    --f7-navbar-bg-color,
    var(--f7-bars-bg-color, var(--f7-theme-color))
  );
}
@media (min-width: 768px) {
  .userprofile {
    height: 128px;
    padding-top: 52px;
  }
}
.userprofile img {
  width: 72px;
  z-index: 99999;
  border-radius: 50%;
}
.md .userprofile::before {
  content: "";
  position: absolute;
  right: 0;
  width: 100%;
  top: 100%;
  bottom: auto;
  height: 8px;
  pointer-events: none;
  background: var(--f7-navbar-shadow-image, var(--f7-bars-shadow-bottom-image));
}
.calificacion .item-label, .calificacion .item-input-wrap input, .calificacion .item-input-focused .item-label {
  font-size: large;
  font-weight: bold;
  color: var(--f7-theme-color);
}
.calificacion .item-label {
  text-align: right;
  margin-right: 20px;
  margin-top: 3px;
}
.listaPlantillas .item-link .item-content .item-inner {
  display: flex;
}

#tab-instalacion .textoAzul .list input[type="text"],
#tab-instalacion .textoAzul .list textarea,
#tab-instalacion .textoAzul .list input[type="number"],
#tab-instalacion .textoAzul .list select
{
  color: blue;
  border: solid 1px  lightblue;
  text-transform: uppercase;
}

#tab-instalacion .textoAzul .list .tabla-personalizada .celda:not(.header),
#tab-instalacion .textoAzul .list .tabla-dinamica .v-table .v-table-body
{
  color: blue;
  text-transform: uppercase;
}
#tab-expediente .list .bordeAzul .item-input-outline input,
#tab-expediente .list .bordeAzul .item-input-outline textarea {
  color: blue;
  padding: 5px;
  text-transform: uppercase;
}
#tab-expediente .bordeAzul .item-input-outline .item-input-wrap:after {
  border-color: lightblue;

}
#tab-cliente .list .bordeAzul .item-input-outline input {
  color: blue;
  text-transform: uppercase;
}
#tab-cliente .bordeAzul .item-input-outline .item-input-wrap:after {
  border-color: lightblue;
}
#tab-cliente .list .outlineAzul .CP input[type="text"],
#tab-cliente .list .outlineAzul .Direccion input[type="text"]{
  color: blue;
  border: solid 1px  lightblue;
  border-radius: 3px;
  padding: 10px;
  padding-left: 5px;
  text-transform: uppercase;
}
#tab-cliente .list .outlineAzul .CP .item-floating-label,
#tab-cliente .list .outlineAzul .Direccion .item-floating-label {
  padding-left: 5px;
}
#tab-defectos .list .textoAzul textarea {
  color: blue;
  text-transform: uppercase;
}
#tab-notas .list .textoAzul textarea {
  color: blue;
  text-transform: uppercase;
}
#tab-notas .list .textoAzul textarea,
.notas-inspeccion,
.notas-inspeccion * {
  height: 100%;
}
.controlesCamara {
  position: absolute;
  bottom: 20px;
  left: 250px;
  display: flex;
}
.controlesCamara .link, .controlesCamara .icon{

  font-size: 40px;
  margin: 20px;
}
.sesiones {
  border: 1px solid grey;
}

.msg-error {
  display: inline-flex;
}

.regla {
  border: 2px dashed #eff1ff;
  margin: 0 0 2px 0;
  padding: 2px;
}


</style>
<style scoped>
/* .button i.icon {
  top: 7px;
  align-content: center;
} */
.bg-transparent {
  background: transparent;
}
.bg-white {
  background: white;
}
.inspeccion-no-realizada {
  font-weight: bold;
  font-size: 20px;
  text-align: center;
}
.hidden {
  visibility: hidden;
}
.w-99 {
  width: 99%;
}
.menu-item-dropdown .menu-item-content:after {
  content: inherit !important;
}
.accordion-item-opened .accordion-item-toggle .item-media {
  color: var(--f7-theme-color) !important;
}
.label-group {
  margin-top: 12px;
  margin-left: 20px;
  font-weight: bold;
}
.label-radio {
  width: var(--f7-radio-size);
  text-align: center;
}
label.radio.disabled,
label.item-checkbox.disabled {
  opacity: 1 !important;
}
.radio input[type="radio"]:not(:checked) ~ * {
  opacity: 0.2;
}

.page-content::after {
  content: "";
  opacity: 0.5;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
}
.list ul {
  background: rgba(255, 255, 255, 0.7);
}

.tab-link-active {
  background-color: var(--f7-theme-color-shade) !important;
}

.accordion-item {
  background-color: #f3f3f3;
}
.accordion-item-content {
  background-color: white;
}

.size-medium {
  font-size: medium;
}

.row-even {
  background-color: #dff7f7;
}
.row-odd {
  background-color: #ffffcd;
}
.row-header {
  background-color: #23355b;
  font-weight: bold;
  color: #d8d6c1;
}
.r-input-little {
  margin: 0;
  padding: 5px;
}

.inicio-sesion, .fin-sesion {
  margin-left: 10px;
  padding: 0px;
  border-radius: 5px;
  border: 1px solid gray;
  display: inline-flex;
}

/* Opción beta "Generar item enriquecido" en el dropdown */
.item-enriquecido-beta {
  color: #ff9800 !important;
  font-weight: 600;
}
.item-enriquecido-beta-tag {
  display: inline-block;
  margin-left: 4px;
  padding: 1px 6px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #fff;
  background: #ff9800;
  border-radius: 3px;
  vertical-align: middle;
}

/* Popup "Generar item enriquecido" */
::v-deep .popup-item-enriquecido .page-content {
  padding: 16px;
}
.item-enriquecido-popup-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  box-sizing: border-box;
}
.item-enriquecido-textarea {
  flex: 1 1 auto;
  min-height: 320px;
  font-family: ui-monospace, "Cascadia Code", Consolas, monospace;
  font-size: 13px;
  padding: 10px 12px;
  border: 1px solid #c5dbff;
  border-radius: 6px;
  resize: vertical;
  background: #fff;
}
.item-enriquecido-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  flex-wrap: wrap;
}
</style>
<script>
import rForm from "./../../components/rForm.vue";
import rPanel from "./../../components/rPanel.vue";
import rInput from "./../../components/rInput.vue";
import rRichTextInput from "./../../components/rRichTextInput.vue";
import rList from "./../../components/rList.vue";
import rFiles from "./../../components/rFiles.vue";
import rCheckbox from "./../../components/rCheckbox.vue";
import rAutocomplete from "./../../components/rAutocomplete.vue";
import rBadge from "./../../components/rBadge.vue";
import rAutocompleteM2m from "./../../components/rAutocompleteM2m.vue";
import rTimepicker from "./../../components/rTimepicker.vue";
import rDireccion from "./../../components/rDireccion.vue";
import AsignarFormato from "./components/AsignarFormato.vue";
import BloqueTutorPracticas from "./components/BloqueTutorPracticas.vue";

import InspeccionOffline from "./../../js/db/InspeccionOffline.js";
import Plantilla from "./../../js/db/PlantillaOffline.js";
import Inspeccion from "./../../js/db/Inspeccion.js";
import ItemEnriquecido from "./../../js/db/ItemEnriquecido.js";
import DatabaseModel from "./../../js/db/DatabaseModel.js";
import DatabaseModelOffline from "../../js/db/DatabaseModelOffline";
import Formato from "./../../js/db/Formato.js";
import FormatoOffline from "./../../js/db/FormatoOffline.js";
import ClienteOffline from "./../../js/db/ClienteOffline.js";
import Cliente from "./../../js/db/Cliente.js";
import Item from "./../../js/db/Item.js";
import EquipoOffline from "./../../js/db/EquipoOffline.js";
import InspectorOffline from "./../../js/db/InspectorOffline.js";
import Inspector from "./../../js/db/Inspector.js";
import Comprobacion from "./Comprobacion.vue";
import Caracteristica from "./Caracteristica.vue";
import Elemento from "./Elemento.vue";
import Documento from "./../../js/db/Documento";
import DocumentoOffline from "./../../js/db/DocumentoOffline";
import Utils from "./../../js/Utils";
import DateUtils from "./../../js/DateUtils";
import EntityUtils from "../../js/EntityUtils.js";
import moment from 'moment';
import * as nominatim from 'nominatim-client';
import { EventBus } from "../../js/EventBus";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";
import TareaForm from "./../tareas/tarea-form.vue";
import ListadoTareas from "../../components/listado-tareas.vue";

// import * as pdfjsLib from 'pdfjs-dist';


export default {
  components: {
    rForm,
    rInput,
    rRichTextInput,
    rList,
    rFiles,
    rCheckbox,
    rTimepicker,
    rDireccion,
    AsignarFormato,
    BloqueTutorPracticas,
    rPanel,
    rAutocomplete,
    rBadge,
    rAutocompleteM2m,
    Comprobacion,
    Caracteristica,
    Elemento,
    TareaForm,
    ListadoTareas,
    moment,
  },
  data() {
    return {
      // #975 · Sube con cada guardado de la inspección: el bloque del tutor relee entonces los
      // participantes, que la API toma de la planificación guardada.
      guardadosTutor: 0,
      Inspeccion,
      InspeccionOffline,
      Plantilla,
      DatabaseModelOffline,
      ClienteOffline,
      Cliente,
      Formato,
      FormatoOffline,
      Item,
      EquipoOffline,
      Inspector,
      InspectorOffline,
      Utils,
      DateUtils,
      EntityUtils,
      codigoComprobacionOpened: "",
      rPanelOpenedByBreakpoint: false,
      readonly: !this.editable,
      datetimeStart: new Date(),
      vlDataDefectos: [],
      popupTabs: {},
      inspeccion: {},
      popupOpen: false,
      target: process.env.TARGET,
      Documento,
      DocumentoOffline,
      flagCaracteristicas: false,
      intervalReload: null,
      intervalJson: null,
      tiempoNoActivo: 0,
      popupReadOnly: true,
      caracteristicasInicializadas: false,
      popupCargarPlantillaOpened: false,
      popupCargarHistoricoOpened: false,
      popupItemEnriquecidoOpened: false,
      itemCanonicoPropuesto: "",
      itemEnriquecidoSyncedId: null,
      historico: [],
      tabActive: 'Expediente',
      nominatim,
      autoscript: null,
      precargaForzada: false,
      documentosOpened: false,
      popupProxInspOpened: false,
      popupNoCalificacion: false,
      infoPeriodicidadMessage: false,
      popupTareasAuditoriaOpened: false,
      popupTareaAuditoriaEditable: false,
      tareaAuditoriaId: null,
      dataTareaAuditoria: {},
      verListadoTareas: false,
      idExpediente: null,
      codigoExpediente: null,
      iniciado: false,
      firmado: null,
      popupHistoricoEstadosOpened: false,
      cameraOpened: false,
      tareaAuditoriaGuardada: false,
      tareaAuditoriaCreada: null,
      tareaAuditoriaAnterior: null,
      imagenFirmaBase64: "/9j/4AAQSkZJRgABAQEASABIAAD/4Ra4RXhpZgAASUkqAAgAAAAHABIBAwABAAAAAQAAABoBBQABAAAAYgAAABsBBQABAAAAagAAACgBAwABAAAAAgAAADEBAgANAAAAcgAAADIBAgAUAAAAgAAAAGmHBAABAAAAlAAAAKYAAABIAAAAAQAAAEgAAAABAAAAR0lNUCAyLjEwLjI4AAAyMDIyOjAzOjI0IDE2OjE0OjUyAAEAAaADAAEAAAABAAAAAAAAAAkA/gAEAAEAAAABAAAAAAEEAAEAAAAAAQAAAQEEAAEAAABOAAAAAgEDAAMAAAAYAQAAAwEDAAEAAAAGAAAABgEDAAEAAAAGAAAAFQEDAAEAAAADAAAAAQIEAAEAAAAeAQAAAgIEAAEAAACSFQAAAAAAAAgACAAIAP/Y/+AAEEpGSUYAAQEAAAEAAQAA/9sAQwAIBgYHBgUIBwcHCQkICgwUDQwLCwwZEhMPFB0aHx4dGhwcICQuJyAiLCMcHCg3KSwwMTQ0NB8nOT04MjwuMzQy/9sAQwEJCQkMCwwYDQ0YMiEcITIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIy/8AAEQgATgEAAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/aAAwDAQACEQMRAD8A8Q0LRbvxFrdrpFgEN1dPsj8xtq5wTyfwr0L/AIZ+8cf3NO/8Cf8A61YHwk/5Kp4f/wCvg/8AoDV9l0AfKf8Awz944/uad/4E/wD1qgu/gX4usLZrm8m0i2gXAaWa9CKMnAySMdSBX0X428b6d4K0o3FyRLdyDFvaq2GkPqfRfevmfxR4y1jxbftcajcsY8ny7dDiOMZOAB+PU81tSoSqa9DKpVUPU5288MPZTPE+q6bIy9fJkdwenQhcd/0qmmjuxYG7t1weM7+f/Hav0V1LCwOd4mRo6H8ONT8RSiLTdT0iSY5xE1yUc49AyjPX+fpXRf8ADP3jj+5p3/gT/wDWrjVdkYMjFWByCDgivV/h98YLzSrmHTfEUzXGmnCLcMMyQYHHTll6e/8AI5VMK0rx1NYYhPSRzX/DP3jj+5p3/gT/APWo/wCGfvHH9zTv/An/AOtX1TFLHPEksTq8bqGV1OQwPQg0+uQ6D5T/AOGfvHH9zTv/AAJ/+tR/wz944/uad/4E/wD1q+rKKAPlP/hn7xx/c07/AMCf/rUf8M/eOP7mnf8AgT/9avqyigD5T/4Z+8cf3NO/8Cf/AK1H/DP3jj+5p3/gT/8AWr6sooA+U/8Ahn7xx/c07/wJ/wDrUf8ADP3jj+5p3/gT/wDWr6sooA+U/wDhn7xx/c07/wACf/rUf8M/eOP7mnf+BP8A9avqyigD5T/4Z+8cf3NO/wDAn/61H/DP3jj+5p3/AIE//Wr6sooA+U/+GfvHH9zTv/An/wCtR/wz944/uad/4E//AFq+rKKAPlP/AIZ+8cf3NO/8Cf8A61H/AAz944/uad/4E/8A1q+rKKAPlP8A4Z+8cf3NO/8AAn/61H/DP3jj+5p3/gT/APWr6sooA+U/+GfvHH9zTv8AwJ/+tR/wz944/uad/wCBP/1q+rKKAPlI/s/+NwCdmnf+BP8A9avLmUoxU9QcGvv1vuH6V8Cz/wDHxL/vn+dAHYfCT/kqnh//AK+D/wCgNX2Je3cNhYz3lw22GCNpHPooGTXx38JP+SqeH/8Ar4P/AKA1fRXxo1FrD4dXMaMytdzRwcemdx/RaqMeaSQpOyufPvi3xLd+K/ENzql0xw52xR54jjH3VH+eazNP0+71W/hsbGB57mZgkcaDkmq1e/fAnwzHb6PceIp4j9ouXMNux7Rj7xH1bj/gNenUkqUNDghF1Jakfhj4D2UUCz+JLuSedhn7NbNtRPYt1b8MfjXQz/BTwZNCyJbXcLHo8dwdw/PI/SvRKK891qjd7naqcErWPmLx18KNT8IwG/t5ft+mg/NIqYeL03j09x+lee19tzwRXVvJbzxrJDKpR0cZDKRggivkPxroI8NeL9R0pSTFDJmIn+4wDL+hFdeHrOfuy3OatSUdUerfAzxg80c3he8cnylM1mT6Z+Zf1yPx9q9qr4/8EalLpPjbR7uIkFbpEYDurHaw/EE19gVz4mHLO66m1CXNHUKKK474l+Lbjwf4Ta9s0U3c0oghZhkISCd2O+ADWEYuTsjVtJXZ17OiY3Mq59TinV8yeHfh/wCK/Htk2rNqASBnYpLdysTI+eSAM9+/r+Nek/DLwp4y8Na5eJrd0ZNM8nEa/aPMV5CV+YDqMAEcgVrOkop+9qRGbfTQ9SorwP4mXt1B8Y9LiiuZo42+y5RHIBy+DxXo/wAWZ5rf4a6rJBK8TjygGRiCP3i9xS9n8PmNT38jtaK+afhR45uNF8Ux2eo3kj2F9iJjLISI3/hbnpzwfY+1fS1KpTdN2YQmpq6CivmT4p+OrjXvFUkGn3MsVhY5hjMbFfMbPzNweckcewFe2/C+R5fhvo0kjs7tG5ZmOST5jd6c6ThFSfUUailJxXQ66ivlLQ9P8ReLfE11pun6tOkwMkmZrlwMA+ozXW/8Kh8ff9ByH/wMl/wq3RjHRyEqjeyPoCgkAEk4A6muYW9Pgf4fQz61ctcSWFqiyuvJd+AFGevJAz+NeHQ3fjv4rancpa3Mi2i/fjEpigiU9Acdf1NRClzXd9EVKfLp1PpZZEc4V1Y+gOadXztP8F/GWmQNc2OoW8023LRwTsjHOMjJAB/PtXq3hu81vQvhwL3xNI0uoQoz4lOXwThFY9znHvzSqRjGPMpXBTfVWOzpFdXGVYMPY5rxi3/4Sfxxes6XDFYhgsW8uNPbA7n8+npSal4V8ReG7Vb0y/ulIZ3t5T+7IIwT0745rg+tO3Mouxn7Z2uo6HtNFcZ4M8Q3es+Hb77XNvurbIEgGCVK5BOO+Qea81+Bt7dXXjXU1uLmaVRZMQJJCwB8xPWuyklUpua2LVRO1up7433D9K+BZ/8Aj4l/3z/OvvpvuH6V8Cz/APHxL/vn+dI0Ow+En/JVPD//AF8H/wBAavevj0pbwJakdF1CMn/viQV8+fDW+i034iaNezhjFBKzsFGSQEbpXv8A498T6L4r8FXmm27zpdOFkiV48DcrA4J56jNEasKdRczsZ1GuVps+da+pfg/cxT/DPTEjcM0JljkH91vMY4/Jgfxr5uTw7qrjP2XA9S6/416X8LtevvBZvLXUrZ5NOnxIBFgukg47kDBHX6CuvE4ijKGk195y0JqMtT6AorjYviXoTj51u4vZoh/Qmr9n468PXsgjW+ETliAJUKg8ZznoB16kfqK4FWpvaSOtVIvqdHXy58Y5Fk+JmpbW3bUiU+x8teK9/wDFvjTS/CmiSXs9xE87R5toFbLSsQdvA/h46+1fJ+pX9xq+p3OoXTb7i4kaWQ+55rvwkHfm6GWIkuXlJtABPiPTAOv2uL/0MV9nV8rfCjQm1zx/YZUmGzP2qU44wvTP1bAr6ppYt+8kGHXu3CuG+K/hi98U+Djb6cvmXNtMLhYu8mAwIHvhv0ruagur21sYxJd3EUEbMFDSuFBJ7ZNc8ZOLujdpNWZ84eC/itqngq0TRr3T1ubKF2xG2Y5Y8nJAP1ycEfjXufhPxto3jGzMumzETIMy20nEkf4dx7j9OlTeIPB+heJreSPUtPhkkZSFnVQJEPqG9vfivn/wPA2gfGa3060uzNHFdyWxlXgSoAw6ZPXHvXQ1Cqm0rNGN5U2k9UbXxR/5LRpX/br/AOjDXpfxf/5Jjq31i/8ARi15p8Uf+S0aV/26/wDow16X8X/+SY6t9Yv/AEYtD/5dgvtng0fhWS8+Gi+JbVWaSzvpIbgDqI9qFW/Bif8AvoeldrcfFqST4Ux2izY1tj9ikY5LGML/AKzOeDjAzzzn8Oo+CFvDd/De9triMSQzXsqSI3RlMaAiuOh+COr/APCZfZ5YyNAE5P2oTJvMXUDbnO49OlaOUHJqfRkqMkk49Ucdf+F5tL8BWWuXQZZdRuSIkP8AzyUcH8Tn8hX0N8K/+SZ6J/1yf/0Y1cb8eYYrbwvosEKLHFHOURFGAqhQABXZfCv/AJJnon/XJ/8A0Y1Z1ZOdNSfcuEVGdl2PAPCXi1PBnjC71R7Nrv8A1kYjEmzq3XODXo0f7Qdu0qK/hyVVLAEi7BIH02c1y3wnsbTUPiRdwXtrBcw+XMfLmjDrnd1wa97/AOEV8O/9AHS//AOP/CqrSpqXvK5NNStozz747aiV8F6fbx7lW7ulc84yqqTgj6kH8K2vg3YpZ/DexlXG66kkmfA77iv48KKpfHHTGvfAa3UaZayuUkY88Icqf1K/lUfwQ8QW194OGjmdftdg7/ujwfLZtwI9Rkn6flWe9DTuX/y9+R6fVXUbS0vtPmt79Fe1YfvAzbRgHPXt0qyzBVLMQFAySe1cV8RNUK+FYzZTq8N1MI2kiYEMoByMj3FclSSjBtlzaUW2U7fxh4X8MxPZaTb3EyFyzsnQn6scmsvW/iQ2qadc2NvpgjSZShd5Nxwe+ABg/jVrwH4S0nU9K/tK+X7TJ5jKItxCpjHUDqf0wa3vFcekaB4WvUgtre3kuUMUaxoAzk/0HX/9dci9rKnzXSVjD33C97I574a/8g3Xf+ua/wAnrivgN/yO+qf9eTf+jErtfhqf+Jbro/6Zr/J64r4Df8jvqn/Xk3/oxK7cD/uz/rqKG0PmfQbfcP0r4Fn/AOPiX/fP86++m+4fpXwLP/x8S/75/nTOo6v4W28d38S9Et5l3RSysjj1BRga9S8Q6HPoGry2koYx5zFIRgOvY15l8JP+SqeH/wDr4P8A6A1fWPiXw3a+ItPMMgCXCjMM2OVPofb2rnxND2sdN0ZVqfOtNzwfJxjJx6UlW9S0260m+ktLyIxyoe/Qj1HqKqV47TTszz2mtGKHYdGP507eDgOoPuODTKKLgZ+saNHqcYkVyJVGFY9PoRXEyRzWdyUdSksZ5Br02zVnvIo0iMpkcJ5Y6vk9KXxx4Fl0+78qcEAgm3uQOHHof8K9fAY6VNctTWH5f8AqzauWfhP448PeG4p7S6tnguLuVTJcbsjA4AA9Bkn157161d/EDw7a2vnJe/aGIBWKJTuPT1wB17+hr5Zm0PUYZCn2dnHZk5BrrPA/gy71TWYI5AQ5OcdREvdjXZiHTS54TvfZb/qawrSS5UfS+mX8Wqabb30KuscybgHGCK5H4meBr3xvptpFZagltJauziOXOyQnaMkjOCAGxwevau1t4EtbaK3iGI4kCKPQAYFSVMJONn1O1q6sz51T4dfE6zWO0t7uZYG3cR3+EXPJyM9yT+Oa7T4a/CibwzqI1nWpYZb5VIhijJIiJGCSehOCR3HfNerUVrKtJqxCpxTueS+OPh/ruvfEex1yxihazg8jeWlAb5GyeK7P4g6HeeI/BN/penqjXU3l7A7bQcOpPP0Brp6Kj2j08iuRa+ZxPwt8L6j4S8JyafqYiFw9082I33AKVUDn1+U121FFTKTk7saVlZHAfFfwhqfi/RbKDShG00E5ZlkcKNpXrk/QfnW94G0e68P+C9M0u+CC5t42EgRsjJYnr+NdDRTc248vQOVXufOkfwq+IGm6rcXmmNHbyOzYlhuwhKk5x61e/wCEL+Lv/QWuP/Bl/wDXr32itfby6pGfsl0bMXSNLuH8H2ml68RdTtaiK63nduOMEE9z7+2a8e1f4I65pepC68L6kHTcTHvkMUsXX+IcHsMjH0r3uiojUlF6Fygpbnzv/wAK7+J+pRyWt5eziAthhPfllbtnGTkV6V4e+HB03wCfD9/e+dcPKZxImSkUmBwucZHXrjOT0rvqKVSo6keV7EqnFHjkfhHxjpjzQ2QnjRjgvbXWwNz1BBB7VoweAte1hZLnWr1llCN5Ubyb2LEEjJ5CjOP1r1KiuNYWC0u7diVQicT4K8LajoltqiX3loblVRArbugbn/x79K8osfhX8Q9JupbjTHS0kkBVnhvAhK5zg4r6NorqoP2MeWOxXso2S7HgX/CFfFs8Nq84U9SdR7fnXgd4wa9nYdDIxHy7e/oOlffDfcP0r4Fn/wCPiX/fP86qdRy3KjHlOw+En/JVPD//AF8H/wBAavsuvga1u7mxuY7m0uJbe4jOUlicqyn2I5Fa/wDwmvir/oZdY/8AA6T/AOKqCj7L1/w5Y+IbURXSESJny5U4ZT/h7V5Hrvg/VNDuNrQvcQNkpPEhKkD1/un2PvjODXiH/Ca+Kv8AoZdY/wDA6T/4qj/hNfFX/Qy6x/4HSf8AxVYVsPCrq9zKpSjM9PIx1qSGCW5mWGCN5JHOFVBkk15Rb+K9dtpWkXU55HYkkzkTZJzk/ODzyaE8W+IopXkh1vUIGfG7yLhowcdOFIH/AOuuVYF31ehisM77n1d4L8EDSduo6kqte/8ALOPqIvf3P8q7C9sbXUbZra8gSaFuqsP84r4l/wCE18Vf9DLrH/gdJ/8AFUf8Jr4q/wChl1j/AMDpP/iq7oU4wjyrY6YwUVZH1lcfDXQJiSn2qDOf9XKP/Zga6DSdE0/RLcw2FusSk5Zs5Zj7k18W/wDCa+Kv+hl1j/wOk/8AiqP+E18Vf9DLrH/gdJ/8VRGnCLukChFO6R9xUV8O/wDCa+Kv+hl1j/wOk/8AiqP+E18Vf9DLrH/gdJ/8VVlH3FRXw7/wmvir/oZdY/8AA6T/AOKo/wCE18Vf9DLrH/gdJ/8AFUAfcVFfDv8Awmvir/oZdY/8DpP/AIqj/hNfFX/Qy6x/4HSf/FUAfcVFfDv/AAmvir/oZdY/8DpP/iqP+E18Vf8AQy6x/wCB0n/xVAH3FRXw7/wmvir/AKGXWP8AwOk/+Ko/4TXxV/0Musf+B0n/AMVQB9xUV8O/8Jr4q/6GXWP/AAOk/wDiqP8AhNfFX/Qy6x/4HSf/ABVAH3FRXw7/AMJr4q/6GXWP/A6T/wCKo/4TXxV/0Musf+B0n/xVAH3FRXw7/wAJr4q/6GXWP/A6T/4qj/hNfFX/AEMusf8AgdJ/8VQB9xUV8O/8Jr4q/wChl1j/AMDpP/iqP+E18Vf9DLrH/gdJ/wDFUAfcVFfDv/Ca+Kv+hl1j/wADpP8A4qj/AITXxV/0Musf+B0n/wAVQB9wt9w/SvgWf/j4l/3z/Otn/hNfFX/Qy6x/4HSf/FVhEknJOSaAP//Z/+EMdWh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8APD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNC40LjAtRXhpdjIiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1sbnM6R0lNUD0iaHR0cDovL3d3dy5naW1wLm9yZy94bXAvIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1wTU06RG9jdW1lbnRJRD0iZ2ltcDpkb2NpZDpnaW1wOmVlNGE3YWQ3LTVlZmEtNGQ2Ni04NzQwLTNlYmRhYmNmZmYzOSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo5MTEyMjMzZS1lYjk2LTQzNzktOGM3ZC04NzZiOTYxYzBjYmYiIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpmNGYxZmRhYy02NjE5LTRhMzYtOTk0YS00Y2ZmOWExMjU4YzUiIEdJTVA6QVBJPSIyLjAiIEdJTVA6UGxhdGZvcm09IldpbmRvd3MiIEdJTVA6VGltZVN0YW1wPSIxNjQ4MTM0ODkyMjM5NDU5IiBHSU1QOlZlcnNpb249IjIuMTAuMjgiIGRjOkZvcm1hdD0iaW1hZ2UvanBlZyIgeG1wOkNyZWF0b3JUb29sPSJHSU1QIDIuMTAiPiA8eG1wTU06SGlzdG9yeT4gPHJkZjpTZXE+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJzYXZlZCIgc3RFdnQ6Y2hhbmdlZD0iLyIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDplZWQ3M2NiZC02ZGFlLTRjNjctODgxYi1jNzVjZGU0NjRiMWYiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkdpbXAgMi4xMCAoV2luZG93cykiIHN0RXZ0OndoZW49IjIwMjItMDMtMjRUMTY6MTQ6NTIiLz4gPC9yZGY6U2VxPiA8L3htcE1NOkhpc3Rvcnk+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAg" +
                    "ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDw/eHBhY2tldCBlbmQ9InciPz7/4gKwSUNDX1BST0ZJTEUAAQEAAAKgbGNtcwQwAABtbnRyUkdCIFhZWiAH5gADABgADgAwABxhY3NwTVNGVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA9tYAAQAAAADTLWxjbXMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1kZXNjAAABIAAAAEBjcHJ0AAABYAAAADZ3dHB0AAABmAAAABRjaGFkAAABrAAAACxyWFlaAAAB2AAAABRiWFlaAAAB7AAAABRnWFlaAAACAAAAABRyVFJDAAACFAAAACBnVFJDAAACFAAAACBiVFJDAAACFAAAACBjaHJtAAACNAAAACRkbW5kAAACWAAAACRkbWRkAAACfAAAACRtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACQAAAAcAEcASQBNAFAAIABiAHUAaQBsAHQALQBpAG4AIABzAFIARwBCbWx1YwAAAAAAAAABAAAADGVuVVMAAAAaAAAAHABQAHUAYgBsAGkAYwAgAEQAbwBtAGEAaQBuAABYWVogAAAAAAAA9tYAAQAAAADTLXNmMzIAAAAAAAEMQgAABd7///MlAAAHkwAA/ZD///uh///9ogAAA9wAAMBuWFlaIAAAAAAAAG+gAAA49QAAA5BYWVogAAAAAAAAJJ8AAA+EAAC2xFhZWiAAAAAAAABilwAAt4cAABjZcGFyYQAAAAAAAwAAAAJmZgAA8qcAAA1ZAAAT0AAACltjaHJtAAAAAAADAAAAAKPXAABUfAAATM0AAJmaAAAmZwAAD1xtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAEcASQBNAFBtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEL/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wgARCAB6AZADAREAAhEBAxEB/8QAGwABAAMBAQEBAAAAAAAAAAAAAAMEBQIBBgj/xAAXAQEBAQEAAAAAAAAAAAAAAAAAAQID/9oADAMBAAIQAxAAAAH9UgAAAAAAAAAAAAAAAAAAAAAAAAAAFczbKpyTF2NFegAAAAAAAAAAAAAAAAAAAAZaZNngABOu9LMAAAAAAAAAAAAAAAAAAADPTEsHa3zuKtVEEy/Ry9AAAAAAAAAAAAAAAAAAA8PmbI0sLvyyAGcmLYNeXUUACE9JTg6PDkkAISY4OAdnYID0mB4RSSW9HB0egAFRPn7B9DLaUADAsppZX6KUAZKQV0asuclo8MWvpZeyimHX1UuLZwSFuLa4Nk4LkSxmZzMVpNfe8+rpbUADOTFs9PqpoAAZaZFki/TygD56zalnBkJaPDLqybEvz1kZ9NLi2aMWVGYg01Ap5zYtkto5zwQat0tqABQTDs9Pp5rsAAx0zLJl+llAFRMerBsS5aWjwgKtSk8Z9fRy4tkB2akUKuxcUCKTNzmM5i3qw6t0tqAPCI+buRqS6ke2+g4Pm7I0vruSgADJT05LR4QF0xq+gl+ds+jlxbNGLKjJSY0FAw8Y09as20M54IdW6W1AGZnOfnPh0dHoWWpraO7WT0+hlsqAMpJyhV2IC0eEBqqB85Z9HLi2SxMTL0YVmpA9KeM3LZLc3ObdsOr0TlhZwcmFz5xAAAntjK3SjSluxwXrRAVUlLi10kXw5JwCmlxaxCgmWyRFRPS4qSlJ0WbfDm2BBYWcAhkw8Y5AABathKu75XprYamtAAAAAAAAAAAAAAAAAAQSY2MRgAGhrWhbk5zVLZr730AAAAAAAAAAAAAAAAAADiTMzmlJ4el/WtTWgAAAAAAAAAAAAAAAAAAAAAByRySL1QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH/xAAnEAACAgEDBAIDAAMAAAAAAAACAwEEABASMxETFCAyUCEiMSMwYP/aAAgBAQABBQL7djxVh3CnJcc53DwbLBwLsTkTBR9VYtdPdbSVKmw0fqLTtkaCEnI0inPBw6xhqpkqIZ3R9NM9IM954lUtIAhca2K26NKTPx6y0ByGgWhHAZEwUTMDAsEvTuhoRiOd4M7wYJiWsuCMhwTrMxGd0MgoLQjEMiesetotqdKwbFetoNjcrltd6W3T1XVJkFTOMSMiu9/anDc4RLYQHvHLTdgaXeRdWWB4RZXrymTKAE2m8hpFOFSKMqgQC9vbEQN0+IWSJKJLO4F351eD1u8f+i9oHz9LMdHJODDS9/anDc4Vr3rqN2lM9IKZsNYOxmXeStwaXS/FIPxq5EsJYdsMt/Cnl351eD1uR/i0Atwet0v2xUdWej0d7CWaZXcIcEoMb39qcNzho5YX2mOsb1U1dIfzZd5BNsDvfleSld351ODVjIXBWinO4w8JZxFPLvzq8Hp1xo716VHdM3RnXUzgBM95ZTDqz2tpgYozl7+1OG5w0ccvugtBEcfjH82XeStwaXoykXVery3NUkRHLc/pTy786vB6Ww/PXTrm6M6jn6ZG7BskOOcTZ0rr7S/QrciyLgZYsd3Ka9o3v7U4bnDR9H82XeRNoQX5oYp4tly+6AkSDG4E4V0YyvYls2B2sVZHaVkIwyJuU8u/NNkVr80MU6G6lG6GB2y9oZ1w19NV3OmeUvIswZ6GkGZ4Q4FUA0akXYtcLFi4YKkwn0KqBljUC2fCDPCDFIFU4axZk0gyKYYIQEEEHE1IwagxkriQWqF41AtzwgzwgxSYV6NXDBIZGfZM9carZOtRf0zVQ2DCQn1rK6yYQyDrEObMXWksiNsfTEEHDKsxkx00/uKrdfr5GJzshkDA/wDOf//EAB4RAAICAgIDAAAAAAAAAAAAAAERABBAUCAxMHCA/9oACAEDAQE/AfiIzuLYKzBr3Y1xswcz4HnmOOhiOPKUWEJ1wGtFLVrgvRv/xAAeEQACAgMBAAMAAAAAAAAAAAABEQAQMUBQIDBwgP/aAAgBAgEBPwH8RGZioc5WYOe7HONmD2fge+Y46GhjfUWkJjoilGZnkrwvo3//xAArEAACAAQEBgIBBQAAAAAAAAAAAQIQESESIDFxIjJBUWGBUJGhMEJSYMH/2gAIAQEABj8C+Xvr2OGxzM5n9nNXc4lQqr/F4YPvPYqvicK1c6JVLuhz/g7rxOpVfD1G5UKLJih1m4M14kWiUruhVXKuxaJPJzKV2kc6+znX2Wac+ZHMp3OZFnWV2kWzPzNd3fN4cocuBeyuiLXEotSGXsTQmpU6ua2FFVHMhtuo2z/C7SLNMeL6PLO/lmqOzPJDsQ5lv+jBKHfLEKk4ZeyN9UYXoypuNdpLYhnDCOLJWolJbkRDsQ5vc080KlDvl7RHbyji4kVWhDL2RltHoQrr1Mb66EW8lscOKh+76OPXyQ7CyXLWNX6MUREQ7EOaJTwP0arJVjicq9s+JWIkQy9kZTr0KNNKUW8lsQzhY12yMVquSREQ7EOVRT0OVHL+TqjgjqUjRfTtPzlapY6lFoOJ9SGXsjyRbyWwoXU6lqlDyXqiybGmh+SkVmdxxdCIh2FC6nUdJ0ZTPSK6O67zpFfyaiSU7o1Z33kqlEUY6dcmK8qupqzVlqy4lU1Z1ZZUKMtEXdTD0HQuas1Y6ZKFHnwRaMo8mL4bz3KPNiehRn8kaF7Iovh6M4brJWL6+PuqnKiyp/XP/8QAKBABAAIBAwMDBQEBAQAAAAAAAQARIRAxUSBBcWGBsVCRocHx8GDh/9oACAEBAAE/Ifq+9L4N5swP3Zu/tNQLTIMR5hLwA5PpdlTPeFtty9VxeO52Z3Mdzj6Tn3m9DW6JekEx+GY8IH3XrahJ9zmCeQfo4MtjMZnu6Utg7vEprR0Eg13h31sR2ydTlCeLjtIeL0oq7csvADkl4AcsTpjgejPWfzp+Rx1UqxxnDptN2+9Nj+9qLkHmf2ptB4OlJnOWAShHudX2g192Dqtq5NLhy10iu1yhlo21w22enaJ5cfhs2vLPgRtxELbTpi//AJ9HDAh0gCFisTZSJUc07GBey7wL2HaZpBeFNm9KIn3QxwzK+0kzTsw6R8z56nojLAorqGF50deB0pa8y32QpONfw2bXlnwJTHZZ7RHmAywEx3uoOCEHsq17/HzrXzMsEbutHQaFcVTA4HQF3eNnt0j5nz1XB41etZfVdwS9Kv6OkQI0bMviMGA/Yhh7U/DZteWfAn6JnMMnolM7psdzDw6C4oeho0q7Wy0Z8not27sTZgJ2y+EqY8Zcz9OkfM+elA0oM59TGpC2u6Z/egHZHVE1BG3w6ehz1bwae6kIvp4Z+Gza8s+BP1S98kHu5CkAAMB0F3+PnXL5ycorob0OCIiO6ulXdLP06R8z56Vo7bMEd3QHGf0mc32xl/efrV0/aK5P4Z2CG2ir2lIO7L05/S1XeJM09pTDo5z3iGK7fE/DZteWfAn6usuDyxwT0ftioqTmWvfueZt+hhGCYJ94FmftCcFZKiu7ZEoEoxfMFw34CMKYfifp0g6LHBPR+2Bq+OdRXIMdV7PPXQ9+7kxe5sIlQabMMYU+DeCF/GXlx7uvM/JvHtnFrpejdEriA769ZkXXpBsr6uhymzlL0FUkKxP6s/qxU3LzoNh9URsMPu+5K8QlWbJayHkiGT8ZjyvRN3c8xEbicT+rP6sDF889FqYezEYUnWa3vxsT7YxK0C5Vb8H0bKMDaKe11cJNpWT34m1Hgm6rXGsPPvDAKD6PVGyZPwu8RUlProCqC2OjCQFFG307YTyNM248D/nP/9oADAMBAAIAAwAAABCSSSSSSSSSSSSSSSSSSSSSSSSSSSYyDySSSSSSSSSSSSSSSSSSSSTv/wD4Ekkkkkkkkkkkkkkkkkkkn/l8/kkkkkkkkkkkkkkkkkkkkE4kkf8A5JJBIIJJIJBBAIPIBJJH+5JJPJJOIO/hOgJfBIwP43JJH2JJI+JJIpO+AJAHI3JG5w3JJH2JJJ+JJOJO+4fAAOfJH4o3JII3nJBPJJIH++/JAHJ3JIB43JJJe3rB75JO4++5JAG9J354A25JPJJINbNJJ3OIJI5m9I2GX2mxJH5JJBvz5JJJJJJJJJJJJJJJJJJXJJA+nJJJJJJJJJJJJJJJJJJJO5BBJJJJJJJJJJJJJJJJJJJJJJI1JJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJP/EACARAAMAAgIDAQEBAAAAAAAAAAABERAgITEwQVBRQGD/2gAIAQMBAT8Q+xS4pfmX6L0hCfTayv7avE8rZ4WrITDEPR5ZCaQghoRizlCdQxbPwvd6MQ8LHeWLLFo6EpjpixbPwvw3DEMQ8I94eORDFo3CitjT7eLF4Uy7rdiGIYsTHvDFli0bkSSx0xYtU96VHBwc+mUuy3wUo2IYhi094eLnopRCciT2QOvnFlLq1N7+nWaQdtITwzMJpCYauKQnEEpiE1ao1N/wzsJ3PLn4zVGpsnsao2XRWJN9/Iao/wAaL9fQi/zv/8QAIBEAAwACAQUBAQAAAAAAAAAAAAERECAhMDFBUFFAYP/aAAgBAgEBPxD3EzCesS9itKUvs08v9tXSWXssPVFLhDFosopRvNKMaEYs5Q1Qh7LordDyhiw8dsoeUPR0JRY7cUPZdFb3EwhiGIg8rHAxD0bhRWxp93ih9Fl3e6GIYh4uiHlD0bkSSx24oeqedeDg58MX0KeMvWEEhiGIeyIQmO5CDQkYk8kDbfOKITVqb36JsJ3EaKXnSl6NxSlLmlw1cUhOIJTFLq1Rqb/DOWE08NwXLvpmqNTZPI1Sl2wR93qGqP40X17CIk/nP//EACkQAQACAAQEBgMBAQAAAAAAAAEAESExQVEQYaGxIHGBkdHwweHxUGD/2gAIAQEAAT8Q/wBcavXH9Iqm7n+HSPX9Y0ilh+r5iRiGwH9xgt/PPbOGlnJLP8tMBuB6cj5iMimKub4s9RmwAvQwXNf5KBULEfTHjyOmMvOFHk4tHrMef7RxWGeLXpnxxiTLabRbqdj/AI7G0CnkTO3urY0OAPCcdt8wics3Vd3wFtHHJfvxZp+Hqfd/E+FM8RIQXssz24FLS1RcELOSWRQM5pRMEx3QXwc7lVXgqCrkEXP5qfzUVCuaprgoFUA1YvVvYt2jtPXRp3g2WcLALuqlbXRQKytweHKEqi5l5WSx8SDGlHvz6DxNNUNnnke3iFBoamzr178EvqLPrh4VTyGBm3pMailFqb1GVH0YusYSZjbdcvSfacuGs2D0U9kTLButnU4Ys1gFaan8QzhkTovdgwBUEbMan81lAkgB3il0dvPlCRslZX9+cErDoxEULnqQ4ugMyrNlUVcC2nOG1UZjAiFh3a34hUoMUZ+THHP8DXnOtd51Xc8TA6P4vAUG7AAZBR4j3tjtwsRmJ18NRs0HlRHAqOpQcftOXDWbBSN1huY2fdpeNi3fT9o4oJVdCYJN2L6c5ohgusMidF7s6R7uLCODfSy7wjruToGf3l4ATUwDCGBFGKauvBzqrg8qb/EWBpa7zrXedV3PE5+mvsnDKAQ2H4hmuLL1/nBRdfavwnQDWimzME2ybD3I2DzMh8yrRLGfacuGs2H3+sXH1XGrU9IrmhunLT1zlct401PrOvQyJ0XuxhKNWnac73Pia5OFKa+3G1afNgDmNvd8Bt7WTmxR2thbMtY8jtDAguK5T7/Wda7zqu54RyRkLSymMfcDE6xKac5UR0uOAHMg+SeidDB40fl78iZ3jdbGhwZ0Zi+bgfnxIBEsdGD3exm9YoRsUmziP4n2nLhrNh9frDwemJsy1+rcAILQCgNCdehkTovdnSPdxXAYUr1PzAtM3XJ/d+C1HB1bVHYAEV48oAFGEGwzPoH7n3+s613nVdzwgsFHlbTIg8mYXaXB6nmvzAc0+m8v0POO9w0Vt8D+ISjZ2v3EW2JyhYtsMj5eAqAVyolJu/7enhUgWuwwa3LZb2bQkF1nMo1BIo7Nes+05cNZsPr9fB16GROi92JpmihWa7z+O+YGwNoQw94VuGddBEKLaMm0E76Kp7xpsCykT0Cw4BlTHAY92+/WKdBMBSEq+gg6sdlgmGWwmb7azrXeNr32gmKu8/jvmBibghrPiO1OkmLmZ7Dx1YuSdu/hiXWDvLP75RHTEJEMRIeWTD8jeYlDkq455lKUnpxcsny3ujWwNrH8Qqwsr2e0yl4TXpdZyzIVbVqxvUaNqkYUJqWu8v74CNVoCnpwWzEh1Z7T+C+J/BfETYGlY4e3CtUGWRPWKXyWx/EVvlyA6E3p1WvmysnS3PKKwBtZ8QI8qyRs9uYahNia2q8ovhNC6wn8F8T+C+I3DuKu8vArwHHbZrpkeNfiLDoJGpWZ6aR3TwRUZy8TALd3V/xqrsRp+oysNHR8vE5HSYXV3i28aDNbkZXnpx9SLxA2Uw8rrIxeRKqCoP8AHRh52Z5RFfoHzESizBTwMITIC1gR65rfPaAQACgNP84uiNgYo30oTXlwf85//9k=",
      // clipboard: false
      accordionOpened: false,
      currentLocation: false,
      intervalLocation: null,
      watchLocationId: null,
      // Guarda de reentrada del inicio de sesion manual: entre la pulsacion y el alta de la
      // sesion hay varios await (compatibilidad, geolocalizacion, geocodificacion inversa)
      // durante los cuales el boton seguia siendo pulsable -> se abrian sesiones duplicadas.
      iniciandoSesion: false,
      avisoFechaHoraAutomaticos: false,
    };
  },
  props: {
    id: {
      type: String,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    nuevo: {
      type: Boolean,
      default: false,
    },
    offline: { type: Boolean },
    formato: {
      type: String,
    },
    provincia: {
      type: String,
    },
  },
  computed: {
    editableAdminDtycal: function() {
      const self = this;
      return !self.readonly && Utils.getUser() && Utils.getUser().roles && (Utils.getUser().roles.indexOf('ADMIN') >= 0 || Utils.getUser().roles.indexOf('DTYCAL') >= 0);
    },
    editableAdminDtycalInspector: function() {
      const self = this;
      return !self.readonly && Utils.getUser() && Utils.getUser().roles && (Utils.getUser().roles.indexOf('ADMIN') >= 0 || Utils.getUser().roles.indexOf('DTYCAL') >= 0 || Utils.getUser().roles.indexOf('INSPECTOR') >= 0);
    },
    botonEditarVisible:function() {
      const self = this;
      return self.readonly && self.offline && self.$refs.rform && self.$refs.rform.formData && self.$refs.rform.formData.estado && (self.$refs.rform.formData.estado.estado == 'GENERADO' || self.$refs.rform.formData.estado.estado == 'PLANIFICADO');
    }
  },
  methods: {
    /**
     * Sincroniza el item enriquecido a partir del expediente (sectorial-first / respaldo FIJ-MOV-PRV).
     * Es idempotente: si el expediente ya tiene un item asociado, lo actualiza; si no, lo crea.
     * El backend persiste inmediatamente y devuelve el ItemEnriquecidoDTO resultante.
     */
    abrirGenerarItemEnriquecido(expediente) {
      const self = this;
      if (!expediente || !expediente.id) {
        self.$f7.dialog.alert("El expediente debe estar guardado para generar el item enriquecido.");
        return;
      }
      self.itemEnriquecidoSyncedId = null;
      self.itemCanonicoPropuesto = "// Sincronizando item enriquecido, espera un momento…";
      self.popupItemEnriquecidoOpened = true;
      const url = ItemEnriquecido.server_movilidad + ItemEnriquecido.prefix + ItemEnriquecido.model
                + "/sync-from-expediente/" + encodeURIComponent(expediente.id);
      ItemEnriquecido.sendRequest({ url: url, method: "POST", data: {} }, false)
        .then(function(res) {
          const item = (res && res.dto) ? res.dto : res;
          if (!item || !item.id) {
            self.itemCanonicoPropuesto = "// El backend no devolvió un item (¿materia del expediente no mapeada a tipo? revisa logs).";
            return;
          }
          self.itemEnriquecidoSyncedId = item.id;
          self.itemCanonicoPropuesto = JSON.stringify(item, null, 2);
        })
        .catch(function(err) {
          const msg = (err && (err.message || err.error)) || "Error sincronizando el item enriquecido";
          self.itemCanonicoPropuesto = "// ERROR: " + msg;
        });
    },
    /** Devuelve solo el bloque JSON del textarea, descartando las líneas de notas `// ...`. */
    _stripJsonComments(raw) {
      if (!raw) return "";
      return raw.split("\n").filter(l => !/^\s*\/\//.test(l)).join("\n").trim();
    },
    copiarItemEnriquecidoAlPortapapeles() {
      const self = this;
      const text = self._stripJsonComments(self.itemCanonicoPropuesto || "");
      const onOk = () => {
        try {
          self.$f7.toast.create({
            text: "JSON copiado al portapapeles",
            icon: '<i class="f7-icons">checkmark_alt</i>',
            position: "center",
            closeTimeout: 1500,
            destroyOnClose: true
          }).open();
        } catch (e) { /* noop */ }
      };
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(onOk).catch(() => self._copiarFallback(text, onOk));
      } else {
        self._copiarFallback(text, onOk);
      }
    },
    _copiarFallback(text, onOk) {
      // Fallback para navegadores sin Clipboard API (Cordova WebView antiguo)
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); onOk && onOk(); } catch (e) { /* noop */ }
      document.body.removeChild(ta);
    },
    abrirFichaItemEnriquecido() {
      if (!this.itemEnriquecidoSyncedId) return;
      this.popupItemEnriquecidoOpened = false;
      // Nueva pestaña/ventana para no perder el contexto del expediente. La ruta de la ficha es
      // /view/:id/ — sin el "view" cae en el listado, que no espera un id y da error.
      window.open("#!/itemsenriquecidos/view/" + encodeURIComponent(this.itemEnriquecidoSyncedId) + "/", "_blank");
    },
    mostrarAgrupadorDocumentoInspeccion: function (documento) {
      const self = this;
      const rform = self.$refs && self.$refs.rform ? self.$refs.rform : null;
      const formData = rform ? rform.formData : null;
      if (!formData) {
        return false;
      }
      const esInspeccionRelacionada = !!(formData.idExpedienteRelacionado || formData.idExpedienteAnteriorNegativo);
      if (!esInspeccionRelacionada) {
        return false;
      }
      const camposPersonalizados = documento && documento.camposPersonalizados ? documento.camposPersonalizados : {};
      const originId = camposPersonalizados.agrupadorId;
      const originCodigo = camposPersonalizados.agrupadorLabel;
      if (!originId && !originCodigo) {
        return false;
      }
      if (originId && formData.id) {
        return String(originId) !== String(formData.id);
      }
      if (originCodigo && formData.codigo) {
        return String(originCodigo) !== String(formData.codigo);
      }
      return false;
    },
    mostrarEnMapa: function (punto) {
      const url = 'https://maps.google.com/?q=' + punto.latitud + ',' + punto.longitud;
      if (typeof cordova !== 'undefined' && cordova.InAppBrowser) {
        cordova.InAppBrowser.open(url, "_system");
      } else {
        window.open(url, "_blank");
      }
    },
    getAccionSegunEstado: function(estado) {
      const self = this;
      if (estado) {
        switch (estado) {
          case "GENERADO":
          case "PLANIFICADO":
            return "sincronizar";
          case "INSPECCIONADO":
          case "AUDITADO":
          case "PENDIENTE_REVISION_CALIDAD":
          case "CORREGIR_ERRORES_AUDITORIA_CALIDAD":
          case "PENDIENTE_FIRMA_INSPECTOR":
            return "finalizar";
        }
      } else {
        return "";
      }
    },
    hayErrorsForLabel(rform, name) {
      return rform && rform.formData && rform.formData.listErrorsForLabel && rform.formData.listErrorsForLabel.filter(e => e.valor == name) && rform.formData.listErrorsForLabel.filter(e => e.valor == name).length
    },
    addSesionManual: async function () {
      const self = this;
      await self.ensureLocation();
      let sesionManual = {
        inicio: new Date(),
        fin: null,
        puntoInicio: self.currentLocation,
        puntoFin: null
      };
      // self.setLocationSesion(sesionManual, 'puntoInicio');
      self.$refs.rform.formData.sesionesManuales.push(sesionManual);
    },
    getHistoricoEstados: function () {
      const self = this;
      return [...self.$refs.rform.formData.historicoEstados || [], self.$refs.rform.formData.estado]
    },
    registrarTareaAuditoria: function (inspeccion) {
      const self = this;

      if (!self.$refs.rform || !self.$refs.rform.formData) {
        self.$f7.dialog.alert('No se pudo acceder a los datos de la inspección');
        return;
      }

      const expediente = inspeccion || self.$refs.rform.formData;

      // Preparar datos mínimos para la tarea
      const inspecciones = [{
        codigo: expediente.codigo || expediente.nombre || '',
        idExpediente: expediente.id || expediente._id || expediente.idExpediente || null,
        estado: expediente.estado ? expediente.estado.estado : null,
        formato: expediente.formato ? expediente.formato.codigo : null,
      }];

      self.dataTareaAuditoria = {
        inspecciones,
        estado: 'REALIZADA',
        username: Utils.getUser().username,
        empleados: [Utils.getUser().username],
        tipo: 'T0068', // Tarea de auditoría
        descripcion: 'Auditoría de inspección ' + (expediente.codigo || expediente.nombre || ''),
        fechaFecha: new Date(),
        fechaHora: new Date(),
        idExpediente: expediente.id,
        codigoExpediente: expediente.codigo,
        numeroPedido: expediente.numeroPedido,
        codigoPedido: expediente.codigoPedido,
        idPedido: expediente.idPedido,
        numeroLineaPedido: expediente.numeroLineaPedido || null,
        idCliente: expediente.cliente ? expediente.cliente.id : null,
        razonSocialCliente: expediente.cliente ? expediente.cliente.razonSocial : '',
        codigoCliente: expediente.cliente ? expediente.cliente.codigo : '',
        observaciones: expediente.observaciones || '',
      };

      // Abrir popup en lugar de nueva pestaña
      self.popupTareaAuditoriaEditable = true;
      self.tareaAuditoriaId = null;
      self.popupTareasAuditoriaOpened = true;

      // Toast de confirmación
      self.$f7.toast.create({
        text: `Abriendo tarea de auditoría para ${expediente.codigo || 'la inspección'}`,
        position: 'center',
        closeTimeout: 3000,
      }).open();
    },

    estadoAuditoria: function() {
      const self = this;
      const expediente = self.$refs.rform.formData;
      // si expediente no tiene tarea o tarea vacía, devolvemos SIN_INICIAR
      if(expediente && !expediente.tarea) {return 'SIN_INICIAR'}
      else if(expediente && expediente.tarea) {
        // si expediente tiene tarea y la tarea tiene alguna sesión abierta (sin fin) devolvemos SESION_ABIERTA
        if(expediente.tarea.sesiones && expediente.tarea.sesiones.find(s => s.inicio && !s.fin)) {
          return 'SESION_ABIERTA';
        }
        // si expediente tiene tarea y la tarea no tiene ninguna sesión abierta (sin fin) devolvemos SESION_CERRADA
        else {
          return 'SESION_CERRADA';
        }
      }

    },

    // Espejo de estadoAuditoria para la tarea de análisis de incompatibilidad (US #134, tipo T0086)
    estadoTareaIncompatibilidad: function() {
      const self = this;
      const expediente = self.$refs.rform.formData;
      if(expediente && !expediente.tareaIncompatibilidad) { return 'SIN_INICIAR'; }
      if(expediente && expediente.tareaIncompatibilidad) {
        if(expediente.tareaIncompatibilidad.sesiones && expediente.tareaIncompatibilidad.sesiones.find(s => s.inicio && !s.fin)) {
          return 'SESION_ABIERTA';
        } else {
          return 'SESION_CERRADA';
        }
      }
    },

    // Métodos de auditoría de expedientes
    iniciarAuditoria: function(expediente) {
      const self = this;
      const app = self.$f7;
      
      const dialog = self.$f7.dialog.confirm(
        '¿Deseas iniciar la auditoría del expediente?',
        'Iniciar Auditoría',
        () => {
          dialog.close();
          if (!self.$refs.rform) {
            self.$f7.dialog.alert('No se pudo guardar el expediente');
            return;
          }
          // Crear tarea de auditoría en el expediente
          let inicio = new Date();
          expediente.tarea = {
            estado: 'PLANIFICADA',
            tipo: { codigo: 'T0068'}, // Tarea de auditoría
            fechaFecha: inicio,
            fechaHora: inicio,
            horaInicio: inicio,
            sesiones: [{inicio: inicio, fin: null}],
            descripcion: 'Auditoría de inspección ' + (expediente.codigo || expediente.nombre || ''),
            username: Utils.getUser().username,
            empleados: [Utils.getUser().username],
            tiempoEstimado: null,
            idCliente: expediente.cliente ? expediente.cliente.id : null,
            idExpediente: expediente.id,
            codigoExpediente: expediente.codigo,
            numeroPedido: expediente.numeroPedido,
            codigoPedido: expediente.codigoPedido,
            idPedido: expediente.idPedido,
            numeroLineaPedido: expediente.numeroLineaPedido || null,
            idCliente: expediente.cliente ? expediente.cliente.id : null,
            razonSocialCliente: expediente.cliente ? expediente.cliente.razonSocial : null,
            codigoCliente: expediente.cliente ? expediente.cliente.codigo : null,
            observaciones: 'Auditoría iniciada por ' + Utils.getUser().username + ' el ' + inicio.toLocaleString(),
          };

          self.$refs.rform.formData.guardadoSilencioso = true;
          // #663 · La espera de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que la apagaba.
          const espera = preloaderDeLaSesion(self);
          espera.mostrar();
          // guardamos el expediente con este cambio. La espera se suelta también con
          // `guardadoTerminado`: `rForm` no emite `error` en todos sus fallos y esta promesa podría
          // no terminar nunca.
          Utils.async((resolve, reject) => {
            self.$refs.rform.$once('error', reject);
            self.$refs.rform.$once('guardadoTerminado', espera.cerrar);
            self.$refs.rform.saveItem(resolve);
          })
            .then((res) => {
              // Toast de confirmación
              self.$f7.toast.create({
                text: 'Auditoría iniciada',
                position: 'center',
                closeTimeout: 2000,
              }).open();
              self.$forceUpdate();
            })
            .catch((err) => {
              self.$f7.dialog.alert('Error al iniciar la auditoría: ' + (err && err.message ? err.message : 'Error desconocido'));
            })
            .finally(() => {
              self.$refs.rform.formData.guardadoSilencioso = false;
              espera.cerrar();
            });
          
        }
      );
    },
    
    pausarAuditoria: function(expediente) {
      const self = this;
      
      const dialog = self.$f7.dialog.confirm(
        '¿Deseas pausar la auditoría?',
        'Pausar Auditoría',
        () => {
          dialog.close();
          if (!self.$refs.rform) {
            self.$f7.dialog.alert('No se pudo guardar el expediente');
            return;
          }
          // Cerrar la sesión abierta (la última sesión sin fin)
          if (expediente.tarea && expediente.tarea.sesiones) {
            const sesionAbierta = expediente.tarea.sesiones.find(s => s.inicio && !s.fin);
            if (sesionAbierta) {
              sesionAbierta.fin = new Date();
            }
          }
          self.$refs.rform.formData.guardadoSilencioso = true;
          const espera = preloaderDeLaSesion(self);
          espera.mostrar();
          // Guardar expediente
          Utils.async((resolve, reject) => {
            self.$refs.rform.$once('error', reject);
            self.$refs.rform.$once('guardadoTerminado', espera.cerrar);
            self.$refs.rform.saveItem(resolve);
          }).then(() => {
              // Toast de confirmación
              self.$f7.toast.create({
                text: 'Auditoría pausada',
                position: 'center',
                closeTimeout: 2000,
              }).open();
              // Forzar actualización de la vista
              self.$forceUpdate();
            }).finally(() => {
              self.$refs.rform.formData.guardadoSilencioso = false;
              espera.cerrar();
            });
        }
      );
    },
    
    reiniciarAuditoria: function(expediente) {
      const self = this;
      
      const dialog = self.$f7.dialog.confirm(
        '¿Deseas reiniciar la auditoría? Se añadirá una nueva sesión.',
        'Reiniciar Auditoría',
        () => {
          dialog.close();
          if (!self.$refs.rform) {
            self.$f7.dialog.alert('No se pudo guardar el expediente');
            return;
          }
          // Añadir nueva sesión con inicio actual
          if (expediente.tarea && expediente.tarea.sesiones) {
            expediente.tarea.sesiones.push({
              inicio: new Date(),
              fin: null
            });
          }
          self.$refs.rform.formData.guardadoSilencioso = true;
          const espera = preloaderDeLaSesion(self);
          espera.mostrar();
          // Guardar expediente
          Utils.async((resolve, reject) => {
            self.$refs.rform.$once('error', reject);
            self.$refs.rform.$once('guardadoTerminado', espera.cerrar);
            self.$refs.rform.saveItem(resolve);
          })
            .then(() => {
              // Toast de confirmación
              self.$f7.toast.create({
                text: 'Auditoría reiniciada',
                position: 'center',
                closeTimeout: 2000,
              }).open();
              // Forzar actualización de la vista
              self.$forceUpdate();
            })
            .finally(() => {
              self.$refs.rform.formData.guardadoSilencioso = false;
              espera.cerrar();
            });
        }
      );
    },
    
    finalizarAuditoria: async function(expediente) {
      const self = this;
      
      const dialog = self.$f7.dialog.confirm(
        '¿Deseas finalizar la auditoría? Se creará la tarea.',
        'Finalizar Auditoría',
        async () => {
          dialog.close();
          if (!self.$refs.rform) {
            self.$f7.dialog.alert('No se pudo guardar el expediente');
            return;
          }
          // Cerrar la sesión abierta
          if (expediente.tarea && expediente.tarea.sesiones) {
            const sesionAbierta = expediente.tarea.sesiones.find(s => s.inicio && !s.fin);
            if (sesionAbierta) {
              sesionAbierta.fin = new Date();
            }
            
            // Calcular duración total (suma de todas las sesiones en milisegundos)
            let duracionTotal = 0;
            expediente.tarea.sesiones.forEach(sesion => {
              if (sesion.inicio && sesion.fin) {
                duracionTotal += new Date(sesion.fin).getTime() - new Date(sesion.inicio).getTime();
              }
            });
            
            // Convertir a minutos y poner en tiempoEstimado
            expediente.tarea.tiempoEstimado = Math.round(duracionTotal / 60000);
          }
          
          // Cambiar estado a REALIZADA
          if (expediente.tarea) {
            expediente.tarea.estado = 'REALIZADA';
          }

          self.dataTareaAuditoria = self.$refs.rform.formData.tarea;
          self.dataTareaAuditoria.tipo = 'T0068'; // Tarea de auditoría
          // Abrir popup en lugar de nueva pestaña
          self.popupTareaAuditoriaEditable = true;
          self.tareaAuditoriaId = self.dataTareaAuditoria.id;
          self.popupTareasAuditoriaOpened = true;

          // Registrar listener del EventBus para escuchar cuando se guarde la tarea
          EventBus.$on('tarea-guardada', self.onTareaGuardadaDesdeEventBus);
          
          // Marcamos que estamos esperando la finalización de la tarea
          self.esperandoFinalizacionTarea = true;

          
        }
      );
    },
    
    cancelarAuditoria: function(expediente) {
      const self = this;
      
      const dialog = self.$f7.dialog.confirm(
        '¿Deseas cancelar la auditoría? Se borrarán todos los datos.',
        'Cancelar Auditoría',
        () => {
          dialog.close();
          if (!self.$refs.rform) {
            self.$f7.dialog.alert('No se pudo guardar el expediente');
            return;
          }
          // Limpiar todos los campos de auditoría
          expediente.tarea = null;
          self.$refs.rform.formData.guardadoSilencioso = true;
          // Guardar expediente
          Utils.async((resolve, reject) => {
            self.$refs.rform.$once('error', reject);
            self.$refs.rform.saveItem(resolve);
          })
            .then((res) => {
              // Toast de confirmación
              self.$f7.toast.create({
                text: 'Auditoría cancelada',
                position: 'center',
                closeTimeout: 2000,
              }).open();
              
              // Forzar actualización de la vista
              self.$forceUpdate();
            })
            .finally(() => {
              self.$refs.rform.formData.guardadoSilencioso = false;
              self.$refs.rform.formData.tarea = null; // Limpiar tarea del expediente al finalizar auditoría
            });
        }
      );
    },

    // Métodos de análisis de incompatibilidad (US #134, tipo T0086) — espejo de auditoría
    iniciarEstudioIncompatibilidad: function(expediente) {
      const self = this;
      const app = self.$f7;

      const dialog = self.$f7.dialog.confirm(
        '¿Deseas iniciar el estudio de incompatibilidad?',
        'Iniciar Estudio de Incompatibilidad',
        () => {
          dialog.close();
          if (!self.$refs.rform) {
            self.$f7.dialog.alert('No se pudo guardar el expediente');
            return;
          }
          let inicio = new Date();
          expediente.tareaIncompatibilidad = {
            estado: 'PLANIFICADA',
            tipo: { codigo: 'T0086' },
            fechaFecha: inicio,
            fechaHora: inicio,
            horaInicio: inicio,
            sesiones: [{ inicio: inicio, fin: null }],
            descripcion: 'Análisis de incompatibilidad de inspección ' + (expediente.codigo || expediente.nombre || ''),
            username: Utils.getUser().username,
            empleados: [Utils.getUser().username],
            tiempoEstimado: null,
            idCliente: expediente.cliente ? expediente.cliente.id : null,
            idExpediente: expediente.id,
            codigoExpediente: expediente.codigo,
            numeroPedido: expediente.numeroPedido,
            codigoPedido: expediente.codigoPedido,
            idPedido: expediente.idPedido,
            numeroLineaPedido: expediente.numeroLineaPedido || null,
            razonSocialCliente: expediente.cliente ? expediente.cliente.razonSocial : null,
            codigoCliente: expediente.cliente ? expediente.cliente.codigo : null,
            observaciones: 'Estudio de incompatibilidad iniciado por ' + Utils.getUser().username + ' el ' + inicio.toLocaleString(),
          };

          self.$refs.rform.formData.guardadoSilencioso = true;
          const espera = preloaderDeLaSesion(self);
          espera.mostrar();
          Utils.async((resolve, reject) => {
            self.$refs.rform.$once('error', reject);
            self.$refs.rform.$once('guardadoTerminado', espera.cerrar);
            self.$refs.rform.saveItem(resolve);
          })
            .then(() => {
              self.$f7.toast.create({
                text: 'Estudio de incompatibilidad iniciado',
                position: 'center',
                closeTimeout: 2000,
              }).open();
              self.$forceUpdate();
            })
            .catch((err) => {
              self.$f7.dialog.alert('Error al iniciar el estudio: ' + (err && err.message ? err.message : 'Error desconocido'));
            })
            .finally(() => {
              self.$refs.rform.formData.guardadoSilencioso = false;
              espera.cerrar();
            });
        }
      );
    },

    pausarEstudioIncompatibilidad: function(expediente) {
      const self = this;
      const app = self.$f7;

      const dialog = self.$f7.dialog.confirm(
        '¿Deseas pausar el estudio de incompatibilidad?',
        'Pausar Estudio de Incompatibilidad',
        () => {
          dialog.close();
          if (!self.$refs.rform) {
            self.$f7.dialog.alert('No se pudo guardar el expediente');
            return;
          }
          if (expediente.tareaIncompatibilidad && expediente.tareaIncompatibilidad.sesiones) {
            const sesionAbierta = expediente.tareaIncompatibilidad.sesiones.find(s => s.inicio && !s.fin);
            if (sesionAbierta) {
              sesionAbierta.fin = new Date();
            }
          }
          self.$refs.rform.formData.guardadoSilencioso = true;
          const espera = preloaderDeLaSesion(self);
          espera.mostrar();
          Utils.async((resolve, reject) => {
            self.$refs.rform.$once('error', reject);
            self.$refs.rform.$once('guardadoTerminado', espera.cerrar);
            self.$refs.rform.saveItem(resolve);
          }).then(() => {
            self.$f7.toast.create({
              text: 'Estudio de incompatibilidad pausado',
              position: 'center',
              closeTimeout: 2000,
            }).open();
            self.$forceUpdate();
          }).finally(() => {
            self.$refs.rform.formData.guardadoSilencioso = false;
            espera.cerrar();
          });
        }
      );
    },

    reiniciarEstudioIncompatibilidad: function(expediente) {
      const self = this;
      const app = self.$f7;

      const dialog = self.$f7.dialog.confirm(
        '¿Deseas reiniciar el estudio de incompatibilidad? Se añadirá una nueva sesión.',
        'Reiniciar Estudio de Incompatibilidad',
        () => {
          dialog.close();
          if (!self.$refs.rform) {
            self.$f7.dialog.alert('No se pudo guardar el expediente');
            return;
          }
          if (expediente.tareaIncompatibilidad && expediente.tareaIncompatibilidad.sesiones) {
            expediente.tareaIncompatibilidad.sesiones.push({
              inicio: new Date(),
              fin: null
            });
          }
          self.$refs.rform.formData.guardadoSilencioso = true;
          const espera = preloaderDeLaSesion(self);
          espera.mostrar();
          Utils.async((resolve, reject) => {
            self.$refs.rform.$once('error', reject);
            self.$refs.rform.$once('guardadoTerminado', espera.cerrar);
            self.$refs.rform.saveItem(resolve);
          })
            .then(() => {
              self.$f7.toast.create({
                text: 'Estudio de incompatibilidad reiniciado',
                position: 'center',
                closeTimeout: 2000,
              }).open();
              self.$forceUpdate();
            })
            .finally(() => {
              self.$refs.rform.formData.guardadoSilencioso = false;
              espera.cerrar();
            });
        }
      );
    },

    finalizarEstudioIncompatibilidad: function(expediente) {
      const self = this;
      const app = self.$f7;

      const dialog = self.$f7.dialog.confirm(
        '¿Deseas finalizar el estudio de incompatibilidad? Se registrará el tiempo total dedicado.',
        'Finalizar Estudio de Incompatibilidad',
        () => {
          dialog.close();
          if (!self.$refs.rform) {
            self.$f7.dialog.alert('No se pudo guardar el expediente');
            return;
          }
          if (expediente.tareaIncompatibilidad && expediente.tareaIncompatibilidad.sesiones) {
            const sesionAbierta = expediente.tareaIncompatibilidad.sesiones.find(s => s.inicio && !s.fin);
            if (sesionAbierta) {
              sesionAbierta.fin = new Date();
            }
            let duracionTotal = 0;
            expediente.tareaIncompatibilidad.sesiones.forEach(sesion => {
              if (sesion.inicio && sesion.fin) {
                duracionTotal += new Date(sesion.fin).getTime() - new Date(sesion.inicio).getTime();
              }
            });
            expediente.tareaIncompatibilidad.tiempoEstimado = Math.round(duracionTotal / 60000);
          }
          if (expediente.tareaIncompatibilidad) {
            expediente.tareaIncompatibilidad.estado = 'REALIZADA';
          }
          self.$refs.rform.formData.guardadoSilencioso = true;
          const espera = preloaderDeLaSesion(self);
          espera.mostrar();
          Utils.async((resolve, reject) => {
            self.$refs.rform.$once('error', reject);
            self.$refs.rform.$once('guardadoTerminado', espera.cerrar);
            self.$refs.rform.saveItem(resolve);
          })
            .then(() => {
              self.$f7.toast.create({
                text: 'Estudio de incompatibilidad finalizado',
                position: 'center',
                closeTimeout: 2000,
              }).open();
              self.$forceUpdate();
            })
            .finally(() => {
              self.$refs.rform.formData.guardadoSilencioso = false;
              espera.cerrar();
            });
        }
      );
    },

    cancelarEstudioIncompatibilidad: function(expediente) {
      const self = this;
      const app = self.$f7;

      const dialog = self.$f7.dialog.confirm(
        '¿Deseas cancelar el estudio de incompatibilidad? Se borrarán todos los datos.',
        'Cancelar Estudio de Incompatibilidad',
        () => {
          dialog.close();
          if (!self.$refs.rform) {
            self.$f7.dialog.alert('No se pudo guardar el expediente');
            return;
          }
          expediente.tareaIncompatibilidad = null;
          self.$refs.rform.formData.guardadoSilencioso = true;
          const espera = preloaderDeLaSesion(self);
          espera.mostrar();
          Utils.async((resolve, reject) => {
            self.$refs.rform.$once('error', reject);
            self.$refs.rform.$once('guardadoTerminado', espera.cerrar);
            self.$refs.rform.saveItem(resolve);
          })
            .then(() => {
              self.$f7.toast.create({
                text: 'Estudio de incompatibilidad cancelado',
                position: 'center',
                closeTimeout: 2000,
              }).open();
              self.$forceUpdate();
            })
            .finally(() => {
              self.$refs.rform.formData.guardadoSilencioso = false;
              self.$refs.rform.formData.tareaIncompatibilidad = null;
              espera.cerrar();
            });
        }
      );
    },

    onTareaAuditoriaGuardada: function(tarea) {
      const self = this;
      // Marcar que se ha guardado la tarea
      self.tareaAuditoriaGuardada = true;
      self.tareaAuditoriaCreada = tarea;
      
      // Resolver la promise si existe (viene de finalizarAuditoria)
      if (self.tareaAuditoriaPromiseResolve) {
        self.tareaAuditoriaPromiseResolve(tarea);
        self.tareaAuditoriaPromiseResolve = null;
        self.tareaAuditoriaPromiseReject = null;
      }
    },
    
    onTareaGuardadaDesdeEventBus: function(res) {
      let tarea = res.dto || res.list?res.list[0]:null; // Dependiendo de cómo se emita el evento, la tarea puede venir en res.dto o directamente en res
      const self = this;
      const app = self.$f7;
      
      console.log('EventBus: tarea-guardada recibido', tarea);
      
      // Si estamos esperando la finalización (viene de finalizarAuditoria)
      if (self.esperandoFinalizacionTarea && 
          tarea && 
          tarea.estado === 'REALIZADA' && 
          tarea.idExpediente === self.$refs.rform.formData.id) {
        
        console.log('Condiciones cumplidas, guardando expediente sin campo tarea');
        
        // Borrar el rastro de tarea en curso del expediente
        self.$refs.rform.formData.tarea = null;
        self.$refs.rform.formData.guardadoSilencioso = true;
        
        // Guardar expediente
        const espera = preloaderDeLaSesion(self);
        espera.mostrar();
        Utils.async((resolve, reject) => {
          self.$refs.rform.$once('error', reject);
          self.$refs.rform.$once('guardadoTerminado', espera.cerrar);
          self.$refs.rform.saveItem(resolve);
        })
          .then(() => {
            // Toast de confirmación
            self.$f7.toast.create({
              text: 'Auditoría finalizada y tarea creada correctamente',
              position: 'center',
              closeTimeout: 2000,
            }).open();
            
            // Forzar actualización de la vista
            self.$forceUpdate();
          })
          .catch((err) => {
            console.error('Error al guardar expediente:', err);
            self.$f7.dialog.alert('Error al guardar el expediente');
          })
          .finally(() => {
            self.$refs.rform.formData.guardadoSilencioso = false;
            espera.cerrar();
            self.esperandoFinalizacionTarea = false;
            // Limpiar listener ya que hemos procesado el evento
            EventBus.$off('tarea-guardada', self.onTareaGuardadaDesdeEventBus);
          });
      }
    },
    
    onCerrarPopupTareaAuditoria: function() {
      const self = this;
      if (!self.$refs.rform || !self.$refs.rform.formData) {
        return;
      }
      const expediente = self.$refs.rform.formData;
      
      if (self.tareaAuditoriaGuardada && self.tareaAuditoriaCreada) {
        // Si se creó la tarea, eliminar campo tarea del expediente
        expediente.tarea = null;
        
        // Guardar expediente
        self.$refs.rform.saveItem().then(() => {
          self.$f7.toast.create({
            text: 'Tarea de auditoría creada correctamente',
            position: 'center',
            closeTimeout: 2000,
          }).open();
        });
      } else if (self.tareaAuditoriaAnterior) {
        // Si NO se creó la tarea, volver estado a PLANIFICADA y hacer como pausa
        self.$f7.dialog.alert(
          'La tarea no se ha generado. La auditoría quedará en estado pausado.',
          'Tarea no generada',
          () => {
            if (expediente.tarea) {
              expediente.tarea.estado = 'PLANIFICADA';
            }
            
            // Guardar expediente
            self.$refs.rform.saveItem().then(() => {
              self.$forceUpdate();
            });
          }
        );
      }
      
      // Limpiar variables
      self.popupTareasAuditoriaOpened = false;
      self.tareaAuditoriaId = null;
      self.tareaAuditoriaGuardada = false;
      self.tareaAuditoriaCreada = null;
      self.tareaAuditoriaAnterior = null;
      
      // Limpiar listener del EventBus si estaba esperando
      if (self.esperandoFinalizacionTarea) {
        EventBus.$off('tarea-guardada', self.onTareaGuardadaDesdeEventBus);
        self.esperandoFinalizacionTarea = false;
      }
      
      // Rechazar la promise si se cierra sin guardar (viene de finalizarAuditoria)
      if (self.tareaAuditoriaPromiseReject && !self.tareaAuditoriaGuardada) {
        self.tareaAuditoriaPromiseReject(new Error('Popup cerrado sin guardar'));
        self.tareaAuditoriaPromiseResolve = null;
        self.tareaAuditoriaPromiseReject = null;
      }
    },
    
    verTareas: function () {
      const self = this;
      if (self.$refs.rform && self.$refs.rform.formData) {
        self.codigoExpediente = self.$refs.rform.formData.codigo;
        self.idExpediente = self.$refs.rform.formData.id;
        self.verListadoTareas = true;
      }
    },
    mostrarHistoricoEstados: function () {
      const self = this;
      self.popupHistoricoEstadosOpened = true;
    },
    eliminarElementoHistoricoEstados: function (item, index) {
      const self = this;
      self.$refs.rform.formData.historicoEstados.splice(index, 1);
    },
    setDate: function(destino, fecha) {
      const self = this;
      // si destino y fecha existen, guardaremos la fecha en el destino como Date
      if (destino && fecha) {
        destino =new Date(fecha);
      }
    },
    setEstado(destino, estado) {
      const self = this;
      // si destino y estado existen, guardaremos el estado en el destino como String
      if (destino && estado) {
        destino.estado = estado;
      }
    },
    getListaEstados: function () {
      const self = this;
      let listaEstados = [
        { nombre: "GENERADO", texto: self.getTextoBadgeEstado("GENERADO"), color: self.getColorBadgeEstado("GENERADO") },
        { nombre: "INSPECCIONADO", texto: self.getTextoBadgeEstado("INSPECCIONADO"), color: self.getColorBadgeEstado("INSPECCIONADO") },
        { nombre: "PLANIFICADO", texto: self.getTextoBadgeEstado("PLANIFICADO"), color: self.getColorBadgeEstado("PLANIFICADO") },
        { nombre: "AUDITADO", texto: self.getTextoBadgeEstado("AUDITADO"), color: self.getColorBadgeEstado("AUDITADO") },
        { nombre: "PDTE_FACTURAR", texto: self.getTextoBadgeEstado("PDTE_FACTURAR"), color: self.getColorBadgeEstado("PDTE_FACTURAR") },
        { nombre: "PDTE_CONFORMIDAD", texto: self.getTextoBadgeEstado("PDTE_CONFORMIDAD"), color: self.getColorBadgeEstado("PDTE_CONFORMIDAD") },
        { nombre: "PDTE_ENVIO", texto: self.getTextoBadgeEstado("PDTE_ENVIO"), color: self.getColorBadgeEstado("PDTE_ENVIO") },
        { nombre: "ENVIADO", texto: self.getTextoBadgeEstado("ENVIADO"), color: self.getColorBadgeEstado("ENVIADO") },
        { nombre: "CANCELADO", texto: self.getTextoBadgeEstado("CANCELADO"), color: self.getColorBadgeEstado("CANCELADO") },
        { nombre: "PENDIENTE_REVISION_CALIDAD", texto: self.getTextoBadgeEstado("PENDIENTE_REVISION_CALIDAD"), color: self.getColorBadgeEstado("PENDIENTE_REVISION_CALIDAD") },
        { nombre: "CORREGIR_ERRORES_AUDITORIA_CALIDAD", texto: self.getTextoBadgeEstado("CORREGIR_ERRORES_AUDITORIA_CALIDAD"), color: self.getColorBadgeEstado("CORREGIR_ERRORES_AUDITORIA_CALIDAD") },
        { nombre: "PENDIENTE_FIRMA_INSPECTOR", texto: self.getTextoBadgeEstado("PENDIENTE_FIRMA_INSPECTOR"), color: self.getColorBadgeEstado("PENDIENTE_FIRMA_INSPECTOR") },
        { nombre: "FIRMADO_INSPECTOR", texto: self.getTextoBadgeEstado("FIRMADO_INSPECTOR"), color: self.getColorBadgeEstado("FIRMADO_INSPECTOR") },
        { nombre: "NO_DEFINIDO", texto: self.getTextoBadgeEstado("NO_DEFINIDO"), color: self.getColorBadgeEstado("NO_DEFINIDO") }
      ];
      return listaEstados;
    },
    getTextoBadgeEstado: function (estado) {
      var self = this;
      if (estado) {
        switch (estado) {
          case "GENERADO":
            return "Creado";
          case "INSPECCIONADO":
            return "Inspeccionado";
          case "PLANIFICADO":
            return "Planificado";
          case "AUDITADO":
            return "Auditado";
          case "PDTE_FACTURAR":
            return "Pdte. Facturar";
          case "PDTE_CONFORMIDAD":
            return "Pdte. Confirmar";
          case "PDTE_ENVIO":
            return "Pdte. Envío";
          case "ENVIADO":
            return "Enviado";
          case "CANCELADO":
            return "Cancelado";
          case "PENDIENTE_REVISION_CALIDAD":
            return "Pdte. de revisión (calidad)";
          case "CORREGIR_ERRORES_AUDITORIA_CALIDAD":
            return "Corregir errores (calidad)";
          case "PENDIENTE_FIRMA_INSPECTOR":
            return "Pdte. de firma";
          case "FIRMADO_INSPECTOR":
            return "Certificado firmado";
          case "NO_DEFINIDO":
            return "No definido";
        }
      } else {
        return "Sin estado";
      }

    },
    getColorBadgeEstado: function (estado) {
      if (estado) {
        switch (estado) {
          case "GENERADO":
            return "lime";
          case "INSPECCIONADO":
            return "green";
          case "PLANIFICADO":
            return "blue";
          case "AUDITADO":
            return "teal";
          case "PDTE_FACTURAR":
            return "purple";
          case "PDTE_CONFORMIDAD":
            return "deeppurple";
          case "PDTE_ENVIO":
            return "yellow";
          case "ENVIADO":
            return "orange";
          case "CANCELADO":
            return "red";
          case "PENDIENTE_REVISION_CALIDAD":
            return "pink";
          case "CORREGIR_ERRORES_AUDITORIA_CALIDAD":
            return "darkblue";
          case "PENDIENTE_FIRMA_INSPECTOR":
            return "deeppurple";
          case "FIRMADO_INSPECTOR":
            return "lightblue";
          case "NO_DEFINIDO":
            return "gray";
        }
      } else {
        return "gray";
      }

    },
    isImage: function(item) {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
      return imageExtensions.includes(item.extension.toLowerCase());
    },
    hayExpedientesAnteriores: function() {
      const self = this;
      return self.$refs.rform && self.$refs.rform.formData && self.$refs.rform.formData.expedientesAnteriores && self.$refs.rform.formData.expedientesAnteriores.length;
    },
    reloadPage: function(){
      var self = this;
      window.location.reload();
    },
    urlVerFormato: function(id) {
      // URL absoluta con hash-bang para abrir en pestaña nueva sin que el router
      // de F7 intercepte la navegación.
      return window.location.origin + '/#!/formatos/view/' + encodeURIComponent(id) + '/';
    },
    openPopupAsignarFormato: function() {
      const self = this;
      self.$refs.popupAsignarFormato.openPopup();
    },
    asignarFormatoCompleto(codigoFormato, asignadoManual = false) {
      const self = this;
      var dbAdapter = self.offline ? FormatoOffline : Formato;
      dbAdapter.getList({ filter: { codigo: codigoFormato } }).then(function(res) {
        if (!res.list.length) {
          app.dialog.alert("No se puede cargar el formato").open();
        } else {
          var formato = res.list[0];
          let inspeccion = self.$refs.rform.formData;
          // Si la inspección trae comprobaciones y formato y el formato tiene como código el codigoFormato que nos llega por parámetro, no hacemos nada
          if (!inspeccion.comprobaciones || !inspeccion.formato || inspeccion.formato.codigo !== codigoFormato) {
            self.$set(self.$refs.rform.formData,"comprobaciones",formato.comprobaciones);
          }
          // revisaremos las comprobaciones para ver si alguna tiene uno de los códigos de defectosExpedienteAnteriorNegativo
          // si es así, pondremos le pondremos el campo conDefectoAnterior a true
          if (inspeccion.comprobaciones && inspeccion.defectosExpedienteAnteriorNegativo && inspeccion.defectosExpedienteAnteriorNegativo.length) {
            let comprobaciones = self.getComprobaciones(inspeccion.comprobaciones);
            comprobaciones.forEach(comprobacion => {
              // Si comprobacion.codigo está en defectosExpedienteAnteriorNegativo, ponemos conDefectoAnterior a true
              if (inspeccion.defectosExpedienteAnteriorNegativo.includes(comprobacion.codigo)) {
                self.$set(comprobacion, "conDefectoAnterior", true);
              }
            });
          }

          // Preservamos las características que nos llegan informadas del servidor ------
          let caracteristicasPrevias = self.getCaracteristicas(self.$refs.rform.formData.caracteristicas).filter(car => !!car.valor);
          // Reemplazamos las características iniciales por las propias del formato seleccionado
          self.$set(self.$refs.rform.formData,"caracteristicas",formato.caracteristicas);
          // Metemos los valores que podamos de las características previas en el nuevo conjunto de características del expediente.
          self.getCaracteristicas(self.$refs.rform.formData.caracteristicas).forEach(car => {
            let old = caracteristicasPrevias.find(c => c.nombre == car.nombre);
            car.valor = old?old.valor:car.valor;
          });
          // -----------------------------------------------------------------------------

          self.$set(self.$refs.rform.formData,"tabs",formato.tabs);
          self.preinicializarResultadosComprobaciones();
          // if (!asignadoManual) {
          //   self.$set(
          //     self.$refs.rform.formData,
          //     "hc1",
          //     new Date()
          //   )
          // }
          let formato_copy = JSON.parse(JSON.stringify(res.list[0]));
          self.$set(self.$refs.rform.formData, "formato", formato_copy);
          if (!asignadoManual) {
            self.initFechaProxInspeccion(self.$refs.rform.formData);
          }
          self._initCaracteristicas(self.$refs.rform.formData);
          // Limpiar instrucciones de comprobaciones del expediente (se consultan del formato local)
          Utils.limpiarInstruccionesComprobaciones(self.$refs.rform.formData.comprobaciones);
          Utils.limpiarInstruccionesElementos(self.$refs.rform.formData.tabs);
          // Limpiar formato embebido (datos pesados que se consultan del formato local)
          Utils.limpiarFormatoExpediente(self.$refs.rform.formData.formato);
        }
      });
    },
    async nocalificacionEstadoSesion(estadoSesion) {
      Utils.log("nocalificacionEstadoSesion: " + estadoSesion);
      const self = this;
      const app = self.$f7;
      if (await self.finalizaTrabajoManual(estadoSesion, false)) {
        app.preloader.show();
        self.guardar(() => self.nocalificacionNoRealizada());
      }
    },
    nocalificacionNoRealizada() {
      const self = this;
      if (self.$refs.popupNoCalificacion) {
        self.$refs.popupNoCalificacion.close();
      }
      self.$f7router.back();
    },
    nocalificacionOk() {
      const self = this;
      if (self.$refs.popupNoCalificacion) {
        self.$refs.popupNoCalificacion.close();
      }
    },
    clickAtras(e) {
      const self = this;
      const app = self.$f7;
      // Sacaremos el popup para que elijan opciones, cuando se haga click atrás estando la sesión manual en estado iniciado o reanudado (estados editables)
      if (self.target == 'cordova' && self.$refs.rform && self.$refs.rform.formData && self.$refs.rform.formData.estadoSesion 
          && self.$refs.rform.formData.estadoSesion == 'iniciado' || self.$refs.rform.formData.estadoSesion == 'reanudado') {
        self.popupNoCalificacion = true;
      } else {
        self.$f7router.back();
      }
    },
    async recalcularDireccion(obj, field) {
      const self = this;
      var app = self.$f7;
      app.dialog.confirm("¿Está seguro de que quiere recalcular la posición?", "Recalcular posición", async function() {
        app.preloader.show();
        let location = await self.updateLocation();
        if (location) {
          self.$set(obj, field, location);
        }
        app.preloader.hide();
      });
    },
    async updateLocation() {
      const self = this;
      if (navigator && navigator.geolocation) {
        let pos = false;
        try {
          pos = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: 5000, enableHighAccuracy: true });
          });
        } catch (e) {
          console.log("Error obteniendo direccion getCurrentPosition: ", e);
          Utils.log("Error obteniendo direccion getCurrentPosition: " + (typeof e === 'object' && e !== null ? JSON.stringify(e) : e));
        }
        if (pos && pos.coords) {
          self.currentLocation = {
            punto: { coordinates: [pos.coords.longitude, pos.coords.latitude], type: "Point", x: pos.coords.longitude, y: pos.coords.latitude },
            latitud: pos.coords.latitude,
            longitud: pos.coords.longitude,
            direccion: pos.coords.longitude + ", " + pos.coords.latitude,
            fecha: new Date()
          };

          if (self.nominatim) {
            try {
              let nomClient = self.nominatim.default.createClient({ useragent: "SIMECAL-MOVILIDAD" });
              const res = await nomClient.reverse({ lat: pos.coords.latitude, lon: pos.coords.longitude });
              self.currentLocation.direccion = res.display_name;
            } catch (e) {
              console.log("Error obteniendo direccion de nominatim: ", e);
              Utils.log("Error obteniendo direccion de nominatim: " + (typeof e === 'object' && e !== null ? JSON.stringify(e) : e));
            }
          }
        }
      }
      return self.currentLocation;
    },
    onChangeCalificacion(e) {
      const self = this;
      if (self.offline) {
        if (e && Array.isArray(e) && e.length && e[0].id) {
          if (e[0].id == 'NEGATIVO') {
            self.$refs.rform.formData.proxInsp = null;
            self.infoPeriodicidadMessage = false;
          } else if (e[0].id == 'DESFAVORABLE' || e[0].id == 'FAVORABLE_CON_REPARO') {
            self.$refs.rform.formData.proxInsp = null;
            self.infoPeriodicidadMessage = "Se informará automáticamente al sincronizar";
          } else if (e[0].id == 'FAVORABLE' || e[0].id == 'FAVORABLE_CON_DEFECTOS') {
            self.initFechaProxInspeccion(self.$refs.rform.formData);
            self.infoPeriodicidadMessage = false;
          }
        }
        console.log(e);
      }
    },
    /**
     * Calcula la calificación del expediente basándose en las comprobaciones y sus defectos
     * Implementa la lógica equivalente al backend Java:
     * - Para cada comprobación, calcula: resultado × peso
     * - Toma el máximo valor (ponderador)
     * - Compara con umbrales: <9 FAVORABLE, <18 FAVORABLE_CON_DEFECTOS, <27 DESFAVORABLE, >=27 NEGATIVO
     */
    calcularCalificacion(rform) {
      const self = this;
      const app = self.$f7;
      
      try {
        const expediente = rform.formData;
        
        if (!expediente.comprobaciones || expediente.comprobaciones.length === 0) {
          app.toast.create({
            text: 'No hay comprobaciones para calcular la calificación',
            position: 'center',
            closeTimeout: 2000,
            icon: '<i class="f7-icons">info_circle</i>',
          }).open();
          return;
        }

        console.log('[CALIFICACION] ========== CÁLCULO DE CALIFICACIÓN ==========');
        // Según BOE Tabla 4 y 5: Calcular resultado cualitativo y cuantitativo, tomar el PEOR
        let resultadoCualitativoPeor = 'F'; // Peor resultado de comprobaciones con peso 3 (solo cualitativo)
        let ponderadorCuantitativoTotal = 0;  // Suma ponderada de TODOS los sistemas (cualquier peso)
        
        expediente.comprobaciones.forEach(comprobacion => {
          // Ignorar comprobaciones que NO aplican (aplica=false o resultado=NA)
          if (comprobacion.aplica === false || comprobacion.resultado === 'NA') {
            console.log(`[CALIFICACION] Comprobación ${comprobacion.codigo} no aplica - IGNORADA`);
            return;
          }
          
          const peso = comprobacion.peso != null ? comprobacion.peso : 3;
          
          // CUALITATIVA: Solo considerar sistemas con peso 3 para resultado cualitativo
          if (peso === 3) {
            const resultadoComprobacion = self.calcularResultadoComprobacion(comprobacion);
            const valorResultado = self.getValorResultado(resultadoComprobacion);
            
            // Actualizar el peor resultado cualitativo
            if (valorResultado > self.getValorResultado(resultadoCualitativoPeor)) {
              resultadoCualitativoPeor = resultadoComprobacion;
            }
            console.log(`[CALIFICACION] Comprobación ${comprobacion.codigo} (peso 3): resultado cualitativo=${resultadoComprobacion}`);
          }
          
          // CUANTITATIVA: Sumar puntos de TODOS los sistemas (cualquier peso)
          const resultadoComprobacion = self.calcularResultadoComprobacion(comprobacion);
          const valorResultado = self.getValorResultado(resultadoComprobacion);
          const ponderador = valorResultado * peso;
          ponderadorCuantitativoTotal += ponderador;
          console.log(`[CALIFICACION] Comprobación ${comprobacion.codigo} (peso ${peso}): resultado=${resultadoComprobacion}(${valorResultado}), ponderador=${ponderador}`);
        });

        // Convertir resultado cualitativo a calificación (según Tabla 5)
        let calificacionCualitativa;
        if (resultadoCualitativoPeor === 'F' || resultadoCualitativoPeor === 'NO_ENCONTRADO') {
          calificacionCualitativa = 'FAVORABLE';
        } else if (resultadoCualitativoPeor === 'DL') {
          calificacionCualitativa = 'FAVORABLE_CON_DEFECTOS';
        } else if (resultadoCualitativoPeor === 'DG') {
          calificacionCualitativa = 'DESFAVORABLE';
        } else { // DMG
          calificacionCualitativa = 'NEGATIVO';
        }
        
        // Convertir ponderador cuantitativo a calificación (según Tabla 4)
        let calificacionCuantitativa;
        if (ponderadorCuantitativoTotal < 9) {
          calificacionCuantitativa = 'FAVORABLE';
        } else if (ponderadorCuantitativoTotal < 18) {
          calificacionCuantitativa = 'FAVORABLE_CON_DEFECTOS';
        } else if (ponderadorCuantitativoTotal < 27) {
          calificacionCuantitativa = 'DESFAVORABLE';
        } else {
          calificacionCuantitativa = 'NEGATIVO';
        }
        
        // La calificación final es la PEOR entre cualitativa y cuantitativa
        const calificaciones = ['FAVORABLE', 'FAVORABLE_CON_DEFECTOS', 'DESFAVORABLE', 'NEGATIVO'];
        const indexCualitativa = calificaciones.indexOf(calificacionCualitativa);
        const indexCuantitativa = calificaciones.indexOf(calificacionCuantitativa);
        const calificacion = calificaciones[Math.max(indexCualitativa, indexCuantitativa)];

        // Actualizar la calificación en el formulario
        self.$set(expediente, 'calificacion', calificacion);
        
        // Disparar el evento de cambio de calificación
        self.onChangeCalificacion([{id: calificacion}]);
        
        // Mostrar notificación con el resultado
        const nombreCalificacion = self.getNombreCalificacion(calificacion);
        console.log(`[CALIFICACION FINAL] Cualitativa (solo peso 3): ${calificacionCualitativa} (${resultadoCualitativoPeor}), Cuantitativa (todos los pesos): ${calificacionCuantitativa} (${ponderadorCuantitativoTotal} puntos), Final: ${calificacion}`);
        app.toast.create({
          text: `Calificación calculada: ${nombreCalificacion} (cualitativo: ${resultadoCualitativoPeor}, cuantitativo: ${ponderadorCuantitativoTotal})`,
          position: 'center',
          closeTimeout: 3500,
          icon: '<i class="f7-icons">checkmark_alt_circle</i>',
        }).open();
        
      } catch (error) {
        console.error('Error al calcular calificación:', error);
        app.toast.create({
          text: 'Error al calcular la calificación',
          position: 'center',
          closeTimeout: 2000,
          icon: '<i class="f7-icons">exclamationmark_triangle</i>',
        }).open();
      }
    },
    
    /**
     * Calcula el resultado de una comprobación aplicando la lógica BOE en CADA NIVEL:
     * - Cualitativo: peor resultado de hijas con peso 3
     * - Cuantitativo: suma ponderada de TODAS las hijas
     * - Resultado final: el PEOR entre ambos
     * - Ignora comprobaciones con aplica=false o resultado='NA'
     */
    calcularResultadoComprobacion(comprobacion) {
      const self = this;
      const peso = comprobacion.peso || 3;
      const defectosSeleccionados = comprobacion.defectosSeleccionados || [];
      const hijas = comprobacion.comprobaciones || comprobacion.hijas || [];
      
      console.log(`[RESULTADO] Calculando ${comprobacion.codigo || comprobacion.nombre} (peso ${peso})`);
      
      // CASO 1: Es hoja con defectos propios
      if ((!hijas || hijas.length === 0) && defectosSeleccionados.length > 0) {
        let defectoMax = null;
        let valorMax = 0;
        
        defectosSeleccionados.forEach(defecto => {
          const categoria = defecto.categoria || defecto.categoriaDefecto;
          const valor = self.getValorCategoria(categoria);
          if (valor > valorMax) {
            valorMax = valor;
            defectoMax = defecto;
          }
        });
        
        let resultado = 'F';
        if (defectoMax) {
          const categoria = defectoMax.categoria || defectoMax.categoriaDefecto;
          // Mapear DN1/DN2/DN3 a DL/DG/DMG
          if (categoria === 'DL' || categoria === 'DN1') resultado = 'DL';
          else if (categoria === 'DG' || categoria === 'DN2') resultado = 'DG';
          else if (categoria === 'DMG' || categoria === 'DN3') resultado = 'DMG';
        }
        console.log(`[RESULTADO] ${comprobacion.codigo} (hoja): ${resultado}`);
        return resultado;
      }
      
      // CASO 2: Tiene hijas - aplicar lógica cualitativo vs cuantitativo
      if (hijas && hijas.length > 0) {
        // CUALITATIVO: Peor resultado de hijas con peso 3
        let resultadoCualitativo = 'F';
        
        // CUANTITATIVO: Suma ponderada de TODAS las hijas
        let ponderadorTotal = 0;
        
        hijas.forEach(hija => {
          // Ignorar hijas que no aplican o tienen resultado NA
          if (hija.aplica === false || hija.resultado === 'NA') {
            console.log(`[RESULTADO] Hija ${hija.codigo} no aplica o resultado=NA - IGNORADA`);
            return;
          }
          
          const pesoHija = hija.peso != null ? hija.peso : 3;
          const resultadoHija = self.calcularResultadoComprobacion(hija);
          const valorHija = self.getValorResultado(resultadoHija);
          
          // CUALITATIVO: solo peso 3
          if (pesoHija === 3) {
            if (valorHija > self.getValorResultado(resultadoCualitativo)) {
              resultadoCualitativo = resultadoHija;
            }
          }
          
          // CUANTITATIVO: todas las hijas
          ponderadorTotal += valorHija * pesoHija;
        });
        
        // Calcular rangos para convertir ponderador a resultado
        const rangos = self.calcularRangoPuntuaciones(comprobacion);
        let resultadoCuantitativo = 'F';
        if (ponderadorTotal >= rangos.right) {
          resultadoCuantitativo = 'DMG';
        } else if (ponderadorTotal >= rangos.middle) {
          resultadoCuantitativo = 'DG';
        } else if (ponderadorTotal >= rangos.left) {
          resultadoCuantitativo = 'DL';
        }
        
        // Tomar el PEOR entre cualitativo y cuantitativo
        const valorCualitativo = self.getValorResultado(resultadoCualitativo);
        const valorCuantitativo = self.getValorResultado(resultadoCuantitativo);
        const resultado = valorCualitativo > valorCuantitativo ? resultadoCualitativo : resultadoCuantitativo;
        
        console.log(`[RESULTADO] ${comprobacion.codigo} (peso ${peso}): cualitativo=${resultadoCualitativo}, cuantitativo=${resultadoCuantitativo}(${ponderadorTotal}pts), rangos={${rangos.left},${rangos.middle},${rangos.right}}, final=${resultado}`);
        return resultado;
      }
      
      // Sin hijas ni defectos
      return 'F';
    },
    
    /**
     * Calcula la puntuación total de una comprobación según BOE
     * Para hojas: valor_defecto_max × peso
     * Para padres con hijas peso < 3: Σ(valor_resultado_hija × peso_hija)
     * Para padres con hijas peso = 3: no suma puntos (se maneja en result3)
     */
    calcularPuntuacionComprobacion(comprobacion) {
      let result = 0;
      const peso = comprobacion.peso != null ? comprobacion.peso : 3;
      const defectosSeleccionados = comprobacion.defectosSeleccionados || [];
      const hijas = comprobacion.comprobaciones || comprobacion.hijas || [];
      
      // CASO 1: Es hoja (no tiene hijas) y tiene defectos y peso != 3
      if ((!hijas || hijas.length === 0) && defectosSeleccionados.length > 0 && peso !== 3) {
        // Buscar el valor máximo de defecto
        let valorDefectoMax = 0;
        defectosSeleccionados.forEach(defecto => {
          const categoria = defecto.categoria || defecto.categoriaDefecto;
          if (categoria) {
            const valor = this.getValorCategoria(categoria);
            if (valor > valorDefectoMax) {
              valorDefectoMax = valor;
            }
          }
        });
        result = valorDefectoMax * peso;
        console.log(`[PUNTOS] ${comprobacion.codigo || comprobacion.nombre}: valorDefectoMax=${valorDefectoMax}, peso=${peso}, puntos=${result}`);
      }
      // CASO 2: Tiene hijas - sumar según BOE: Σ(valor_resultado_subsistema × peso_subsistema)
      else if (hijas && hijas.length > 0) {
        hijas.forEach(comprobacionHija => {
          const pesoHija = comprobacionHija.peso != null ? comprobacionHija.peso : 3;
          
          // Solo sumar hijas con peso < 3 (según BOE, peso 3 se maneja aparte)
          if (pesoHija < 3) {
            // Calcular resultado de la hija primero (recursivo)
            const resultadoHija = this.calcularResultadoComprobacion(comprobacionHija);
            const valorResultadoHija = this.getValorResultado(resultadoHija);
            
            // Sumar: valor_resultado × peso
            result += valorResultadoHija * pesoHija;
          }
        });
        console.log(`[PUNTOS] ${comprobacion.codigo || comprobacion.nombre}: sumaPuntos=${result}, peso_padre=${peso}`);
      }
      
      return result;
    },
    
    /**
     * Calcula los rangos de puntuación (umbrales) para una comprobación
     * Implementa la lógica BOE: suma de TODOS los pesos de hijas con peso < 3
     * Retorna {left, middle, right} equivalente al Triple de Java
     */
    calcularRangoPuntuaciones(comprobacion) {
      let left = 3;
      let middle = 6;
      let right = 9;
      
      const peso = comprobacion.peso != null ? comprobacion.peso : 3;
      const defectos = comprobacion.defectos || [];
      const hijas = comprobacion.comprobaciones || comprobacion.hijas || [];
      
      // CASO 1: Es hoja (no tiene hijas), tiene defectos y peso != 3
      if ((!hijas || hijas.length === 0) && defectos.length > 0 && peso !== 3) {
        left = 1 * peso;   // CategoriaDefectoEnum.DL = 1
        middle = 3 * peso; // CategoriaDefectoEnum.DG = 3
        right = 9 * peso;  // CategoriaDefectoEnum.DMG = 9
      }
      // CASO 2: Tiene hijas - sumar TODOS los pesos de hijas con peso < 3
      else if (hijas && hijas.length > 0) {
        // Según BOE: Σ(Ppi × valor_categoria) para todos los puntos con peso ≠ 3
        const sumaPesos = hijas
          .filter(h => (h.peso != null ? h.peso : 3) < 3)
          .reduce((sum, h) => sum + (h.peso != null ? h.peso : 3), 0);
        
        if (sumaPesos > 0) {
          // Los rangos se calculan como la suma de pesos × valor de categoría × peso del padre
          left = 1 * sumaPesos * peso;   // DL
          middle = 3 * sumaPesos * peso; // DG
          right = 9 * sumaPesos * peso;  // DMG
        }
      }
      
      return {
        left: left,
        middle: middle,
        right: right
      };
    },
    
    /**
     * Obtiene el valor numérico de un resultado (F, DL, DG, DMG, NO_ENCONTRADO)
     * Equivalente a ResultadoEnum.getValorDefecto()
     */
    getValorResultado(resultado) {
      const valores = {
        'NO_ENCONTRADO': -1,
        'F': 0,
        'DL': 1,
        'DG': 3,
        'DMG': 9
      };
      return valores[resultado] != null ? valores[resultado] : -1;
    },
    
    /**
     * Obtiene el valor numérico de una categoría de defecto
     * Equivalente a CategoriaDefectoEnum valores
     */
    getValorCategoria(categoria) {
      const valores = {
        'DL': 1,
        'DN1': 1,  // DN1 = Defecto Leve
        'DG': 3,
        'DN2': 3,  // DN2 = Defecto Grave
        'DMG': 9,
        'DN3': 9   // DN3 = Defecto Muy Grave
      };
      return valores[categoria] || 0;
    },
    
    /**
     * Obtiene el nombre legible de una calificación
     */
    getNombreCalificacion(calificacion) {
      const nombres = {
        'FAVORABLE': 'Favorable',
        'FAVORABLE_CON_DEFECTOS': 'Favorable con Defectos',
        'FAVORABLE_CON_REPARO': 'Favorable con Reparo',
        'DESFAVORABLE': 'Condicionada',
        'NEGATIVO': 'Negativa'
      };
      return nombres[calificacion] || calificacion;
    },
    
    guardar: async function(afterSaveFunction) {
      const self = this;
      console.log("guardar");
      Utils.log("guardar");
      let inspeccion = self.$refs.rform.formData;

      if (!self.offline) {
        // si estamos online, el estado es planificado y damos a guardar cambios, pondremos la fecha de fín en el rango de la última sesión manual abierta
        if (inspeccion && inspeccion.sesionesManuales && inspeccion.estado && inspeccion.estado.estado == 'PLANIFICADO') {
          let ultimoRango = inspeccion.sesionesManuales[inspeccion.sesionesManuales.length - 1];
          if (ultimoRango && !ultimoRango.fin) {
            ultimoRango.fin = new Date();
            ultimoRango.puntoFin = self.currentLocation;
            ultimoRango.username = self.getUsernameLogged();
          }
        }
        // si estamos online, el estado es inspeccionado y damos a guardar cambios, pondremos la fecha de fín en el rango de la última sesión TPI abierta
        // Hacer esto solo si el usuario no es NOID
        if (inspeccion && inspeccion.sesionesTPI && inspeccion.estado && inspeccion.estado.estado == 'INSPECCIONADO' && self.$refs.rform.username != 'NOID') {
          let ultimoRango = inspeccion.sesionesTPI[inspeccion.sesionesTPI.length - 1];
          if (ultimoRango && !ultimoRango.fin) {
            ultimoRango.fin = new Date();
            ultimoRango.puntoFin = self.currentLocation;
            ultimoRango.username = self.getUsernameLogged();
          }
        }
      }
      if (inspeccion && inspeccion.sesionesManuales && inspeccion.sesionesManuales.length > 0) {
        let tiempoReal = inspeccion.sesionesManuales.reduce((acc, sesion) => {
          let finTime = self.getTime(sesion.fin),
            inicioTime = self.getTime(sesion.inicio);
          return acc + finTime - inicioTime;
        }, 0);
        tiempoReal = Math.round((tiempoReal || 0) / 60000);
        inspeccion.tiempoReal = tiempoReal;
        inspeccion.duracion = tiempoReal;
        
        // Sincronización de campos derivados de sesionesManuales
        // Solo se aplican si Utils.posterior2Dic2024 (requisito funcional)
        if (Utils.posterior2Dic2024(inspeccion.fechaInsp)) {
          const duracionH = DateUtils.getDurationInHoursAndMinutes(tiempoReal);
          inspeccion.duracionH = duracionH;
          
          // Sincronizar hc1 y hf1 desde la primera y última sesión
          // Esto es crítico para que el historicoOffline capture estos cambios
          const primeraSesion = inspeccion.sesionesManuales[0];
          const ultimaSesion = inspeccion.sesionesManuales[inspeccion.sesionesManuales.length - 1];
          
          if (primeraSesion && primeraSesion.inicio) {
            inspeccion.hc1 = primeraSesion.inicio;
          }
          // hf1 debe sincronizarse SIEMPRE que haya una sesión con fin
          // Esto asegura que cuando se pausa o finaliza, el cambio se registre en historicoOffline
          if (ultimaSesion && ultimaSesion.fin) {
            inspeccion.hf1 = ultimaSesion.fin;
          }
        }
      }
      self.$nextTick(_=>{self.$refs.rform.saveItem(afterSaveFunction)});
    },
    syncOnline: function(inspeccion) {
      var self = this;
      var app = self.$f7;
      let expediente = self.$refs.rform.formData;
      // lanzamos las reglas de auditoría de sincronización y si hay errores, no sincronizamos
      EntityUtils.cumpleReglas("sincronizar", expediente, this.offline,(cumple)=>{
        // miraremos si incumple alguna regla crítica
        app.preloader.hide();
        if(!self.incumpleReglaCritica(expediente)) {
          if(!cumple) {app.dialog.alert("Cumple reglas bloqueantes pero no las siguientes informativas<br>" + self.extraerMensajesErrores(expediente).join("<br>"));}
          app.dialog.create( {
              title: "Reglas incumplidas",
              text: "Cumple reglas bloqueantes pero no las siguientes informativas<br>" + self.extraerMensajesErrores(expediente).join("<br>"),
              buttons: [
                  {
                    text: 'Cancelar',
                    color: 'gray',
                    onClick: function(dialog) {}
                  },
                  {
                    text: 'Sincronizar',
                    color: 'blue',
                    onClick: () => {
                      let inspeccionCopia = JSON.parse(JSON.stringify(inspeccion));
                      Utils.limpiarInstruccionesComprobaciones(inspeccionCopia.comprobaciones);
                      Inspeccion.syncOnline({ data: [inspeccionCopia] })
                      .then(function(res) {
                        app.preloader.hide();
                        self.$set(self.$refs.rform, "formData", res[0]);
                        app.toast
                          .create({
                            text: "Inspección enviada",
                            position: "center",
                            closeTimeout: 2000,
                            icon: '<i class="f7-icons">checkmark_alt</i>',
                          })
                          .open();
                      })
                      .catch(function(e) {
                        app.preloader.hide();
                        console.log(e);
                        if (typeof e == "string") {
                          app.dialog.alert(e);
                        } else if(e.error && e.error.message) {
                          app.dialog.alert(e.error.message);
                        } else if (e.message) {
                          app.dialog.alert(e.message);
                        } else {
                          app.dialog.alert("Error al sincronizar la inspección");
                        }
                      })
                    }
                  }
                ]
              }
          ).open();
        }
        else {
          app.dialog.alert("No cumple <b>reglas</b> de auditoría<br>" + self.extraerMensajesErrores(expediente).join("<br>"),"Reglas incumplidas");
        }
      });
    },
    cumpleReglas: function() {
      var self = this;
      var app = self.$f7;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      let expediente = self.$refs.rform.formData;
      let accion = "";
      // si expediente.estado.estado es GENERADO o PLANIFICADO, la acción es sincronizar
      if (expediente.estado.estado == 'GENERADO' || expediente.estado.estado == 'PLANIFICADO') {
        accion = "sincronizar";
      } else 
      // si expediente.estado.estado es INSPECCIONADO, AUDITADO, PENDIENTE_REVISION_CALIDAD, CORREGIR_ERRORES_AUDITORIA_CALIDAD o PENDIENTE_FIRMA_INSPECTOR, la acción es finalizar
      if (expediente.estado.estado == 'INSPECCIONADO' || expediente.estado.estado == 'AUDITADO' || expediente.estado.estado == 'PENDIENTE_REVISION_CALIDAD' || expediente.estado.estado == 'CORREGIR_ERRORES_AUDITORIA_CALIDAD' || expediente.estado.estado == 'PENDIENTE_FIRMA_INSPECTOR') {
        accion = "finalizar";
      }
      EntityUtils.cumpleReglas(accion, expediente, this.offline,(cumple)=>{
        espera.cerrar();
        if(cumple) {
          app.dialog.alert("Cumple reglas");
        }
        else {
          app.dialog.alert("No cumple <b>reglas</b> de auditoría<br>" + self.extraerMensajesErrores(expediente).join("<br>"),"Reglas incumplidas");
        }
      });
    },
    incumpleReglaCritica: function(expediente) {
      var self = this;
      // añadimos los errores de valores
      var errores = expediente.listErrorsForLabel.flatMap(e=>e.errores);
      const caracts = EntityUtils.getUltimasHijas(expediente.caracteristicas);
      caracts.forEach(caract => {
        if (caract.listErrorsForLabel) {
          errores = errores.concat(caract.listErrorsForLabel.flatMap(e=>e.errores));
        }
      });
      const compros = EntityUtils.getUltimasHijas(expediente.comprobaciones);
      compros.forEach(compro => {
        if (compro.listErrorsForLabel) {
          errores = errores.concat(compro.listErrorsForLabel.flatMap(e=>e.errores));
        }
      });
      // y los errores de los items de las pestanas (cuadros, transformadores...)
      errores = errores.concat(EntityUtils.erroresDeItems(expediente));
      // ahora miramos si alguno de los errores es de una regla tipoRegla bloqueante
      return errores.filter(e=>!!e).some(e=>e.tipoRegla == 'bloqueante');
    },
    extraerMensajesErrores: function(expediente) {
      var self = this;
      var errores = [];
      if (expediente.listErrorsForLabel) {
        // errores en valores 
        expediente.listErrorsForLabel.forEach(campo => {
          campo.errores.forEach(error => {
            errores.push(error.nombre + ": <span class='regla-"+ error.tipoRegla + "'>" + error.error + "</span>");
          });
        });
      }
      // buscamos errores en comprobaciones (están dentro de los nodos hoja en el campo listErrorsForLabel de cada nodo)
      const caracts = EntityUtils.getUltimasHijas(expediente.caracteristicas);
      caracts.forEach(caract => {
        if (caract.listErrorsForLabel) {
          caract.listErrorsForLabel.forEach(error => {
            errores.push(error.nombre + ": <span class='regla-"+ error.tipoRegla + "'>" + error.error + "</span>");
          });
        }
      });
      const compros = EntityUtils.getUltimasHijas(expediente.comprobaciones);
      compros.forEach(compro => {
        if (compro.listErrorsForLabel) {
          compro.listErrorsForLabel.forEach(error => {
            errores.push(error.nombre + ": <span class='regla-"+ error.tipoRegla + "'>" + error.error + "</span>")
          });
        }
      });
      // los de los items de las pestanas llevan delante el nombre de su item: una regla de
      // subformato se evalua tantas veces como cuadros haya, y sin eso no se sabe cual fallo
      EntityUtils.erroresDeItems(expediente).forEach(error => {
        errores.push(error.etiqueta + error.nombre + ": <span class='regla-"+ error.tipoRegla + "'>" + error.error + "</span>");
      });
      //eliminamos los errores que son iguales
      return [...new Set(errores)];
    },
    onChangeInspector(index, event) {
      const self = this;
      if (!event.target) {
        self.$set(self.$refs.rform.formData.inspectores,index,Object.assign(self.$refs.rform.formData.inspectores[index], event));
      }
    },
    onChangeRol(index, event) {
      const self = this;
      if(self.$refs.rform.formData.inspectores[index].rol) {
        self.$set(self.$refs.rform.formData.inspectores[index],'rol',event.target.value);
      } else {
        self.$set(self.$refs.rform.formData.inspectores[index],'rol','INSPECTOR');
      }
    },
    crearExpedienteSegundas(inspeccion){
      const self = this;
      const app = self.$f7;
      app.dialog.confirm(
        "Se va a generar un expediente de segunda visita. ¿Desea continuar?",
        "Crear expediente de segundas",
        function() {
        const espera = preloaderDeLaSesion(self);
        espera.mostrar();
        Inspeccion.crearExpedienteSegundas(inspeccion)
          .then(function(res) {
            self.navigate('/inspecciones/view/' + res.id + '/');
            
          }).catch(function(e) {
            if (typeof e == "string") {
              e = {
                message: e
              };
            }
            app.dialog.alert(e.message);
          }).finally(function(e) {
            espera.cerrar();
          });
        });
    },
    regenerarCodigoExpediente(){
      const self = this;
      const app = self.$f7;

      var exp = self.$refs.rform.formData;
      var cod = exp.codigo;
      var fechaInsp = moment(exp.fechaInsp);

      var anyo = parseInt(fechaInsp.format('YY'));
      var provincia = exp.direccionInspeccion.provincia;

      app.dialog.confirm(
        "Se va a regenerar el código de este expediente. Provincia: " + provincia + " , Año: " + anyo + " ¿Desea continuar?",
        "Regenerar código expediente",
        function() {
  
        self.$set(self.$refs.rform.formData, "codigoErroneo", cod || "NOHAY");
        self.$set(self.$refs.rform.formData, "codigo", null);
        self.$set(self.$refs.rform.formData, "anyo", anyo);
        app.preloader.show();
        self.$refs.rform.saveItem();
        });
    },
    getUsernameLogged() {
      const self = this;
      var userStr = localStorage.getItem("user");
      var user = null;
      if (userStr) {
        user = JSON.parse(userStr);
      }
      if (user) {
        return user.username;
      } else {
        return null;
      }
    },
    navigate(url){
      var self = this;
      var app = self.$f7;
      Utils.log("navigate: " + url);
      app.views.current.router.navigate(url);
    },
    cancelarEdicion(){
      var self = this;
      self.$refs.rform.cancelEdit();
      self.readonly = true;
    },
    descargarCertificado(inspeccion, beta = false){
      const self = this;
      const app = self.$f7;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Inspeccion.descargarCertificado(inspeccion, beta)
        .catch(function(e) {
          if (typeof e == "string") {
            e = {
              message: e
            };
          }
          if(e.message) {
            app.dialog.alert(e.message);
          } else {
            var e = JSON.parse(new TextDecoder().decode(new Uint8Array(e.response)));
            if (e &&  e.error && e.error.code == 'ERROR_AUDITORIA') {
              var message = e.error.message + " :<ul>";
              e.error.errors.forEach( err => {message+= "<li>"+err+"</li>";})
              message+="</ul>";
              app.dialog.alert(message + " <br> ");
            } else {
            var msg = e.error.message;
            app.dialog.alert(msg);
            }
          } 
        }).finally(function(e) {
          espera.cerrar();
        });
    },
    descargarHojaDatos(inspeccion, beta = false){
      const self = this;
      const app = self.$f7;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Inspeccion.descargarHojaDatos(inspeccion, beta)
        .catch(function(e) {
          if (typeof e == "string") {
            e = {
              message: e
            };
          }
          if(e.message) app.dialog.alert(e.message);
          else {
            var msg = JSON.parse(new TextDecoder().decode(new Uint8Array(e.response))).error.message;
            app.dialog.alert(msg);
          } 
        }).finally(function(e) {
          espera.cerrar();
        });
    },
    versionar(inspeccion){
      const self = this;
      const app = self.$f7;
      app.dialog.confirm(
        "Se va a versionar este expediente. ¿Desea continuar?",
        "Versionar expediente",
        function() {
          const espera = preloaderDeLaSesion(self);
          espera.mostrar();
          Inspeccion.versionar(inspeccion)
            .then(function(res) {
              self.navigate('/inspecciones/view/' + res.id + '/');
              
            }).catch(function(e) {
              if (typeof e == "string") {
                e = {
                  message: e
                };
              }
              app.dialog.alert(e.message);
            }).finally(function(e) {
              espera.cerrar();
            });
        });
    },
    estadoEnviado(inspeccion){
      const self = this;
      const app = self.$f7;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Inspeccion.estadoEnviado(inspeccion)
        .then(function(res) {
          self.$refs.rform.formData = res;
          app.dialog.alert("Estado cambiado correctamente.");
        }).catch(function(e) {
          if (typeof e == "string") {
            e = {
              message: e
            };
          }
          app.dialog.alert(e.message);
        }).finally(function(e) {
          espera.cerrar();
        });
    },
    finalizar() {
      const self = this;
      const app = self.$f7;
      let expediente = self.$refs.rform.formData;
      // lanzamos las reglas de auditoría de finalización y si hay errores, no sincronizamos
      EntityUtils.cumpleReglas('finalizar', expediente, self.offline, (cumple)=>{
        if(!self.incumpleReglaCritica(expediente)) {
          if(!cumple) {app.dialog.alert("Cumple reglas bloqueantes pero no las siguientes informativas<br>" + self.extraerMensajesErrores(expediente).join("<br>"));}
          // Mostramos un díalogo para que pregunte si queremos finalizar el expediente
          app.dialog.create({
            title: "Finalizar expediente",
            text: "Se va a finalizar el expediente. ¿Desea continuar?",
            buttons: [
              {
                text: 'Cancelar',
                color: 'gray',
                onClick: function(dialog) {}
              },
              {
                text: 'Finalizar',
                color: 'blue',
                onClick: () => {
                  Inspeccion.finalizar(self.id,{}).then(function(res) {
                    self.$refs.rform.formData = res;
                    app.toast
                      .create({
                        text: "Expediente finalizado correctamente",
                        position: "center",
                        closeTimeout: 2000,
                      })
                      .open();
                  }).catch(function(e) {
                    if (e &&  e.code == 'ERROR_AUDITORIA') {
                      var message = e.message + " :<ul>";
                      e.errors.forEach( err => {message+= "<li>"+err+"</li>";})
                      message+="</ul>";
                      app.dialog.alert(message);
                      return;
                    }
                    if (typeof e == "string") {
                      e = {
                        message: e
                      };
                    }
                    app.dialog.alert(e.message);
                  }).finally(function(e) {
                    app.preloader.hide();
                  });
                }
              }
            ]
          }).open();
        } else {
          app.dialog.alert("No cumple <b>reglas</b> de auditoría<br>" + self.extraerMensajesErrores(expediente).join("<br>"),"Reglas incumplidas");
        }
      });
    },
    auditoriaManual(inspeccion, erroresAuditoria){
      const self = this;
      // Enviar el id del expediente y los textos de los incumplimientos al back.
      const app = self.$f7;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Inspeccion.auditoriaManual(inspeccion, erroresAuditoria)
        .then(function(res) {
          self.$refs.rform.formData = res;
        }).catch(function(e) {
          if (typeof e == "string") {
            e = {
              message: e
            };
          }
          app.dialog.alert(e.message);
        }).finally(function(e) {
          espera.cerrar();
        });
    },
    saveSignature(base64, filename) {
      const self = this;
      const app = self.$f7;
      // La que encendió `obtenerBase64YFirmarConAutofirma`; sin ella, una sin encender: cerrarla no hace nada.
      const espera = self.$_esperaFirma || preloaderDeLaSesion(self);
      Documento.uploadData({
        nombre: filename,
        base64: base64
      }).then(function(json) {
        json = json.list ? json.list : json;
        Inspeccion.adjuntarCertificado({itemId: self.$refs.rform.itemId, data: json, firmado: true})
          .then(function(res) {
            self.$refs.rform.formData = res;
            app.dialog.alert("Certificado firmado correctamente.");
          }).catch(function(e) {
            if (typeof e == "string") {
              e = {
                message: e
              };
            }
            app.dialog.alert(e.message);
          }).finally(function(e) {
            espera.cerrar();
          });
      }).catch(function(e) {
        espera.cerrar();
        if (typeof e == "string") {
          e = {
            message: e
          };
        }
        app.dialog.alert(e.message);
      });
		},
    autoFirmaResultCallback(signatureB64, certificateB64) {
      const self = this;
      const app = self.$f7;
			console.log("Firma OK");
      let inspeccion = self.$refs.rform.formData;
      let filename = inspeccion.codigo.replaceAll('/', '') + ' ' + (inspeccion.cliente && inspeccion.cliente.razonSocial ? inspeccion.cliente.razonSocial : "").replaceAll('/', '_') + '_CI.pdf';
			self.saveSignature(signatureB64, filename);
		},
    autoFirmaErrorCallback(errorType, errorMessage) {
      const self = this;
      const app = self.$f7;
      if (self.$_esperaFirma) self.$_esperaFirma.cerrar();
      app.dialog.alert("Ha habido un error con Autofirma: " + errorMessage);
			console.log("Type: " + errorType + "\nMessage: " + errorMessage);
		},
    abrirAutoFirma(inspeccion) {
      const self = this;
      const app = self.$f7;
      app.dialog.confirm(
        "Se va a abrir el programa autofirma para realizar la firma digital, asegúrese de tener instalada la última versión en el sistema. Puede descargarlo desde: <a class='external' href='https://firmaelectronica.gob.es/Home/Descargas.html'>AQUI</a>", 
        _ => self.obtenerBase64YFirmarConAutofirma(inspeccion));
    },
    firmarConAutofirma(b64, params) {
      const self = this;
      const app = self.$f7;
      params = params || "signaturePage=1\nlayer2FontSize=8\n" + 
                  "layer2Text=Firmado digitalmente por $$SUBJECTCN$$ el día $$SIGNDATE=dd/MM/yyyy$$ en representación de $$ORGANIZATION$$\n" + 
                  "signaturePositionOnPageLowerLeftX=10\n" + "signaturePositionOnPageLowerLeftY=10\n" + 
                  "signaturePositionOnPageUpperRightX=200\n" + "signaturePositionOnPageUpperRightY=50\n" +
                  "signatureRubricImage=" + self.imagenFirmaBase64 + "\n";
      self.autoscript.sign(
        b64,
        "SHA512withRSA",
        "AUTO",
        params,
        self.autoFirmaResultCallback,
        self.autoFirmaErrorCallback);
    },
    obtenerBase64YFirmarConAutofirma(inspeccion){
      const self = this;
      const app = self.$f7;

      // La firma va y vuelve por AutoFirma (`autoFirmaResultCallback` → `saveSignature`, o
      // `autoFirmaErrorCallback`): la espera se guarda en el componente para que la cierre quien acabe.
      if (self.$_esperaFirma) self.$_esperaFirma.cerrar();
      const espera = preloaderDeLaSesion(self);
      self.$_esperaFirma = espera;
      espera.mostrar();
      self.$loadScript("/static/autofirma/autoscript.js")
        .then(() => {
          self.autoscript = AutoScript;
          if (self.autoscript) {
            self.autoscript.cargarAppAfirma();

            Inspeccion.obtenerBase64(inspeccion.id)
              .then(({base64, array}) => {
                // Buscar la secuencia .-:-. en el PDF y calcular parámetros de firma
                self.buscarPosicionFirmaEnPDF(base64).then((params) => {
                  self.firmarConAutofirma(base64, params);
                }).catch((error) => {
                  console.log("Error al buscar posición de firma, usando valores por defecto:", error);
                  // Si hay error, usar parámetros por defecto
                  self.firmarConAutofirma(base64);
                });
              }).catch(function(e) {
                espera.cerrar();
                if (typeof e == "string") {
                  e = {
                    message: e
                  };
                }
                if(e.message) {
                  app.dialog.alert(e.message);
                } else {
                  var e = JSON.parse(new TextDecoder().decode(new Uint8Array(e.response)));
                  if (e &&  e.error && e.error.code == 'ERROR_AUDITORIA') {
                    var message = e.error.message + " :<ul>";
                    e.error.errors.forEach( err => {message+= "<li>"+err+"</li>";})
                    message+="</ul>";
                    app.dialog.alert(message + " <br> ");
                  } else {
                  var msg = e.error.message;
                  app.dialog.alert(msg);
                  }
                } 
              });

          } else {
            espera.cerrar();
          }
        })
        .catch((e) => {
          espera.cerrar();
          console.log(e);
          app.dialog.alert("Error al cargar Autofirma: " + e);
          // Failed to fetch script
        });
    },
    async buscarPosicionFirmaEnPDF(base64PDF) {
      const self = this;
      
      try {
        // Cargar pdf.js si no está cargado
        if (typeof pdfjsLib === 'undefined') {
          await self.$loadScript('https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.min.js');
          pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';
          // pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
          //   'pdfjs-dist/build/pdf.worker.min.js',
          //   import.meta.url
          // ).toString();
        }

        // Convertir base64 a array buffer
        const binaryString = atob(base64PDF);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }

        // Cargar el PDF
        const loadingTask = pdfjsLib.getDocument({ data: bytes });
        const pdf = await loadingTask.promise;

        // Buscar la secuencia .-:-. en todas las páginas
        const MARCA_FIRMA = '.-:-.';
        let posicionEncontrada = null;

        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);
          const textContent = await page.getTextContent();
          const viewport = page.getViewport({ scale: 1.0 });

          // Buscar la marca en el texto
          for (let i = 0; i < textContent.items.length; i++) {
            const item = textContent.items[i];
            if (item.str.includes(MARCA_FIRMA)) {
              // Encontrada la marca, calcular posición
              const transform = item.transform;
              const x = transform[4]; // Posición X
              const y = transform[5]; // Posición Y (invertir coordenadas PDF) viewport.height - transform[5];

              posicionEncontrada = {
                page: pageNum,
                x: Math.max(0, Math.round(x)), // Pequeño ajuste a la izquierda
                y: Math.max(0, Math.round(y -50)), // Pequeño ajuste hacia arriba
                width: 200,
                height: 50
              };

              console.log(`Marca de firma encontrada en página ${pageNum} en posición (${x}, ${y})`);
              break;
            }
          }

          if (posicionEncontrada) break;
        }

        // Generar parámetros para Autofirma
        if (posicionEncontrada) {
          const params = `signaturePage=${posicionEncontrada.page}\n` +
                        `layer2FontSize=8\n` +
                        `layer2Text=Firmado digitalmente por $$SUBJECTCN$$ el día $$SIGNDATE=dd/MM/yyyy$$ en representación de $$ORGANIZATION$$\n` +
                        `signaturePositionOnPageLowerLeftX=${posicionEncontrada.x}\n` +
                        `signaturePositionOnPageLowerLeftY=${posicionEncontrada.y}\n` +
                        `signaturePositionOnPageUpperRightX=${posicionEncontrada.x + posicionEncontrada.width}\n` +
                        `signaturePositionOnPageUpperRightY=${posicionEncontrada.y + posicionEncontrada.height}\n` +
                        `signatureRubricImage=${self.imagenFirmaBase64}\n`;
          
          console.log("Parámetros de firma personalizados:", params);
          return params;
        } else {
          console.log("Marca .-:-. no encontrada, usando posición por defecto");
          return null; // Usará los parámetros por defecto en firmarConAutofirma
        }

      } catch (error) {
        console.error("Error al procesar PDF:", error);
        throw error;
      }
    },
    firmarInspector(inspeccion){
      const self = this;
      // Enviar el id del expediente y los textos de los incumplimientos al back.
      const app = self.$f7;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Inspeccion.firmar(inspeccion)
        .then(function(res) {
          self.$refs.rform.formData = res;
      	  app.dialog.confirm("Se le va a redirigir a la web de firmadocumentos para que realice la firma del certificado.", function() {window.open(res.urlFirma, '_blank');});
        }).catch(function(e) {
          if (typeof e == "string") {
            e = {
              message: e
            };
          }
          app.dialog.alert(e.message);
        }).finally(function(e) {
          espera.cerrar();
        });
    },
    cambiaEstado: function(estado, comentarios) {
      const self = this;
      const app = self.$f7;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Inspeccion.cambiaEstado({itemId: self.$refs.rform.itemId, data: {estado: estado, comentarios: comentarios}})
        .then(function(res) {
          self.$refs.rform.formData = res;

          app.toast
            .create({
              text: "Cambio de estado realizado correctamente",
              position: "center",
              closeTimeout: 2000,
            })
            .open();

        }).catch(function(e) {
          if (typeof e == "string") {
            e = {
              message: e
            };
          }
          app.dialog.alert(e.message);
        }).finally(function(e) {
          espera.cerrar();
        });
    },
    abrirPopupCertificado: function(firmado) {
      const self = this;
      self.firmado = firmado;
      self.$refs.popupAdjuntarCertificado.open();
    },
    enviarCertificadoFirmado: function(ref) {
      ref.rformCertificadoFirmado.saveItem();
    },
    adjuntarCertificado: function(json) {
      const self = this;
      const app = self.$f7,
        firmado = self.firmado;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Inspeccion.adjuntarCertificado({itemId: self.$refs.rform.itemId, data: json.documento, firmado: firmado})
        .then(function(res) {
          self.$refs.rform.formData = res;
          self.$refs.rformCertificadoFirmado.clear();
          self.$refs.popupAdjuntarCertificado.close();
        }).catch(function(e) {
          if (typeof e == "string") {
            e = {
              message: e
            };
          }
          app.dialog.alert(e.message);
        }).finally(function(e) {
          espera.cerrar();
        });
    },
    refreshEnvio: function(json) {
      const self = this;
      const app = self.$f7;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Inspeccion.refreshEnvio({itemId: self.$refs.rform.itemId})
        .then(function(res) {
          self.$refs.rform.formData = res;
        }).catch(function(e) {
          if (typeof e == "string") {
            e = {
              message: e
            };
          }
          app.dialog.alert(e.message);
        }).finally(function(e) {
          espera.cerrar();
        });
    },
    
    datosDescargables(inspeccion){
      return inspeccion.calificacion != null;
    },
    certificadoDescargable(inspeccion){
      return inspeccion.calificacion != null;
    },
    cumpleCondicion (condicion, caracteristicas) {
      const self = this;
      const caracteristicasCoincidentes = caracteristicas.filter(c => c.nombre == condicion.nombre);
      if(!caracteristicasCoincidentes.length){
        return false;
      }
      const caracteristicaCoincidente = caracteristicasCoincidentes[0];
      var valorA = caracteristicaCoincidente.valor;
      var valorB = condicion.valor;
      if (caracteristicaCoincidente.tipo == "NUMBER") {
        valorA = parseFloat(valorA);
        valorB = parseFloat(valorB.replace(",","."));
      }
      if (condicion.operacion == "IGUAL") {
        if(caracteristicaCoincidente.options || caracteristicaCoincidente.options.length){
          return valorA && valorA.split(',').map(v => v.trim()).includes(valorB ? valorB.trim() : valorB) ;
        }
        return (valorA ? valorA.trim() : valorA) == (valorB ? valorB.trim() : valorB);
      } else if (condicion.operacion == "DIFERENTE") {
        if(caracteristicaCoincidente.options || caracteristicaCoincidente.options.length){
          return !valorA || !valorA.split(',').map(v => v.trim()).includes(valorB ? valorB.trim() : valorB) ;
        }
        return (valorA ? valorA.trim() : valorA) != (valorB ? valorB.trim() : valorB);
      } else if (condicion.operacion == "MAYOR") {
        return valorA > valorB;
      } else if (condicion.operacion == "MENOR") {
        return valorA < valorB;
      }
    },
    caracteristicaModificada(caracteristica){
      var self = this;
      self.flagCaracteristicas = true;
      if(self.caracteristicasInicializadas && !!caracteristica.valor){
        caracteristica.modificada = true;
      }
    },
    inicializarPrecargas (forzar) {
      const self = this;
      const app = self.$f7;
      var inspeccion = self.$refs.rform.formData;
      if(!forzar && (!self.flagCaracteristicas || inspeccion.idExpedienteRelacionado || self.readonly || inspeccion.codigo)){
        return;
      }
      self.flagCaracteristicas = false;
      if(!inspeccion || !inspeccion.formato){
        app.dialog.alert("No se pueden hacer precargas sin tener formato asignado previamente.");
        return;
      }
      var precargas = inspeccion?.formato?.precargas;
      var caracteristicas = self.getCaracteristicas(inspeccion.caracteristicas);
      var comprobaciones = self.getComprobaciones(inspeccion.comprobaciones);

      comprobaciones.forEach(comprobacion => {
        self.$set(comprobacion,"bloqueado",false);
      });
      if(precargas && precargas.length){
        precargas.forEach(precarga => {
          var condiciones = precarga.condiciones;
          if(!precarga.provincias.length || !precarga.provincias.includes(inspeccion.direccionInspeccion.provincia)){
            return;
          }
          var cumpleTodas = condiciones.every(condicion => {
            var cumple = self.cumpleCondicion(condicion, caracteristicas);
            return cumple;
          });
          if(cumpleTodas){
            self.aplicarPrecarga(precarga);
            self.precargaForzada = true;
          }
        });
      }
    },
    aplicarPrecarga(precarga, comprobacion, valor){
      var self = this;
      if(!comprobacion){
        var inspeccion = self.$refs.rform.formData;
        var valores = precarga.valores;
        valores.forEach(valor => {
          var comprobaciones = self.getComprobaciones(inspeccion.comprobaciones);
          comprobaciones.filter(c => c.codigo == valor.codigo).forEach(c => {
            self.aplicarPrecarga(precarga, c, valor);
          });
        });
      } else {
        if(comprobacion.hijas && comprobacion.hijas.length){
          comprobacion.hijas.forEach(hija => {
            self.aplicarPrecarga(precarga, hija, valor);
          })
        } else {
          if(!comprobacion.modificadaInspector && (!comprobacion.resultado || (comprobacion.resultado != "D" && comprobacion.resultado != "DL" && comprobacion.resultado != "DG" && comprobacion.resultado != "DMG"))){
            self.$set(comprobacion, "precarga", valor.resultado);
            // self.$set(comprobacion, "bloqueado", valor.bloqueado);
          }
        }
      }
    },
    getCaracteristicas (caracteristicas) {
      var self = this;
      if (!caracteristicas || !caracteristicas.length) {
        return [];
      }
      var result = Object.assign([], caracteristicas);
      var hijas = caracteristicas.flatMap(c => {
        return self.getCaracteristicas(c.hijas);
      });
      return result.concat(hijas);
    },
    getComprobaciones (comprobaciones) {
      var self = this;
      if (!comprobaciones || !comprobaciones.length) {
        return [];
      }
      var result = Object.assign([], comprobaciones);
      var hijas = comprobaciones.flatMap(c => {
        return self.getComprobaciones(c.hijas);
      });
      return result.concat(hijas);
    },
    retroceder(){
      const self = this;
      // if(self.target == "cordova"){
      //   self.$refs.rform.saveItem();
      // }
      self.$f7router.back();
    },
    anadirTabItem(tab) {
      var self = this;
      var app = this.$f7;
      app.dialog.prompt("Nombre", "Nuevo", function(v) {
        if (!v) {
          app.toast
            .create({
              text: "Inserte un nombre válido",
              position: "center",
              closeTimeout: 2000,
            })
            .open();
          return;
        }

        //TODO: copiar de formato.comprobaciones
        //TODO: copiar de formato.caracteristicas
        let item = { nombre: v, comprobaciones: JSON.parse(JSON.stringify(tab.formato.comprobaciones)), caracteristicas: JSON.parse(JSON.stringify(tab.formato.caracteristicas))};
        if (tab.tipo == "CUADROS") {
          item.cuadro = {
            protecciones: [],
            medidas: [],
            puestaATierra: null,
            aislamiento: null,
          };
        }
        if (tab.tipo == "TRANSFORMADORES") {
          //TODO
        }
        var tabItems = tab.items || [];
        tabItems.push(item);
        self.$set(tab, "items", tabItems);
        app.toast
          .create({
            text: "Elemento " + v + " agregado con éxito",
            position: "center",
            closeTimeout: 2000,
          })
          .open();
        self.popupTabs[tab.nombre] = tab.items.length - 1;
        self.popupOpen = false;
        self.$nextTick(() => (self.popupOpen = true));
      });
    },
    recorrerHijas (padre, nombrePadre, res, nombreItem, nombreTab) {
      var self = this;
      if (padre.defectosSeleccionados && padre.defectosSeleccionados.length) {
        for (let dsi in padre.defectosSeleccionados) {
          let ds = padre.defectosSeleccionados[dsi];
          ds.defectos = padre.defectos;
          if (nombreItem) {
            ds.nombreItem = nombreItem;
          }
          if (nombreTab) {
            ds.nombreTab = nombreTab;
          }
          res[
              nombrePadre +
              ".defectosSeleccionados." +
              dsi
          ] = ds;
        }
      }
      if (padre.hijas && padre.hijas.length) {
        for (let hi in padre.hijas) {
          var h = padre.hijas[hi];
          var name = nombrePadre + ".hijas." + hi;
          self.recorrerHijas(h, name, res, nombreItem, nombreTab);

        }
      }
    },
    getComprobacionesConDatos: function() {
      const self = this;
      console.log("getComprobacionesConDatos");
      if(self.$refs.rform && self.$refs.rform.formData) {
        // vamos a buscar todas las comprobaciones que tengan datos (observaciones o documentos)
        var comprobaciones = (!self.$refs.rform || !self.$refs.rform.formData || !self.$refs.rform.formData.comprobaciones)?[]:self.$refs.rform.formData.comprobaciones
        var comprobacionesConDatos = self.getAllComprobaciones(comprobaciones,'comprobaciones').filter(c => c.observaciones || (c.documentos && c.documentos.length));
        return comprobacionesConDatos;
      }
      return [];
    },
    // vamos a convertir el árbol de comprobaciones en un array de comprobaciones
    getAllComprobaciones: function(comprobaciones,rutaPadre) {
      const self = this;
      var res = [];
      // let orden = 0;
      comprobaciones.forEach(function(c,i) {
        c.ruta = rutaPadre + "." + i;
        res.push(c);
        if (c.hijas && c.hijas.length) {
          // si tiene hijas, las añadimos al array
          res = res.concat(self.getAllComprobaciones(c.hijas, c.ruta + ".hijas"));
        }
      });
      return res;
    },


    getAllDefectos() {
      var self = this;
      var app = this.$f7;
      if (!self.$refs.rform || !self.$refs.rform.formData.comprobaciones)
        return [];
      var formData = self.$refs.rform.formData;

      var res = {};
      for (let ci in formData.comprobaciones) {
        var c = formData.comprobaciones[ci];
        var name = "comprobaciones." + ci;
        self.recorrerHijas(c, name, res, null, null);
        
      }
      for (let ti in formData.tabs) {
        let tab = formData.tabs[ti];
        for (let ii in tab.items) {
          let nombreTab = tab.nombre;
          let item = tab.items[ii];
          let nombreItem = item.nombre;
          for (let ci in item.comprobaciones) {
            var c = item.comprobaciones[ci];
            var name = "tabs." + ti + ".items." + ii + ".comprobaciones." + ci;
            self.recorrerHijas(c, name, res, nombreItem, nombreTab);
            
          }
        }
      }
      return res;
    },
    consoleLog(e) {
      console.log(e);
    },
    downloadInforme: function(inspeccion) {
      var self = this;
      var app = self.$f7;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Inspeccion.downloadInforme(inspeccion)
        .catch(function(e) {
          console.log(e);
        })
        .then((_) => espera.cerrar());
    },
    downloadPreview: function(inspeccion) {
      var self = this;
      var app = self.$f7;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Inspeccion.downloadPreview(inspeccion)
        .catch(function(e) {
          console.log(e);
        })
        .then((_) => espera.cerrar());
    },
    eliminarDefecto: function(key) {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm("¿Está seguro?", "Eliminar defecto", function() {
        var namespaces = key.split(".");
        var context = self.$refs.rform.formData;
        for (var i = 0; i < namespaces.length; i++) {
          if (i == namespaces.length - 1) {
            console.log(context[namespaces[i]]);
            context.splice(parseInt(namespaces[i]), 1);
            //self.$forceUpdate();
          }
          context = context[namespaces[i]];
        }
        context = self.$refs.rform.formData;
        for (var i = 0; i < namespaces.length; i++) {
          if (i == namespaces.length - 2) {
            console.log(context[namespaces[i]]);
            if (!context.defectosSeleccionados || !context.defectosSeleccionados.length) {
              context.resultado = "F";
            }
            //self.$forceUpdate();
          }
          context = context[namespaces[i]];
        }
      });
    },
    eliminarObservacion(comprobacion) {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm("¿Está seguro?", "Eliminar observación y documentos de la comprobación", function() {
        comprobacion.observaciones = "";
        comprobacion.documentos = [];
        // self.$set(comprobacion, "observaciones", "");
        // self.$set(comprobacion, "documentos", []);
      });
    },
    beforeSave: function(data, resolve, reject) {
      var self = this;
      var app = this.$f7;

      if (self.offline) {
        Utils.log("beforeSave");
        // id
        if (!data.id) {
          data.id = "local-" + new Date().getTime();
        }
        data.guardadoLocal = new Date();
        // let hfRealTime = self.getTime(self.$refs.rform.formData.hfReal);
        // let hfActualTime = new Date().getTime();
        // if (!hfRealTime || hfActualTime - hfRealTime < (1000 * 60 * 60)) {
          self.finalizaTrabajo();
        // }
      }

      resolve(data);
    },
    tieneHijasGrupo: function(comprobacion) {
      return comprobacion.hijas.some(function(hija) {
        return hija.tipo == "GROUP";
      });
    },
    onSave: function (res, afterSaveFunction) {
      var self = this;
      var app = self.$f7;
      var router = self.$f7router;
      console.log("Guardado");
      Utils.log(`Guardado ${self.$refs.rform.formData.id}`);
      self.guardadosTutor++;
      if (!self.offline) {
        self.readonly = true;
      }

      const guardadoSilencioso = (res && res.guardadoSilencioso) || (self.$refs.rform && self.$refs.rform.formData && self.$refs.rform.formData.guardadoSilencioso);
      if (!guardadoSilencioso) {
        if (res && res.sesionesManuales && Utils.posterior2Dic2024(res.fechaInsp)) {
          self.$set(res, "duracion", res.tiempoReal);
        }
        self.$refs.rform.formData = res;
        app.toast
        .create({
          text: self.$t("inspecciones.inspeccion_form.inspeccion_guardada"),
          position: "center",
          closeTimeout: 1000,
          icon: '<i class="f7-icons">checkmark_alt</i>',
        })
        .open();
      } else {
        if (res) {
          res.guardadoSilencioso = false;
        }
        if (self.$refs.rform && self.$refs.rform.formData) {
          self.$refs.rform.formData.guardadoSilencioso = false;
        }
      }
      self.precargaForzada = false;
      if (afterSaveFunction) {
        afterSaveFunction();
      }
    },
    getTime: function(date) {
      if (!date) {
        return 0;
      }
      if (typeof date == "string") {
        date = new Date(date);
      }
      return date.getTime();
    },
    initFechaProxInspeccion(inspeccion, sobreescribir = false) {
      const self = this;
      if(inspeccion.formato && inspeccion.formato.periodicidadMeses && (sobreescribir || !inspeccion.proxInsp)) {
        var fechaBase = moment();
        if(inspeccion.fechaInsp){
          fechaBase = inspeccion.fechaInsp;
        }
        self.$set(inspeccion, "proxInsp", moment(fechaBase).add(inspeccion.formato.periodicidadMeses, 'M').format());
        // inspeccion.proxInsp = moment(fechaBase).add(inspeccion.formato.periodicidadMeses, 'M').format();
      }
    },
    _initCaracteristicas(element){
      const self = this;
      if(element.caracteristicas){
        return element.caracteristicas.forEach(self._initCaracteristicas);
      }
      var caracteristica = element;
      caracteristica.modificada = !!caracteristica.valor;
      if(caracteristica.hijas){
        caracteristica.hijas.forEach(self._initCaracteristicas);
      }
    },
    rellenarCaracteristicasDefecto(caracteristica){
      const self = this,
        form = self.$refs.rform,
        inspeccion = form.formData;
      if(!caracteristica || caracteristica.target){
        if(inspeccion.caracteristicas){
          inspeccion.caracteristicas.forEach(self.rellenarCaracteristicasDefecto);
        }
        return;
      }
      if(caracteristica.vinculado && form.getValue(caracteristica.vinculado)){
        var val = form.getValue(caracteristica.vinculado).toUpperCase();
        if(!caracteristica.valor && !caracteristica.modificada && !!val){
          self.$set(caracteristica,"valor", val);
        }
      }
      if(caracteristica.hijas){
        caracteristica.hijas.forEach(self.rellenarCaracteristicasDefecto);
      }
      // if((!caracteristica.hijas || !caracteristica.hijas.length)  && typeof  caracteristica.valor == "undefined") {
      //   self.$set(caracteristica,"valor", "");
      // }
    },
    preinicializarResultadosComprobaciones: function() {
      const self = this;
      const form = self.$refs.rform;
      if (!form || !form.formData) {
        return;
      }
      const roots = [];
      if (form.formData.comprobaciones && form.formData.comprobaciones.length) {
        roots.push(...form.formData.comprobaciones);
      }
      if (form.formData.tabs && form.formData.tabs.length) {
        form.formData.tabs.forEach(tab => {
          if (tab && tab.items && tab.items.length) {
            tab.items.forEach(item => {
              if (item && item.comprobaciones && item.comprobaciones.length) {
                roots.push(...item.comprobaciones);
              }
            });
          }
        });
      }
      const stack = [...roots];
      while (stack.length) {
        const c = stack.pop();
        if (!c) {
          continue;
        }
        if (!Object.prototype.hasOwnProperty.call(c, "resultado")) {
          self.$set(c, "resultado", null);
        }
        if (!Object.prototype.hasOwnProperty.call(c, "modificadaInspector")) {
          self.$set(c, "modificadaInspector", false);
        }
        if (!Object.prototype.hasOwnProperty.call(c, "defectosSeleccionados")) {
          self.$set(c, "defectosSeleccionados", []);
        }
        if (c.hijas && c.hijas.length) {
          stack.push(...c.hijas);
        }
      }
    },
    loadItem: async function(inspeccion) {
      const self = this;
      self.inspeccion = inspeccion; 
      console.log("loaditem: ",inspeccion);
      self.$set(self.$refs.rform.formData, "listErrorsForLabel", []);
      Utils.log(`Cargada inspección ${self.$refs.rform.formData.id}`);
      if (!!inspeccion) {
        self.initFechaProxInspeccion(inspeccion);
        if (self.offline && Utils.getProperty('viene.enac') && Utils.getProperty('viene.enac') == "true") {
          self.$set(self.$refs.rform.formData, "iniciado", true);
        }
        if(!inspeccion.sesiones) {inspeccion.sesiones = [];}
        if(!inspeccion.sesionesManuales) {inspeccion.sesionesManuales = [];}
        await self.iniciaSesion(inspeccion);
        self.preinicializarResultadosComprobaciones();
        // En modo offline y en ejecucion (GENERADO/PLANIFICADO) solo se puede editar si hay una
        // sesion de trabajo manual abierta. Si no la hay, forzamos solo lectura: el inspector
        // tiene que pulsar Iniciar/Reanudar (que abre la sesion) para poder meter datos.
        if (self.offline && inspeccion.estado && (inspeccion.estado.estado == 'GENERADO' || inspeccion.estado.estado == 'PLANIFICADO')) {
          var smCarga = inspeccion.sesionesManuales;
          var sesionAbiertaCarga = !!(smCarga && smCarga.length && !smCarga[smCarga.length - 1].fin);
          self.readonly = !sesionAbiertaCarga;
        }
        // revisaremos las comprobaciones para ver si alguna tiene uno de los códigos de defectosExpedienteAnteriorNegativo
        // si es así, pondremos le pondremos el campo conDefectoAnterior a true
        if (inspeccion.comprobaciones && inspeccion.defectosExpedienteAnteriorNegativo && inspeccion.defectosExpedienteAnteriorNegativo.length) {
          let comprobaciones = self.getComprobaciones(inspeccion.comprobaciones);
          comprobaciones.forEach(comprobacion => {
            // Si comprobacion.codigo está en defectosExpedienteAnteriorNegativo, ponemos conDefectoAnterior a true
            if (inspeccion.defectosExpedienteAnteriorNegativo.includes(comprobacion.codigo)) {
              self.$set(comprobacion, "conDefectoAnterior", true);
            }
          });
        }
      }
      if (inspeccion && inspeccion.sesionesManuales && Utils.posterior2Dic2024(inspeccion.fechaInsp)) {
        // ponemos en duración el tiempo real de la inspección
        self.$set(self.$refs.rform.formData, "duracion", inspeccion.tiempoReal);
        self.$set(self.$refs.rform, "dateRef", inspeccion.fechaInsp);
        self.$set(inspeccion, "duracion", inspeccion.tiempoReal);
      }
    },
    iniciaSesion: async function(inspeccion) {
      const self = this;
      // Si estamos online y readonly es falso, vamos a añadir un inicio de sesión tpi y el estado es pklanificado
      if (!self.offline && !self.readonly && inspeccion && inspeccion.estado && inspeccion.estado.estado == 'PLANIFICADO') {
          if(!inspeccion.sesionesManuales) {
            inspeccion.sesionesManuales = [];
          }
          self.$refs.rform.formData.sesionesManuales.push({
            inicio: new Date(),
            fin: null,
            tipo: "Manual - online"
          });
        }
        // Si estamos online y readonly es falso, vamos a añadir un inicio de sesión tpi y el estado es inspeccionado
        // Solo si el usuaerio no es NOID
        if (!self.offline && !self.readonly && inspeccion && inspeccion.estado && inspeccion.estado.estado == 'INSPECCIONADO' && self.$refs.rform.username != 'NOID') {
          if(!inspeccion.sesionesTPI) {
            inspeccion.sesionesTPI = [];
          }
          self.$refs.rform.formData.sesionesTPI.push({
            inicio: new Date(),
            puntoInicio: self.currentLocation,
            fin: null,
            tipo: "TPI"
          });
        }
    },
    activarAutoguardado: function () {
      Utils.log("activarAutoguardado"); 
      const self = this;
      if (self.$refs.rform && self.$refs.rform.formData) {
        self.$refs.rform.formData.guardadoSilencioso = true;
        self.$refs.rform.saveItem();
      }
      if (self.intervalReload) {
        window.clearInterval(self.intervalReload);
      }
      self.$nextTick(function () {
        self.intervalReload = window.setInterval(() => {
          if (self.$refs.rform && self.$refs.rform.formData) {
              self.$refs.rform.formData.guardadoSilencioso = true;
              self.$refs.rform.saveItem();
            }
        },45000);
      })
    },
    activarGuardadoJson: function () {
      Utils.log("activarGuardadoJson");
      const self = this;
      if (self.intervalJson) {
        window.clearInterval(self.intervalJson);
      }
      self.$nextTick(function () {
        self.intervalJson = window.setInterval(() => {
          if (self.$refs.rform && self.$refs.rform.formData && self.$refs.rform.formData.id) {
            Utils.log("Guardando snapshot de inspección");
            Utils.logInspeccion(self.$refs.rform.formData);
          }
        }, 60000);
      })
    },
    activarUpdateLocation: function () {
      Utils.log("activarUpdateLocation");
      const self = this;
      // Limpiar watcher anterior si existe
      if (self.watchLocationId !== null && navigator && navigator.geolocation) {
        navigator.geolocation.clearWatch(self.watchLocationId);
        self.watchLocationId = null;
      }
      if (self.intervalLocation) {
        window.clearInterval(self.intervalLocation);
        self.intervalLocation = null;
      }
      if (navigator && navigator.geolocation) {
        // watchPosition mantiene la posición actualizada continuamente
        self.watchLocationId = navigator.geolocation.watchPosition(
          function(pos) {
            if (pos && pos.coords) {
              self.currentLocation = {
                punto: { coordinates: [pos.coords.longitude, pos.coords.latitude], type: "Point", x: pos.coords.longitude, y: pos.coords.latitude },
                latitud: pos.coords.latitude,
                longitud: pos.coords.longitude,
                direccion: pos.coords.longitude + ", " + pos.coords.latitude,
                fecha: new Date()
              };
              // Rellenar retroactivamente puntoInicio si no se capturó al iniciar la sesión
              if (self.$refs && self.$refs.rform && self.$refs.rform.formData) {
                let formData = self.$refs.rform.formData;
                if (!formData.puntoInicio || !formData.puntoInicio.punto) {
                  self.$set(formData, "puntoInicio", JSON.parse(JSON.stringify(self.currentLocation)));
                }
                if (formData.sesionesManuales && formData.sesionesManuales.length) {
                  let ultima = formData.sesionesManuales[formData.sesionesManuales.length - 1];
                  if (ultima && !ultima.fin && (!ultima.puntoInicio || !ultima.puntoInicio.punto)) {
                    ultima.puntoInicio = JSON.parse(JSON.stringify(self.currentLocation));
                  }
                }
              }
            }
          },
          function(err) {
            console.log("Error watchPosition: ", err);
            Utils.log("Error watchPosition: " + (typeof err === 'object' && err !== null ? JSON.stringify(err) : err));
          },
          { enableHighAccuracy: true, timeout: 10000, maximumAge: 30000 }
        );
        // Mantener updateLocation con intervalo largo como fallback para nominatim (dirección textual)
        self.updateLocation();
        self.$nextTick(function () {
          self.intervalLocation = window.setInterval(self.updateLocation, 120000);
        });
      }
    },
    async ensureLocation() {
      const self = this;
      // Si watchPosition ya pobló la ubicación, no hacer nada
      if (self.currentLocation && self.currentLocation.punto) {
        return self.currentLocation;
      }
      // Intento 1: alta precisión (5s timeout)
      try {
        await self.updateLocation();
        if (self.currentLocation && self.currentLocation.punto) {
          return self.currentLocation;
        }
      } catch (e) {
        console.log("ensureLocation: fallo intento alta precisión", e);
        Utils.log("ensureLocation: fallo intento alta precisión: " + (typeof e === 'object' && e !== null ? JSON.stringify(e) : e));
      }
      // Intento 2: baja precisión como fallback (5s timeout) — en web usa IP, más rápido
      if (navigator && navigator.geolocation) {
        try {
          const pos = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: 5000, enableHighAccuracy: false });
          });
          if (pos && pos.coords) {
            self.currentLocation = {
              punto: { coordinates: [pos.coords.longitude, pos.coords.latitude], type: "Point", x: pos.coords.longitude, y: pos.coords.latitude },
              latitud: pos.coords.latitude,
              longitud: pos.coords.longitude,
              direccion: pos.coords.longitude + ", " + pos.coords.latitude,
              fecha: new Date()
            };
            return self.currentLocation;
          }
        } catch (e) {
          console.log("ensureLocation: fallo intento baja precisión", e);
          Utils.log("ensureLocation: no se pudo obtener ubicación: " + (typeof e === 'object' && e !== null ? JSON.stringify(e) : e));
        }
      }
      return self.currentLocation;
    },
    onSaveNuevoCliente: function (res) {
      Utils.log("onSaveNuevoCliente"); 
      var self = this;
      var app = self.$f7;
      self.$refs.rformCliente.clear();
      if (self.$refs.popupNuevoCliente) {
        self.$refs.popupNuevoCliente.close();
      }
      if (self.$refs.rform && self.$refs.rform.formData) {
        self.$set(self.$refs.rform.formData, 'cliente', res);
      }
      
      app.toast
        .create({
          text: self.$t("inspeccionesOffline.nuevo_cliente_guardado"),
          position: "center",
          closeTimeout: 2000,
          icon: '<i class="f7-icons">checkmark_alt</i>'
        })
        .open();
    },
    cargarPlantilla: function (plantillaId) {
      Utils.log("cargarPlantilla");
      var self = this;
      var app = self.$f7;
      app.preloader.show();
      Plantilla.get({itemId: plantillaId})
        .then(plantilla => {
          var expediente = self.$refs.rform.formData;
          // if (plantilla.formato.codigo != expediente.formato.codigo) {
          //   app.dialog.alert("El formato del expediente " + expediente.formato.codigo + " y el de la plantilla " + plantilla.formato.codigo + " no coinciden");
          //   return;
          // }
          for (var j = 0; j < plantilla.caracteristicas.length; j++) {
            self.buscarCaracteristicasPasarAPlantilla(plantilla.caracteristicas[j]);
          }
          if (plantilla.tabs && plantilla.tabs.length) {
            for (var j = 0; j < plantilla.tabs.length; j++) {
              self.buscarTabsPasarAPlantilla(plantilla.tabs[j]);
            }
          }
          expediente = self.$refs.rform.formData;
          var carga= {};
          carga.direccionInspeccion = plantilla.direccionInspeccion;
          carga.cliente = plantilla.cliente;
          carga.nombrePlantilla = plantilla.nombre;
          carga.equipos = plantilla.equipos;
          carga.observaciones = plantilla.observaciones;
          if (expediente.formato.comprobacionesEnPlantillas) {
            carga.comprobaciones = plantilla.comprobaciones;
          }
          Object.assign(expediente, carga);
          if (self.$refs.tabExpediente) {
            self.$nextTick(() => {
              self.$refs.tabExpediente.$el.click();
            });
          }
          app.preloader.hide();
          self.$refs.popupCargarPlantilla.close();
          self.popupCargarPlantillaOpened = false;
        })
        .catch(_ => {
          app.preloader.hide();
          if (typeof e == "string") e = { error: e };
          let error = e.message || e.error || e.error_description;
          app.dialog.alert(error);
          console.log(error);
        });
      // self.$forceUpdate();
    },
    buscarCaracteristicasPasarAPlantilla: function (caracteristica) {
      var self = this;
      if (caracteristica.hijas && caracteristica.hijas.length) {
        for (var j = 0; j < caracteristica.hijas.length; j++) {
          self.buscarCaracteristicasPasarAPlantilla(caracteristica.hijas[j]);
        }
      }
      else if (!caracteristica.noPasarAPlantilla) {
       self.asignarCaracteristicaExpediente(caracteristica) 
      }
    },
    asignarCaracteristicaExpediente: function (caracteristica, caracteristicasExpediente) {
      var self = this;
      var caracteristicas = caracteristicasExpediente || self.$refs.rform.formData.caracteristicas;
      for (var j = 0; j < caracteristicas.length; j++) {
        if (caracteristicas[j].hijas && caracteristicas[j].hijas.length) {
          self.asignarCaracteristicaExpediente(caracteristica, caracteristicas[j].hijas);
        }
        else if (caracteristica.nombre == caracteristicas[j].nombre && caracteristica.tipo == caracteristicas[j].tipo) {
          self.$set(caracteristicas[j], 'valor', caracteristica.valor);
          break;
        }
      } 
    },

    buscarTabsPasarAPlantilla: function (tabPlantilla) {
      var self = this;
      var tabsFormatoExp = self.$refs.rform.formData.formato.tabs;
      if (tabsFormatoExp && tabsFormatoExp.length) {
        for (var i = 0; i < tabsFormatoExp.length; i++) {
          if (tabsFormatoExp[i].formato.codigo == tabPlantilla.formato.codigo) {

            self.getTabOK(tabPlantilla, tabsFormatoExp[i]);
          }
        }
      }

    },

    getTabOK (tabPlantilla, tabFormatoExp) {
      var self = this;
      var tabsExpediente = self.$refs.rform.formData.tabs;
      tabsExpediente.forEach((tabExp,i) => {
        if (tabExp.formato.codigo == tabFormatoExp.formato.codigo) {
          self.$set(self.$refs.rform.formData.tabs[i], 'items', []);
          if (tabPlantilla.items) {
            tabPlantilla.items.forEach(itemPlantilla => {
              var item = {};
              item.nombre = itemPlantilla.nombre;
              item.observaciones = itemPlantilla.observaciones;
              item.cuadro = itemPlantilla.cuadro;
              item.transformador = itemPlantilla.transformador;
              if (tabFormatoExp.formato.comprobacionesEnPlantillas) {
                item.comprobaciones = itemPlantilla.comprobaciones;
              } else {
                // Copia propia por item: sin ella todos los items de la plantilla compartían el
                // mismo árbol y marcar una comprobación en uno la marcaba en todos hasta recargar.
                const comprobacionesFormato = tabFormatoExp.formato.comprobaciones;
                item.comprobaciones = comprobacionesFormato ? JSON.parse(JSON.stringify(comprobacionesFormato)) : comprobacionesFormato;
              }
              item.caracteristicas = itemPlantilla.caracteristicas;
              item.caracteristicas.forEach(caract => {
                self.limpiarCaracteristicasHijasTabs(caract);
              });
              tabExp.items.push(item);
            });
          }
        }
      })
    },

    limpiarCaracteristicasHijasTabs: function (caracteristicaTab) {
      var self = this;
      if (caracteristicaTab.hijas && caracteristicaTab.hijas.length) {
        for (var j = 0; j < caracteristicaTab.hijas.length; j++) {
          self.limpiarCaracteristicasHijasTabs(caracteristicaTab.hijas[j]);
        }
      }
      else  if (caracteristicaTab.noPasarAPlantilla) {
       caracteristicaTab.valor = null;
      }
    },
    
    copiarPlantilla: function (inspeccion) {
      Utils.log("copiarPlantilla");
      var self = this;
      var app = self.$f7;
      var plantilla = JSON.parse(JSON.stringify(inspeccion));
      plantilla.id = "local-" + new Date().getTime();
      delete plantilla._id;
      delete plantilla.$loki;
      delete plantilla.meta;
      delete plantilla.nombrePlantilla;
      app.dialog.prompt(
        "Nombre plantilla",
        "Guardar como plantilla",
        function(nombrePlantilla) {
          plantilla.nombre = nombrePlantilla;
          app.preloader.show();
          Plantilla.save({
            data: plantilla,
            itemId: null,
          })
          .then(function(res) {
            app.preloader.hide();
            app.dialog.alert("Plantilla creada");
          }).catch(function(e){
                  app.preloader.hide();
                if (typeof e == "string") e = { error: e };
                let error = e.message || e.error || e.error_description;
                app.dialog.alert(error);
                console.log(error);
              });
            
          });
        
    },
    cargaHistorico: function (hist) {
      const self = this;
      let inspeccion = self.$refs.rform.formData;
      Utils.log("cargaHistorico: " + hist.date);
      app.dialog.confirm("¿Está seguro de que quieres cargar la versión de " + hist.date + "?, se sobreescribirá la versión actual", "Cargar histórico", function () {
        Utils.logInspeccion(inspeccion, true);
        Utils.getHistItem(inspeccion, hist.file).then(res => {
          if (res) {
            let inspRes = JSON.parse(res);
            if (inspRes) {
              self.$refs.rform.formData = inspRes;
              if (self.$refs.popupCargarHistorico) {
                self.$refs.popupCargarHistorico.close();
              }
              app.toast
                .create({
                  text: 'Version cargada correctamente',
                  position: "center",
                  closeTimeout: 2000,
                  icon: '<i class="f7-icons">checkmark_alt</i>'
                })
                .open();
              
            }
          }
        }).catch(e => {
          console.log("Error cargando historico", e);
          alert("Error cargando histórico: " + e);
        });
      });
    },
    cargarListadoHistorico: function (inspeccion) {
      Utils.log("cargarListadoHistorico");
      const self = this;
      Utils.getHistoricoInspeccion(inspeccion).then(hist => {
        self.historico = hist;
      })
    },
    comienzaTrabajo: function(estadoSesion){
      Utils.log("comienzaTrabajo");
      const self = this;
      self.iniciado = true;
      let now = new Date();
      // Se comprueban la sesión anterior. Si no hay o la anterior se cerró hace más de 5 minutos, se abre una nueva sesión
      if(!self.$refs.rform.formData.sesiones){
        self.$set(self.$refs.rform.formData, "sesiones", []);
        // self.$set(inspeccion, "sesiones", []);
      }
      if (self.$refs.rform.formData.sesiones.length == 0){
        self.$refs.rform.formData.sesiones.push({inicio: now, fin: null});
      } else {
        let ultimaSesion = self.$refs.rform.formData.sesiones[self.$refs.rform.formData.sesiones.length-1];
        if(moment().diff(moment(ultimaSesion.fin), 'minutes') > 5) {
          self.$refs.rform.formData.sesiones.push({inicio: now, fin: null});
        }
      }
      self.readonly = false;
      self.$set(self.$refs.rform.formData, "iniciado", true);
      // if (!self.$refs.rform.formData.hc1) {
      //   self.$set(self.$refs.rform.formData, "hc1", now);
      // }
      if (!self.$refs.rform.formData.fechaInsp) {
        self.$set(self.$refs.rform.formData, "fechaInsp", now);
      }
      if (!self.$refs.rform.formData.proxInsp) {
        self.initFechaProxInspeccion(self.$refs.rform.formData, true);
      }

      // if (!self.$refs.rform.formData.hf1) {
      //   let formato = self.$refs.rform.formData.formato;
      //   if (formato && formato.tiempoInspMin && formato.tiempoInspMax) {
      //     let tiempoInsp = formato.tiempoInspMin + Math.floor(Math.random() * (formato.tiempoInspMax - formato.tiempoInspMin));
      //     let hf = new Date(now.getTime() + (tiempoInsp * 60000));
      //     self.$set(self.$refs.rform.formData, "hf1", hf);
      //   }
      // }
      self.activarAutoguardado();
      if (estadoSesion && (estadoSesion == 'iniciado' ||  estadoSesion == 'reanudado') && (!self.$refs.rform.formData.puntoInicio || !self.$refs.rform.formData.puntoInicio.direccion)) {
        self.$set(self.$refs.rform.formData, "puntoInicio", self.currentLocation);
      }
    },
    finalizaTrabajo: function(){
      const self = this;
      let ultimaSesion = self.$refs.rform.formData.sesiones[self.$refs.rform.formData.sesiones.length-1];
      if(!ultimaSesion.fin || moment().diff(moment(ultimaSesion.fin), 'minutes') < 5) {
        ultimaSesion.fin = new Date();
      }
      let tiempoRealAutomatico = self.$refs.rform.formData.sesiones.reduce((acc, sesion) => {
        let finTime = self.getTime(sesion.fin),
          inicioTime = self.getTime(sesion.inicio);
        return acc + finTime - inicioTime;
      }, 0);
      self.$set(self.$refs.rform.formData, "tiempoRealAutomatico", Math.round((tiempoRealAutomatico || 0) / 60000));
    },
    eliminarSesion: function(idSesion){
      const self = this,
        inspeccion = self.$refs.rform.formData;
      if(inspeccion.sesiones){
        inspeccion.sesiones.splice(idSesion,1);
      }
    },

    // Devuelve la lista de inspecciones (codigo + formato) con una sesión de trabajo
    // abierta cuyo formato es INCOMPATIBLE con el de la inspección actual.
    // Vacío => se puede abrir la sesión. Solo aplica en modo offline.
    // Regla: A y B son compatibles si A.formatosCompatibles incluye el código de B
    // O B.formatosCompatibles incluye el código de A (simétrica por OR). Lista vacía =>
    // incompatible con todo. Mismo formato no es excepción (solo compatible si se lista a sí mismo).
    comprobarCompatibilidadFormatos: async function () {
      const self = this;
      const inspeccion = self.$refs.rform.formData;
      const formatoActual = inspeccion && inspeccion.formato;
      // Sin formato asignado no se puede evaluar incompatibilidad -> se permite.
      if (!self.offline || !formatoActual || !formatoActual.codigo) {
        return [];
      }
      const codigoActual = formatoActual.codigo;

      // Escaneamos todas las inspecciones locales (solo las del propio inspector) y nos
      // quedamos con las que tienen su ÚLTIMA sesión manual abierta, excluyendo esta misma.
      let inspecciones = [];
      try {
        // Proyección mínima: NO cargar comprobaciones/características/documentos embebidos
        // (en el adaptador nativo de android cargarlo todo puede agotar memoria y cerrar la app).
        const res = await InspeccionOffline.getList({ projection: ['id', 'codigo', 'formato', 'sesionesManuales'] });
        inspecciones = (res && res.list) || [];
      } catch (e) {
        Utils.log("comprobarCompatibilidadFormatos: error listando inspecciones " + e);
        return [];
      }

      const abiertas = inspecciones.filter(insp => {
        if (!insp || !insp.formato || !insp.formato.codigo) return false;
        // Excluir la inspección actual (por id, o por codigo si no hay id aún)
        if (inspeccion.id && insp.id === inspeccion.id) return false;
        if (!inspeccion.id && inspeccion.codigo && insp.codigo === inspeccion.codigo) return false;
        const sm = insp.sesionesManuales;
        if (!sm || !sm.length) return false;
        const ultima = sm[sm.length - 1];
        return !!ultima && ultima.fin == null;
      });

      if (!abiertas.length) {
        return [];
      }

      // Resolvemos los formatosCompatibles SIEMPRE desde el catálogo local (FormatoOffline),
      // no desde el formato embebido en el expediente: así el expediente se mantiene ligero
      // (el formato embebido solo aporta el código) y la compatibilidad refleja la última
      // configuración sincronizada del catálogo.
      const codigos = new Set([codigoActual]);
      abiertas.forEach(insp => codigos.add(insp.formato.codigo));
      const compatiblesPorCodigo = {};
      try {
        const resF = await FormatoOffline.getList({ filter: { codigo: { $in: Array.from(codigos) } } });
        (resF.list || []).forEach(f => {
          compatiblesPorCodigo[f.codigo] = Array.isArray(f.formatosCompatibles) ? f.formatosCompatibles : [];
        });
      } catch (e) {
        Utils.log("comprobarCompatibilidadFormatos: error listando formatos " + e);
      }

      const getCompatibles = (codigo) => compatiblesPorCodigo[codigo] || [];

      const compatiblesActual = getCompatibles(codigoActual);

      const conflictos = [];
      abiertas.forEach(insp => {
        const codigoOtro = insp.formato.codigo;
        const compatiblesOtro = getCompatibles(codigoOtro);
        const compatible = compatiblesActual.indexOf(codigoOtro) !== -1
          || compatiblesOtro.indexOf(codigoActual) !== -1;
        if (!compatible) {
          conflictos.push({
            id: insp.id,
            codigo: insp.codigo || insp.id,
            formato: insp.formato.codigo || insp.formato.nombre
          });
        }
      });

      return conflictos;
    },

    // Geocodificacion inversa fiable (offline): espera la respuesta de Nominatim (con timeout)
    // para rellenar la direccion del punto. Si falla, no hay red o tarda demasiado, se mantiene
    // la direccion de coordenadas que ya trae. Nunca lanza: no debe romper el inicio/fin de sesion.
    asegurarDireccion: async function(loc) {
      const self = this;
      if (!loc || loc.latitud == null || loc.longitud == null || !self.nominatim) {
        return loc;
      }
      try {
        const nomClient = self.nominatim.default.createClient({ useragent: "SIMECAL-MOVILIDAD" });
        const timeout = new Promise(function(resolve) { setTimeout(function() { resolve(null); }, 5000); });
        const res = await Promise.race([
          nomClient.reverse({ lat: loc.latitud, lon: loc.longitud }),
          timeout
        ]);
        if (res && res.display_name) {
          loc.direccion = res.display_name;
        }
      } catch (e) {
        Utils.log("asegurarDireccion: no se pudo resolver direccion, se deja coordenadas. " + (typeof e === 'object' && e !== null ? JSON.stringify(e) : e));
      }
      return loc;
    },

    // "editar" en modo offline/ejecucion abre (o reanuda) una sesion de trabajo manual,
    // de forma que nunca se pueda editar sin sesion iniciada.
    editarOffline: function() {
      var self = this;
      var sm = self.$refs.rform.formData.sesionesManuales;
      var estadoSesion = (sm && sm.length) ? 'reanudado' : 'iniciado';
      self.comienzaTrabajoManual(estadoSesion);
    },

    comienzaTrabajoManual: async function (estadoSesion) {
      Utils.log("comienzaTrabajoManual: " + estadoSesion);
      const self = this;
      const app = self.$f7;

      // Guarda de reentrada: desde que se pulsa el boton hasta que la sesion entra en
      // sesionesManuales hay varios await (compatibilidad de formatos, GPS, Nominatim) que
      // pueden tardar segundos. Como el v-if del boton depende de sesionesManuales, durante
      // esa ventana el boton seguia visible y pulsable: un segundo toque abria una SEGUNDA
      // sesion con la misma hora de inicio, que despues nadie cerraba (al pausar/finalizar
      // solo se cierra la ultima) y que el servidor acababa cerrando con la fecha de
      // sincronizacion, inflando el tiempoReal a decenas de horas.
      if (self.iniciandoSesion) {
        Utils.log("comienzaTrabajoManual: ignorado, ya hay un inicio de sesion en curso");
        return;
      }
      self.iniciandoSesion = true;
      // El preloader se muestra ANTES del primer await para que el inspector vea que la app
      // esta trabajando y no vuelva a pulsar.
      app.preloader.show();
      try {
        await self.comienzaTrabajoManualInterno(estadoSesion);
      } finally {
        self.iniciandoSesion = false;
        app.preloader.hide();
      }
    },

    // Cuerpo real del inicio de sesion manual. Siempre se invoca a traves de
    // comienzaTrabajoManual, que es quien controla la reentrada y el preloader.
    comienzaTrabajoManualInterno: async function (estadoSesion) {
      const self = this;
      const app = self.$f7;

      // Validación de compatibilidad de formatos: no se permite abrir una sesión de
      // trabajo si ya hay otra inspección con una sesión manual abierta (fin == null)
      // cuyo formato es incompatible con el de esta inspección. Bloqueo duro.
      let conflictos = [];
      try {
        conflictos = await self.comprobarCompatibilidadFormatos();
      } catch (e) {
        // La validacion de compatibilidad NUNCA debe impedir/romper el inicio de sesion:
        // si falla (p.ej. error de datos o de la BD local), se registra y se continua.
        Utils.log("comienzaTrabajoManual: fallo en validacion de compatibilidad, se continua. " + e);
      }
      if (conflictos && conflictos.length) {
        const formatoActual = self.$refs.rform.formData.formato
          ? (self.$refs.rform.formData.formato.codigo || self.$refs.rform.formData.formato.nombre)
          : '';
        const lineas = conflictos
          .map(c => '• ' + (c.formato || ''))
          .join('<br>');
        // Un botón por cada expediente en conflicto que navega a su edición offline
        // (para que el inspector pueda pausar/finalizar esa sesión), más Cancelar.
        const botones = conflictos
          .filter(c => c.id)
          .map(c => ({
            text: self.$t('inspecciones.inspeccion_form.compatibilidad_ir'),
            onClick: function () {
              self.navigate('/inspecciones/edit-offline/' + c.id + '/');
            }
          }));
        botones.push({ text: self.$t('common.cancelar'), color: 'gray' });
        app.dialog.create({
          title: self.$t('inspecciones.inspeccion_form.compatibilidad_titulo'),
          text: self.$t('inspecciones.inspeccion_form.compatibilidad_mensaje', { formato: formatoActual }) + '<br><br>' + lineas,
          verticalButtons: true,
          buttons: botones
        }).open();
        return;
      }

      // Saneado de sesiones huerfanas: una sesion sin fin que NO es la ultima viene de un
      // expediente ya afectado por versiones anteriores de la app (doble pulsacion en
      // Iniciar). Hay que cerrarla aqui: la botonera y finalizaTrabajoManual miran solo
      // sesionesManuales[length-1], asi que si la dejamos abierta nunca se ofrece
      // Pausar/Finalizar sobre ella y su duracion sigue creciendo. La cerramos con el inicio
      // de la siguiente, nunca antes del suyo propio, igual que hace el backend al sincronizar.
      const sesiones = self.$refs.rform.formData.sesionesManuales || [];
      for (let i = 0; i < sesiones.length - 1; i++) {
        const huerfana = sesiones[i];
        if (!huerfana || huerfana.fin != null) {
          continue;
        }
        const siguiente = sesiones[i + 1];
        let finHuerfana = (siguiente && siguiente.inicio) ? siguiente.inicio : huerfana.inicio;
        if (huerfana.inicio && new Date(finHuerfana) < new Date(huerfana.inicio)) {
          finHuerfana = huerfana.inicio;
        }
        Utils.log("comienzaTrabajoManual: sesion huerfana en posicion " + i + " (inicio "
          + huerfana.inicio + "), se cierra en " + finHuerfana);
        self.$set(huerfana, "fin", finHuerfana);
      }

      // Invariante: NUNCA puede haber dos sesiones manuales abiertas a la vez en el mismo
      // expediente. Red de seguridad independiente de la guarda de reentrada: si la ultima
      // sigue abierta se reanuda esa y no se crea otra (la botonera ya ofrece Pausar y
      // Finalizar sobre ella, de modo que el expediente queda operativo).
      // Ojo: comprobarCompatibilidadFormatos() NO cubre esto, excluye el propio expediente.
      const ultimaAbierta = sesiones.length ? sesiones[sesiones.length - 1] : null;
      if (ultimaAbierta && ultimaAbierta.fin == null) {
        Utils.log("comienzaTrabajoManual: la ultima sesion sigue abierta (inicio "
          + ultimaAbierta.inicio + "), se reanuda esa y no se crea otra");
        self.readonly = false;
        self.comienzaTrabajo(estadoSesion);
        self.$set(self.$refs.rform.formData, "estadoSesion", estadoSesion);
        return;
      }

      self.readonly = false;
      await self.ensureLocation();
      if (self.offline) {
        await self.asegurarDireccion(self.currentLocation);
      }
      // if(!self.$refs.rform.formData.iniciado) {
      self.comienzaTrabajo(estadoSesion);
      // }
      let now = new Date();
      // Se comprueban la sesión anterior. Si no hay o la anterior se cerró hace más de 5 minutos, se abre una nueva sesión
      if(!self.$refs.rform.formData.sesionesManuales) {
        self.$set(self.$refs.rform.formData, "sesionesManuales", []);
      }
      
      if (!self.$refs.rform.formData.hc1 && Utils.posterior2Dic2024(self.$refs.rform.formData.fechaInsp)) {
        self.$set(self.$refs.rform.formData, "hc1", now);
      }
      
      let sesionManual = {
        inicio: now,
        fin: null,
        puntoInicio: self.currentLocation,
        puntoFin: null
      };
      // self.setLocationSesion(sesionManual, 'puntoInicio');
      self.$refs.rform.formData.sesionesManuales.push(sesionManual);
      // Consistencia: la direccion de inicio de inspeccion debe ser la misma que la del inicio de
      // la primera sesion manual (con su direccion ya resuelta). El watchPosition puede haber
      // pre-rellenado puntoInicio con solo coordenadas, asi que lo igualamos aqui explicitamente.
      const primeraSesion = self.$refs.rform.formData.sesionesManuales[0];
      if (primeraSesion && primeraSesion.puntoInicio) {
        self.$set(self.$refs.rform.formData, "puntoInicio", JSON.parse(JSON.stringify(primeraSesion.puntoInicio)));
      }
      self.$set(self.$refs.rform.formData, "estadoSesion", estadoSesion);
    },
    comprobarExpediente: function (exp) {
      const self = this;
      var errores = [];
      self.comprobarComprobaciones(exp.comprobaciones, errores);
      if (errores && errores.length) {
        return { idExp: exp.id, errores: errores };
      }
    },
    comprobarComprobaciones: function (comprobaciones, errores) {
      const self = this;
      comprobaciones.forEach(comp => {

        if (comp.hijas && comp.hijas.length) {
          self.comprobarComprobaciones(comp.hijas, errores);
        } else {
          var err = self.comprobarComprobacion(comp);
          if (err) {
            errores.push(err);
          }
        }

      })

    },
    comprobarComprobacion: function (comprobacion) {
      if (comprobacion.resultado == "D" || comprobacion.resultado == "DL" || comprobacion.resultado == "DG" || comprobacion.resultado == "DMG") {
        if (!comprobacion.defectosSeleccionados || !comprobacion.defectosSeleccionados.length) {
          return "Se debe seleccionar un defecto para la comprobación " + comprobacion.codigo + ' - ' + comprobacion.nombre;
        }
      } else if (!comprobacion.resultado) {
        return "Se debe seleccionar un resultado para la comprobación " + comprobacion.codigo + ' - ' + comprobacion.nombre;
      }
    },
    finalizaTrabajoManual: async function (estadoSesion, guardar = false) {
      Utils.log("finalizaTrabajoManual: " + estadoSesion);  
      const self = this;
      const app = self.$f7;
      // Si le damos a finalizar y no hemos seleccionado una calificación, sacaremos un mensaje y no dejaremos finalizar
      if (estadoSesion == 'finalizado') {
        // lanzamos las reglas de auditoría de finalización y si hay errores, no sincronizamos
        let expediente = self.$refs.rform.formData;
        const cumple = await new Promise((resolve) => {
          EntityUtils.cumpleReglas('sincronizar', expediente, self.offline, (cumpleReglas) => {
            resolve(cumpleReglas);
          });
        });

        // EntityUtils.cumpleReglas('sincronizar', expediente, self.offline, (cumple)=>{
        if(!self.incumpleReglaCritica(expediente)) {
          if (!cumple) {
            const resultConfirm = await new Promise((resolve) => {
              app.dialog.create({
                title: "Reglas incumplidas",
                text: "Cumple reglas bloqueantes pero no las siguientes informativas<br>" + self.extraerMensajesErrores(expediente).join("<br>"),
                buttons: [
                  {
                    text: 'Volver a la inspección',
                    color: 'gray',
                    onClick: function () {
                      resolve(false);
                    }
                  },
                  {
                    text: 'Finalizar',
                    color: 'blue',
                    onClick: () => {
                      resolve(true);
                    }
                  }
                ]
              }
              ).open();
              // app.dialog.confirm("Cumple reglas bloqueantes pero no las siguientes informativas<br>" + self.extraerMensajesErrores(expediente).join("<br>"),
              //   "Reglas de auditoría", async function () {
              //     resolve(true);
              //   }, async function () {
              //     resolve(false);
              //   });
            });
            if (!resultConfirm) {
              return false;
            }
            // app.dialog.alert("Cumple reglas bloqueantes pero no las siguientes informativas<br>" + self.extraerMensajesErrores(expediente).join("<br>"));
          }
          if (!expediente.calificacion) {
            app.dialog.alert("Debe seleccionar una calificación para finalizar la sesión, si lo que desea es pausar la inspección, seleccione pausar.");
            return false;
          }
          var error = self.comprobarExpediente(expediente);
          if (error && error.idExp) {
            var message = "Error al finalizar" + " :<ul>";
            error.errores.forEach(err => { message += "<li>" + err + "</li>"; })
            message += "</ul>";
            app.dialog.alert(message);
            return false;
          }
          if (Utils.posterior2Dic2024(expediente.fechaInsp)) {
            self.$set(expediente, "hf1", new Date());
          }
          // return true;
        } else {
          app.dialog.alert("No cumple <b>reglas</b> de auditoría<br>" + self.extraerMensajesErrores(expediente).join("<br>"),"Reglas incumplidas");
          return false;
        }
        // });
      }
      app.preloader.show();
      await self.ensureLocation();
      if (self.offline) {
        await self.asegurarDireccion(self.currentLocation);
      }
      self.readonly = true;
      let ultimaSesion = self.$refs.rform.formData.sesionesManuales[self.$refs.rform.formData.sesionesManuales.length - 1];
      if(ultimaSesion) {
        ultimaSesion.fin = new Date();
        ultimaSesion.puntoFin = self.currentLocation;
        if(estadoSesion == 'finalizado') {
          self.$set(self.$refs.rform.formData, "puntoFin", self.currentLocation);
        }
      }
      let tiempoReal = self.$refs.rform.formData.sesionesManuales.reduce((acc, sesion) => {
        let finTime = self.getTime(sesion.fin),
        inicioTime = self.getTime(sesion.inicio);
        return acc + finTime - inicioTime;
      }, 0);
      tiempoReal = Math.round((tiempoReal || 0) / 60000);
      self.$set(self.$refs.rform.formData, "tiempoReal", tiempoReal);
      self.$set(self.$refs.rform.formData, "duracion", tiempoReal);
      self.$set(self.$refs.rform.formData, "estadoSesion", estadoSesion);
      if (Utils.posterior2Dic2024(self.$refs.rform.formData.fechaInsp)) {
        const duracionH = DateUtils.getDurationInHoursAndMinutes(tiempoReal);
        self.$set(self.$refs.rform.formData, "duracionH", duracionH);
      }
      if (guardar) {
        self.guardar();
      } else {
        app.preloader.hide();
      }
      return true;
    },
    eliminarSesionManual: function(idSesion){
      const self = this,
        inspeccion = self.$refs.rform.formData;
      if(inspeccion.sesionesManuales){
        inspeccion.sesionesManuales.splice(idSesion,1);
      }
    },
    inicioSesionTPI: async function (sesionesTPI) {
      const self = this;
      await self.ensureLocation();
      sesionesTPI.push({ inicio: new Date(), puntoInicio: self.currentLocation, fin: null });
    },
    eliminarSesionTPI: function(idSesion){
      const self = this,
        inspeccion = self.$refs.rform.formData;
      if(inspeccion.sesionesTPI){
        inspeccion.sesionesTPI.splice(idSesion,1);
      }
    },
    duracionAcumuladaSesiones: function(sesiones, tipoResultado = 'string'){
      const self = this;
      if(!sesiones || !sesiones.length || !sesiones[0].inicio || !sesiones[0].fin){
        return '';
      }
      let segundosTotales = sesiones.filter(s=>s).reduce((acc, sesion) => { return acc + DateUtils.getDurationInSeconds(sesion.inicio,sesion.fin); }, 0);
      if(tipoResultado == 'number'){
        return DateUtils.getDurationString(segundosTotales);
      } else {
        return DateUtils.getDurationString(segundosTotales);
      }
    },
    arreglarDocumentos: function () {
      const self = this;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Inspeccion.arreglarDocumentos(self.id)
        .then(function (res) {
          espera.cerrar();
          self.$set(self.$refs.rform, "formData", res);
          app.dialog.alert("Documentos arreglados, refresca la página para comprobar.");
        })
        .catch(function (e) {
          espera.cerrar();
          console.log(e);
          if (typeof e == "string") {
            app.dialog.alert(e);
          } else if (e.error && e.error.message) {
            app.dialog.alert(e.error.message);
          } else if (e.message) {
            app.dialog.alert(e.message);
          } else {
            app.dialog.alert("Error al arreglar documentos");
          }
        });
    },
    switchAllComprobaciones: function (comprobaciones,opened) {
      const self = this;
      if (!comprobaciones || !comprobaciones.length) {
        EventBus.$emit('switchAccordion', opened);
        return;
      }
      const stack = [...comprobaciones];
      while (stack.length) {
        const comprobacion = stack.pop();
        self.$set(comprobacion, "accordionOpened", opened);
        if (comprobacion && comprobacion.hijas && comprobacion.hijas.length) {
          stack.push(...comprobacion.hijas);
        }
      }
      self.$nextTick(() => {
        setTimeout(() => {
          EventBus.$emit('switchAccordion', opened);
        }, 0);
      });
    },
    onDeviceReady: function () {
      var self = this;
      var app = self.$f7;
      console.log("onDeviceReady");
      document.addEventListener("resume", self.onResumeApp, false);
      self.verifyTimeZone();
    },
    verifyTimeZone: function () {
      var self = this;
      if (self.offline) {
        if(window.VerifyAutomaticDateTimeZone) {
          window.VerifyAutomaticDateTimeZone.isAutomaticChecked(function(isAutomatic){
            let auto = false;
            if (typeof isAutomatic == 'boolean' && isAutomatic) {
              auto = true;
            } else if (typeof isAutomatic == 'string' && isAutomatic.toLowerCase() == 'true') {
              auto = true;
            } else if (Array.isArray(isAutomatic) && isAutomatic.length && isAutomatic[0].toString() == 'true') {
              auto = true;
            }
            console.log("Fecha y hora automáticos", isAutomatic);
            if (auto) {
              console.log("Fecha y hora automáticos activados");
              // Marcamos que el aviso de fecha y hora automáticos se oculte (false)
              if (self.$refs.popupFechaHoraIncorrecta) {
                self.$refs.popupFechaHoraIncorrecta.close();
              }
            } else {
              console.log("Fecha y hora automáticos desactivados");
              // Marcamos que el aviso de fecha y hora automáticos se muestre (true)
              self.avisoFechaHoraAutomaticos=true;
            }
          });
        }
      }
    },
    onResumeApp: function () {
      var self = this;
      var app = self.$f7;
      console.log("onResumeApp");
      self.verifyTimeZone();
      // Reactivar watchPosition al volver del background
      self.activarUpdateLocation();
    },
  },
  mounted: function() {
    var self = this;
    var app = self.$f7;
    if (self.formato) {
      self.asignarFormatoCompleto(self.formato);
    }
    console.log("mounted", self.$refs.rform.formData);
    // Validar alineamiento entre expediente y formato local
    if (!self.formato && self.$refs.rform.formData && self.$refs.rform.formData.formato && self.$refs.rform.formData.formato.id) {
      var inspeccion = self.$refs.rform.formData;
      var dbAdapterFormato = self.offline ? FormatoOffline : Formato;
      dbAdapterFormato.get({ itemId: inspeccion.formato.id }).then(function(formatoLocal) {
        if (formatoLocal) {
          var diffs = [];
          diffs = diffs.concat(Utils.validarAlineamientoCaracteristicas(
            inspeccion.caracteristicas, formatoLocal.caracteristicas));
          diffs = diffs.concat(Utils.validarAlineamientoComprobaciones(
            inspeccion.comprobaciones, formatoLocal.comprobaciones));
          if (diffs.length > 0) {
            console.warn('Desalineamiento formato-expediente:', diffs);
            var msg = 'El formato ha cambiado desde que se asignó al expediente. Diferencias encontradas: '
              + diffs.map(function(d) { return d.tipo + ' ' + (d.nombre || d.codigo) + ': ' + d.error; }).join(', ');
            app.dialog.alert(msg);
          }
        }
      });
    }
    self.activarUpdateLocation();
    
    if (self.offline) {
      
      document.addEventListener("deviceready", self.onDeviceReady, false);

      self.activarGuardadoJson();
      // Guardamos la referencia del handler para poder desengancharlo en beforeDestroy.
      // (Antes era una función anónima => imposible de $off => se acumulaba en el EventBus
      // global reteniendo TODO el componente -> fuga de memoria por cada expediente abierto.)
      self._onCameraOpened = (val) => {
        self.cameraOpened = val;
      };
      EventBus.$on("cameraOpened", self._onCameraOpened);
      // Aviso, una vez por apertura, de que el expediente se acerca al máximo de 16 MB que admite
      // la base local (lo emite guardarDocumento en DatabaseModelOfflineMongoDB.js).
      self._avisoTamanoMostrado = false;
      self._onGuardadoLocal = (ev) => {
        const d = ev && ev.detail;
        if (!d || d.collection !== 'inspecciones' || !d.filtro || d.filtro.id !== self.id || self._avisoTamanoMostrado) {
          return;
        }
        self._avisoTamanoMostrado = true;
        app.toast.create({
          text: `Este expediente ya ocupa ${d.megas} MB en la tablet y el máximo son 16 MB. Avise a soporte antes de añadir más elementos.`,
          position: "center",
          closeButton: true,
          closeTimeout: 15000
        }).open();
      };
      window.addEventListener("simecal:guardado-local", self._onGuardadoLocal);
    }
    if (self.offline) {
      // El expediente offline (incluido el alta nueva) arranca en solo lectura: el inspector
      // debe pulsar "Iniciar" para abrir la sesion de trabajo y poder meter datos.
      self.readonly = true;
    }
    self.caracteristicasInicializadas = true;
    Utils.log(`Entrando en inspección ${self.id}`);
    if(self.target == "cordova"){
      DatabaseModelOffline.createIndex('plantillas', 'id');
      DatabaseModelOffline.createIndex('plantillas', 'nombre');
    }
  },
  beforeDestroy: function() {
    const self = this;
    
    if (self.intervalReload) {
      window.clearInterval(self.intervalReload);
    }
    if (self.intervalJson) {
      window.clearInterval(self.intervalJson);
    }
    if (self.intervalLocation) {
      window.clearInterval(self.intervalLocation);
    }
    if (self.watchLocationId !== null && navigator && navigator.geolocation) {
      navigator.geolocation.clearWatch(self.watchLocationId);
      self.watchLocationId = null;
    }
    // Desenganchar listeners globales para no retener el componente (fuga de memoria):
    // se registran en cada mounted y, sin quitarlos, cada expediente abierto queda vivo.
    document.removeEventListener("deviceready", self.onDeviceReady, false);
    document.removeEventListener("resume", self.onResumeApp, false);
    if (self._onCameraOpened) {
      EventBus.$off("cameraOpened", self._onCameraOpened);
      self._onCameraOpened = null;
    }
    if (self._onGuardadoLocal) {
      window.removeEventListener("simecal:guardado-local", self._onGuardadoLocal);
      self._onGuardadoLocal = null;
    }
    EventBus.$off('tarea-guardada', self.onTareaGuardadaDesdeEventBus);
    if(self.offline){
      Utils.logInspeccion(self.$refs.rform.formData, true);
    }

    Utils.log(`Saliendo de inspección ${self.$refs.rform.formData.id}`);
  }
};
</script>
<style scoped>
.cursor-wait {
  cursor: wait !important;
}

.loading-history,
.loading-history * {
  cursor: progress !important;
}
</style>
